var fs = Object.defineProperty;
var gs = (e, n, r) => n in e ? fs(e, n, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[n] = r;
var tn = (e, n, r) => gs(e, typeof n != "symbol" ? n + "" : n, r);
import Ie, { useState as ce, useRef as ye, useEffect as ve, useId as ps, forwardRef as vt, memo as zn, useLayoutEffect as yr, useCallback as pe, useMemo as G, useImperativeHandle as _r, Fragment as vs } from "react";
import "reflect-metadata";
import { Container as bs, injectable as js } from "inversify";
import { createPortal as hn } from "react-dom";
import { mixed as le, string as Je, number as Tt, object as ft, bool as xn } from "yup";
import { Listbox as nn, Switch as ws } from "@headlessui/react";
import { Controller as ke } from "react-hook-form";
import { Trans as Fn } from "react-i18next";
var Tn = { exports: {} }, Dt = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var rr;
function ys() {
  if (rr) return Dt;
  rr = 1;
  var e = Ie, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, s = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(i, c, d) {
    var u, x = {}, h = null, f = null;
    d !== void 0 && (h = "" + d), c.key !== void 0 && (h = "" + c.key), c.ref !== void 0 && (f = c.ref);
    for (u in c) a.call(c, u) && !o.hasOwnProperty(u) && (x[u] = c[u]);
    if (i && i.defaultProps) for (u in c = i.defaultProps, c) x[u] === void 0 && (x[u] = c[u]);
    return { $$typeof: n, type: i, key: h, ref: f, props: x, _owner: s.current };
  }
  return Dt.Fragment = r, Dt.jsx = l, Dt.jsxs = l, Dt;
}
var Bt = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var sr;
function _s() {
  return sr || (sr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Ie, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), i = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), x = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), f = Symbol.for("react.offscreen"), g = Symbol.iterator, y = "@@iterator";
    function p(m) {
      if (m === null || typeof m != "object")
        return null;
      var N = g && m[g] || m[y];
      return typeof N == "function" ? N : null;
    }
    var b = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function v(m) {
      {
        for (var N = arguments.length, L = new Array(N > 1 ? N - 1 : 0), q = 1; q < N; q++)
          L[q - 1] = arguments[q];
        j("error", m, L);
      }
    }
    function j(m, N, L) {
      {
        var q = b.ReactDebugCurrentFrame, ne = q.getStackAddendum();
        ne !== "" && (N += "%s", L = L.concat([ne]));
        var oe = L.map(function(te) {
          return String(te);
        });
        oe.unshift("Warning: " + N), Function.prototype.apply.call(console[m], console, oe);
      }
    }
    var _ = !1, I = !1, k = !1, O = !1, C = !1, R;
    R = Symbol.for("react.module.reference");
    function P(m) {
      return !!(typeof m == "string" || typeof m == "function" || m === a || m === o || C || m === s || m === d || m === u || O || m === f || _ || I || k || typeof m == "object" && m !== null && (m.$$typeof === h || m.$$typeof === x || m.$$typeof === l || m.$$typeof === i || m.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      m.$$typeof === R || m.getModuleId !== void 0));
    }
    function M(m, N, L) {
      var q = m.displayName;
      if (q)
        return q;
      var ne = N.displayName || N.name || "";
      return ne !== "" ? L + "(" + ne + ")" : L;
    }
    function D(m) {
      return m.displayName || "Context";
    }
    function B(m) {
      if (m == null)
        return null;
      if (typeof m.tag == "number" && v("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof m == "function")
        return m.displayName || m.name || null;
      if (typeof m == "string")
        return m;
      switch (m) {
        case a:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case s:
          return "StrictMode";
        case d:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof m == "object")
        switch (m.$$typeof) {
          case i:
            var N = m;
            return D(N) + ".Consumer";
          case l:
            var L = m;
            return D(L._context) + ".Provider";
          case c:
            return M(m, m.render, "ForwardRef");
          case x:
            var q = m.displayName || null;
            return q !== null ? q : B(m.type) || "Memo";
          case h: {
            var ne = m, oe = ne._payload, te = ne._init;
            try {
              return B(te(oe));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var J = Object.assign, ee = 0, T, E, Y, se, W, ae, ie;
    function Ae() {
    }
    Ae.__reactDisabledLog = !0;
    function Ue() {
      {
        if (ee === 0) {
          T = console.log, E = console.info, Y = console.warn, se = console.error, W = console.group, ae = console.groupCollapsed, ie = console.groupEnd;
          var m = {
            configurable: !0,
            enumerable: !0,
            value: Ae,
            writable: !0
          };
          Object.defineProperties(console, {
            info: m,
            log: m,
            warn: m,
            error: m,
            group: m,
            groupCollapsed: m,
            groupEnd: m
          });
        }
        ee++;
      }
    }
    function Qe() {
      {
        if (ee--, ee === 0) {
          var m = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: J({}, m, {
              value: T
            }),
            info: J({}, m, {
              value: E
            }),
            warn: J({}, m, {
              value: Y
            }),
            error: J({}, m, {
              value: se
            }),
            group: J({}, m, {
              value: W
            }),
            groupCollapsed: J({}, m, {
              value: ae
            }),
            groupEnd: J({}, m, {
              value: ie
            })
          });
        }
        ee < 0 && v("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var at = b.ReactCurrentDispatcher, ot;
    function qe(m, N, L) {
      {
        if (ot === void 0)
          try {
            throw Error();
          } catch (ne) {
            var q = ne.stack.trim().match(/\n( *(at )?)/);
            ot = q && q[1] || "";
          }
        return `
` + ot + m;
      }
    }
    var it = !1, et;
    {
      var St = typeof WeakMap == "function" ? WeakMap : Map;
      et = new St();
    }
    function jt(m, N) {
      if (!m || it)
        return "";
      {
        var L = et.get(m);
        if (L !== void 0)
          return L;
      }
      var q;
      it = !0;
      var ne = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var oe;
      oe = at.current, at.current = null, Ue();
      try {
        if (N) {
          var te = function() {
            throw Error();
          };
          if (Object.defineProperty(te.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(te, []);
            } catch (nt) {
              q = nt;
            }
            Reflect.construct(m, [], te);
          } else {
            try {
              te.call();
            } catch (nt) {
              q = nt;
            }
            m.call(te.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (nt) {
            q = nt;
          }
          m();
        }
      } catch (nt) {
        if (nt && q && typeof nt.stack == "string") {
          for (var Q = nt.stack.split(`
`), Me = q.stack.split(`
`), he = Q.length - 1, xe = Me.length - 1; he >= 1 && xe >= 0 && Q[he] !== Me[xe]; )
            xe--;
          for (; he >= 1 && xe >= 0; he--, xe--)
            if (Q[he] !== Me[xe]) {
              if (he !== 1 || xe !== 1)
                do
                  if (he--, xe--, xe < 0 || Q[he] !== Me[xe]) {
                    var He = `
` + Q[he].replace(" at new ", " at ");
                    return m.displayName && He.includes("<anonymous>") && (He = He.replace("<anonymous>", m.displayName)), typeof m == "function" && et.set(m, He), He;
                  }
                while (he >= 1 && xe >= 0);
              break;
            }
        }
      } finally {
        it = !1, at.current = oe, Qe(), Error.prepareStackTrace = ne;
      }
      var Et = m ? m.displayName || m.name : "", nr = Et ? qe(Et) : "";
      return typeof m == "function" && et.set(m, nr), nr;
    }
    function It(m, N, L) {
      return jt(m, !1);
    }
    function kt(m) {
      var N = m.prototype;
      return !!(N && N.isReactComponent);
    }
    function Ye(m, N, L) {
      if (m == null)
        return "";
      if (typeof m == "function")
        return jt(m, kt(m));
      if (typeof m == "string")
        return qe(m);
      switch (m) {
        case d:
          return qe("Suspense");
        case u:
          return qe("SuspenseList");
      }
      if (typeof m == "object")
        switch (m.$$typeof) {
          case c:
            return It(m.render);
          case x:
            return Ye(m.type, N, L);
          case h: {
            var q = m, ne = q._payload, oe = q._init;
            try {
              return Ye(oe(ne), N, L);
            } catch {
            }
          }
        }
      return "";
    }
    var tt = Object.prototype.hasOwnProperty, $ = {}, z = b.ReactDebugCurrentFrame;
    function H(m) {
      if (m) {
        var N = m._owner, L = Ye(m.type, m._source, N ? N.type : null);
        z.setExtraStackFrame(L);
      } else
        z.setExtraStackFrame(null);
    }
    function re(m, N, L, q, ne) {
      {
        var oe = Function.call.bind(tt);
        for (var te in m)
          if (oe(m, te)) {
            var Q = void 0;
            try {
              if (typeof m[te] != "function") {
                var Me = Error((q || "React class") + ": " + L + " type `" + te + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof m[te] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Me.name = "Invariant Violation", Me;
              }
              Q = m[te](N, te, q, L, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (he) {
              Q = he;
            }
            Q && !(Q instanceof Error) && (H(ne), v("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", q || "React class", L, te, typeof Q), H(null)), Q instanceof Error && !(Q.message in $) && ($[Q.message] = !0, H(ne), v("Failed %s type: %s", L, Q.message), H(null));
          }
      }
    }
    var ge = Array.isArray;
    function K(m) {
      return ge(m);
    }
    function U(m) {
      {
        var N = typeof Symbol == "function" && Symbol.toStringTag, L = N && m[Symbol.toStringTag] || m.constructor.name || "Object";
        return L;
      }
    }
    function Ce(m) {
      try {
        return ze(m), !1;
      } catch {
        return !0;
      }
    }
    function ze(m) {
      return "" + m;
    }
    function Te(m) {
      if (Ce(m))
        return v("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", U(m)), ze(m);
    }
    var Ze = b.ReactCurrentOwner, Ft = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, lt, Vt, jn;
    jn = {};
    function es(m) {
      if (tt.call(m, "ref")) {
        var N = Object.getOwnPropertyDescriptor(m, "ref").get;
        if (N && N.isReactWarning)
          return !1;
      }
      return m.ref !== void 0;
    }
    function ts(m) {
      if (tt.call(m, "key")) {
        var N = Object.getOwnPropertyDescriptor(m, "key").get;
        if (N && N.isReactWarning)
          return !1;
      }
      return m.key !== void 0;
    }
    function ns(m, N) {
      if (typeof m.ref == "string" && Ze.current && N && Ze.current.stateNode !== N) {
        var L = B(Ze.current.type);
        jn[L] || (v('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', B(Ze.current.type), m.ref), jn[L] = !0);
      }
    }
    function rs(m, N) {
      {
        var L = function() {
          lt || (lt = !0, v("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", N));
        };
        L.isReactWarning = !0, Object.defineProperty(m, "key", {
          get: L,
          configurable: !0
        });
      }
    }
    function ss(m, N) {
      {
        var L = function() {
          Vt || (Vt = !0, v("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", N));
        };
        L.isReactWarning = !0, Object.defineProperty(m, "ref", {
          get: L,
          configurable: !0
        });
      }
    }
    var as = function(m, N, L, q, ne, oe, te) {
      var Q = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: m,
        key: N,
        ref: L,
        props: te,
        // Record the component responsible for creating this element.
        _owner: oe
      };
      return Q._store = {}, Object.defineProperty(Q._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Q, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: q
      }), Object.defineProperty(Q, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ne
      }), Object.freeze && (Object.freeze(Q.props), Object.freeze(Q)), Q;
    };
    function os(m, N, L, q, ne) {
      {
        var oe, te = {}, Q = null, Me = null;
        L !== void 0 && (Te(L), Q = "" + L), ts(N) && (Te(N.key), Q = "" + N.key), es(N) && (Me = N.ref, ns(N, ne));
        for (oe in N)
          tt.call(N, oe) && !Ft.hasOwnProperty(oe) && (te[oe] = N[oe]);
        if (m && m.defaultProps) {
          var he = m.defaultProps;
          for (oe in he)
            te[oe] === void 0 && (te[oe] = he[oe]);
        }
        if (Q || Me) {
          var xe = typeof m == "function" ? m.displayName || m.name || "Unknown" : m;
          Q && rs(te, xe), Me && ss(te, xe);
        }
        return as(m, Q, Me, ne, q, Ze.current, te);
      }
    }
    var wn = b.ReactCurrentOwner, Kn = b.ReactDebugCurrentFrame;
    function Lt(m) {
      if (m) {
        var N = m._owner, L = Ye(m.type, m._source, N ? N.type : null);
        Kn.setExtraStackFrame(L);
      } else
        Kn.setExtraStackFrame(null);
    }
    var yn;
    yn = !1;
    function _n(m) {
      return typeof m == "object" && m !== null && m.$$typeof === n;
    }
    function Jn() {
      {
        if (wn.current) {
          var m = B(wn.current.type);
          if (m)
            return `

Check the render method of \`` + m + "`.";
        }
        return "";
      }
    }
    function is(m) {
      return "";
    }
    var Xn = {};
    function ls(m) {
      {
        var N = Jn();
        if (!N) {
          var L = typeof m == "string" ? m : m.displayName || m.name;
          L && (N = `

Check the top-level render call using <` + L + ">.");
        }
        return N;
      }
    }
    function Qn(m, N) {
      {
        if (!m._store || m._store.validated || m.key != null)
          return;
        m._store.validated = !0;
        var L = ls(N);
        if (Xn[L])
          return;
        Xn[L] = !0;
        var q = "";
        m && m._owner && m._owner !== wn.current && (q = " It was passed a child from " + B(m._owner.type) + "."), Lt(m), v('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', L, q), Lt(null);
      }
    }
    function er(m, N) {
      {
        if (typeof m != "object")
          return;
        if (K(m))
          for (var L = 0; L < m.length; L++) {
            var q = m[L];
            _n(q) && Qn(q, N);
          }
        else if (_n(m))
          m._store && (m._store.validated = !0);
        else if (m) {
          var ne = p(m);
          if (typeof ne == "function" && ne !== m.entries)
            for (var oe = ne.call(m), te; !(te = oe.next()).done; )
              _n(te.value) && Qn(te.value, N);
        }
      }
    }
    function cs(m) {
      {
        var N = m.type;
        if (N == null || typeof N == "string")
          return;
        var L;
        if (typeof N == "function")
          L = N.propTypes;
        else if (typeof N == "object" && (N.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        N.$$typeof === x))
          L = N.propTypes;
        else
          return;
        if (L) {
          var q = B(N);
          re(L, m.props, "prop", q, m);
        } else if (N.PropTypes !== void 0 && !yn) {
          yn = !0;
          var ne = B(N);
          v("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ne || "Unknown");
        }
        typeof N.getDefaultProps == "function" && !N.getDefaultProps.isReactClassApproved && v("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ds(m) {
      {
        for (var N = Object.keys(m.props), L = 0; L < N.length; L++) {
          var q = N[L];
          if (q !== "children" && q !== "key") {
            Lt(m), v("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", q), Lt(null);
            break;
          }
        }
        m.ref !== null && (Lt(m), v("Invalid attribute `ref` supplied to `React.Fragment`."), Lt(null));
      }
    }
    function tr(m, N, L, q, ne, oe) {
      {
        var te = P(m);
        if (!te) {
          var Q = "";
          (m === void 0 || typeof m == "object" && m !== null && Object.keys(m).length === 0) && (Q += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Me = is();
          Me ? Q += Me : Q += Jn();
          var he;
          m === null ? he = "null" : K(m) ? he = "array" : m !== void 0 && m.$$typeof === n ? (he = "<" + (B(m.type) || "Unknown") + " />", Q = " Did you accidentally export a JSX literal instead of a component?") : he = typeof m, v("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", he, Q);
        }
        var xe = os(m, N, L, ne, oe);
        if (xe == null)
          return xe;
        if (te) {
          var He = N.children;
          if (He !== void 0)
            if (q)
              if (K(He)) {
                for (var Et = 0; Et < He.length; Et++)
                  er(He[Et], m);
                Object.freeze && Object.freeze(He);
              } else
                v("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              er(He, m);
        }
        return m === a ? ds(xe) : cs(xe), xe;
      }
    }
    function us(m, N, L) {
      return tr(m, N, L, !0);
    }
    function ms(m, N, L) {
      return tr(m, N, L, !1);
    }
    var hs = ms, xs = us;
    Bt.Fragment = a, Bt.jsx = hs, Bt.jsxs = xs;
  }()), Bt;
}
process.env.NODE_ENV === "production" ? Tn.exports = ys() : Tn.exports = _s();
var t = Tn.exports;
const Cs = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 -960 960 960",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsx("path", { d: "m644-428-58-58q9-47-27-88t-93-32l-58-58q17-8 34.5-12t37.5-4q75 0 127.5 52.5T660-500q0 20-4 37.5T644-428Zm128 126-58-56q38-29 67.5-63.5T832-500q-50-101-143.5-160.5T480-720q-29 0-57 4t-55 12l-62-62q41-17 84-25.5t90-8.5q151 0 269 83.5T920-500q-23 59-60.5 109.5T772-302Zm20 246L624-222q-35 11-70.5 16.5T480-200q-151 0-269-83.5T40-500q21-53 53-98.5t73-81.5L56-792l56-56 736 736-56 56ZM222-624q-29 26-53 57t-41 67q50 101 143.5 160.5T480-280q20 0 39-2.5t39-5.5l-36-38q-11 3-21 4.5t-21 1.5q-75 0-127.5-52.5T300-500q0-11 1.5-21t4.5-21l-84-82Zm319 93Zm-151 75Z" })
  }
), Ns = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 -960 960 960",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsx("path", { d: "M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z" })
  }
), Ss = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsxs(
  "svg",
  {
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: [
      /* @__PURE__ */ t.jsx("defs", { children: /* @__PURE__ */ t.jsx(
        "mask",
        {
          id: "b",
          x: "0",
          y: "0",
          width: "60",
          height: "60",
          maskUnits: "userSpaceOnUse",
          children: /* @__PURE__ */ t.jsx("g", { id: "c", children: /* @__PURE__ */ t.jsx("rect", { width: "60", height: "60", fill: "#d9d9d9" }) })
        }
      ) }),
      /* @__PURE__ */ t.jsx("g", { mask: "url(#b)", children: /* @__PURE__ */ t.jsx(
        "path",
        {
          d: "M32.5,35h5v-7.5h7.5v-5h-7.5v-7.5h-5v7.5h-7.5v5h7.5v7.5ZM20,45c-1.38,0-2.55-.49-3.53-1.47-.98-.98-1.47-2.16-1.47-3.53V10c0-1.38.49-2.55,1.47-3.53.98-.98,2.16-1.47,3.53-1.47h30c1.38,0,2.55.49,3.53,1.47.98.98,1.47,2.16,1.47,3.53v30c0,1.38-.49,2.55-1.47,3.53-.98.98-2.16,1.47-3.53,1.47h-30ZM20,40h30V10h-30v30ZM10,55c-1.38,0-2.55-.49-3.53-1.47-.98-.98-1.47-2.16-1.47-3.53V15h5v35h35v5H10Z",
          fill: "#1c1b1f"
        }
      ) })
    ]
  }
), Is = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 29 29",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsxs("g", { fill: "currentcolor", fillRule: "nonzero", children: [
      /* @__PURE__ */ t.jsx("path", { d: "M9.153 11.758a2.565 2.565 0 1 0 .004-5.13 2.565 2.565 0 0 0-.004 5.13Zm-.689-2.564a.69.69 0 1 1 1.38-.002.69.69 0 0 1-1.38.002ZM8.464 14.073a2.564 2.564 0 1 0-5.128.002 2.564 2.564 0 0 0 5.128-.002Zm-1.874 0a.69.69 0 1 1-1.38.002.69.69 0 0 1 1.38-.002ZM7.527 18.017a2.564 2.564 0 1 0-.002 5.128 2.564 2.564 0 0 0 .002-5.128Zm0 3.253a.69.69 0 1 1-.002-1.38.69.69 0 0 1 .002 1.38Z" }),
      /* @__PURE__ */ t.jsx("path", { d: "M26.911 4.075c.842-1.236 1.693-2.771.8-3.67a1.715 1.715 0 0 0-1.889-.216 8.968 8.968 0 0 0-1.815.943 28.839 28.839 0 0 0-4.929 4.183 12.351 12.351 0 0 0-18.77 12.76 12.314 12.314 0 0 0 9.39 9.666c.891.196 1.8.297 2.713.3.614 0 1.227-.047 1.834-.138a3.593 3.593 0 0 0 2.879-2.452 3.709 3.709 0 0 0-.895-3.8 1.5 1.5 0 0 1 1.061-2.573c.399-.002.78.157 1.061.44a3.7 3.7 0 0 0 3.8.896 3.589 3.589 0 0 0 2.449-2.88 12.3 12.3 0 0 0-1.886-8.633 33.073 33.073 0 0 0 4.197-4.826Zm-13 16.506a3.359 3.359 0 0 0 .99 2.388c.492.496.662 1.228.439 1.89a1.7 1.7 0 0 1-1.376 1.185 10.667 10.667 0 0 1-3.874-.135 10.453 10.453 0 0 1 2.293-20.65c.689.002 1.376.066 2.053.194a10.29 10.29 0 0 1 3.367 1.279 14.379 14.379 0 0 0-2.293 3.413 3.374 3.374 0 0 0-4.06 2.313 2.277 2.277 0 0 1-1.86 1.53.937.937 0 0 0-.512 1.59l.229.229a5.49 5.49 0 0 0 7.767 0 3.363 3.363 0 0 0 .85-3.35 15.519 15.519 0 0 0 3.371-2.287 10.449 10.449 0 0 1 1.444 7.084 1.7 1.7 0 0 1-1.181 1.378c-.66.221-1.39.05-1.884-.441a3.38 3.38 0 0 0-5.767 2.389h.004Zm1.843-6.1a3.627 3.627 0 0 1-4.15.694 3.987 3.987 0 0 0 1.647-2.185 1.503 1.503 0 1 1 2.504 1.491h-.001Zm1.578-3.812a9.5 9.5 0 0 1 .708-1.174 27.8 27.8 0 0 1 4.181-4.62l.911.912a29.114 29.114 0 0 1-4.626 4.175c-.374.264-.767.5-1.176.707h.002Zm8.538-8.46a16.961 16.961 0 0 1-1.512 2.153l-.69-.691a15.68 15.68 0 0 1 2.2-1.461h.002Z" })
    ] })
  }
), ks = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 27 15",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsx(
      "path",
      {
        d: "M1,8.98771202 L24.586,8.98771202 L17.293,1.69471202 C16.9140278,1.30233313 16.9194476,0.678627244 17.3051814,0.292893445 C17.6909152,-0.0928403531 18.3146211,-0.0982601888 18.707,0.280712021 L27.707,9.28071202 C28.0973819,9.67121187 28.0973819,10.3042122 27.707,10.694712 L18.707,19.694712 C18.3146211,20.0736842 17.6909152,20.0682644 17.3051814,19.6825306 C16.9194476,19.2967968 16.9140278,18.6730909 17.293,18.280712 L24.586,10.987712 L1,10.987712 C0.44771525,10.987712 0,10.5399968 0,9.98771202 C0,9.43542727 0.44771525,8.98771202 1,8.98771202 Z",
        fill: "currentcolor",
        fillRule: "nonzero"
      }
    )
  }
), Ls = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsxs("g", { fill: "currentcolor", fillRule: "nonzero", children: [
      /* @__PURE__ */ t.jsx("path", { d: "M14 0C6.268 0 0 6.268 0 14s6.268 14 14 14 14-6.268 14-14S21.732 0 14 0Zm0 26C7.373 26 2 20.627 2 14S7.373 2 14 2c6.628 0 12 5.373 12 12-.007 6.624-5.375 11.993-12 12Z" }),
      /* @__PURE__ */ t.jsx("path", { d: "m11.691 18.244-3.766-3.847a1 1 0 0 1 1.43-1.399l3.05 3.116 6.24-6.374a1 1 0 0 1 1.43 1.399l-6.955 7.1a1 1 0 0 1-1.429.005Z" })
    ] })
  }
), Es = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 29 21",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsx(
      "path",
      {
        d: "M27.965.882a1.464 1.464 0 0 0-2.048 0L9.56 17.015l-6.7-6.609a1.464 1.464 0 0 0-2.048 0 1.416 1.416 0 0 0 0 2.02l7.724 7.62c.568.558 1.48.558 2.048 0l17.38-17.144a1.416 1.416 0 0 0 0-2.02Z",
        fill: "currentcolor",
        fillRule: "nonzero"
      }
    )
  }
), $s = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 27 27",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsx(
      "path",
      {
        d: "M24.955 1.205 13.979 12.178l-11-10.993a1.188 1.188 0 0 0-1.68 1.68l10.998 10.992L1.315 24.849a1.188 1.188 0 0 0 1.68 1.68l10.984-10.99 10.987 10.985a1.188 1.188 0 0 0 1.68-1.68L15.66 13.857 26.635 2.885a1.188 1.188 0 0 0-1.68-1.68Z",
        fill: "currentcolor",
        fillRule: "nonzero"
      }
    )
  }
), Ms = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 28 29",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsxs("g", { fill: "currentcolor", fillRule: "nonzero", children: [
      /* @__PURE__ */ t.jsx("path", { d: "M14.012 11.426c-.672 0-1.22.542-1.224 1.215l-.078 9.367a1.224 1.224 0 0 0 1.225 1.234h.155a1.224 1.224 0 0 0 1.224-1.234l-.077-9.367a1.225 1.225 0 0 0-1.225-1.215ZM13.994 5.628a1.768 1.768 0 0 0-1.794 1.72 1.805 1.805 0 0 0 3.6.037 1.8 1.8 0 0 0-1.806-1.757Z" }),
      /* @__PURE__ */ t.jsx("path", { d: "M14 .435c-7.732 0-14 6.268-14 14s6.268 14 14 14 14-6.268 14-14a14 14 0 0 0-14-14Zm0 26c-6.627 0-12-5.373-12-12 0-6.628 5.373-12 12-12s12 5.372 12 12c-.007 6.624-5.376 11.992-12 12Z" })
    ] })
  }
), Os = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 27 15",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsx(
      "path",
      {
        d: "M13.094 14.836a1 1 0 0 1-.707-.293L.42 2.572a1 1 0 0 1 1.414-1.414l11.259 11.26L24.41 1.172a1 1 0 0 1 1.41 1.418L13.794 14.536a1 1 0 0 1-.7.3Z",
        fill: "currentcolor",
        fillRule: "nonzero"
      }
    )
  }
), Ps = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 26 29",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsxs("g", { fill: "currentcolor", fillRule: "nonzero", children: [
      /* @__PURE__ */ t.jsx("path", { d: "M22.264 26.547H3.604a1.17 1.17 0 0 1-1.17-1.17v-11.67h14v-2.33h-10.5v-1.17a7 7 0 0 1 14 0v3.5h3.5v11.67a1.17 1.17 0 0 1-1.17 1.17Zm2.34-15.17h-2.34v-1.17a9.33 9.33 0 0 0-18.66 0v1.17h-2.34a1.16 1.16 0 0 0-1.16 1.17v12.83a3.5 3.5 0 0 0 3.5 3.5h18.66a3.5 3.5 0 0 0 3.5-3.5v-12.83a1.16 1.16 0 0 0-1.16-1.17Z" }),
      /* @__PURE__ */ t.jsx("path", { d: "M11.764 23.047h2.34v-5.84h-2.34z" })
    ] })
  }
), Ts = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 15 27",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsx(
      "path",
      {
        d: "M14.05 13.896c.001.266-.104.52-.292.707L1.792 26.57a1 1 0 0 1-1.414-1.413l11.26-11.262L.393 2.58A1 1 0 0 1 1.81 1.17l11.948 12.022a1 1 0 0 1 .293.705Z",
        fill: "currentcolor",
        fillRule: "nonzero"
      }
    )
  }
), Rs = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 25 28",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsx("g", { fill: "currentcolor", fillRule: "nonzero", children: /* @__PURE__ */ t.jsx("path", { d: "M12.306 12.877a6 6 0 1 1 0-12 6 6 0 0 1 0 12ZM22.206 27.877H2.411a2 2 0 0 1-1.99-2.2l.62-6.2a3.987 3.987 0 0 1 3.98-3.6h14.57a3.987 3.987 0 0 1 3.98 3.6l.62 6.2a2 2 0 0 1-1.985 2.2Z" }) })
  }
), As = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 28 29",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsxs("g", { fill: "currentcolor", fillRule: "nonzero", children: [
      /* @__PURE__ */ t.jsx("path", { d: "M14 2.435c6.627 0 12 5.372 12 12 0 6.627-5.373 12-12 12s-12-5.373-12-12c.007-6.625 5.376-11.993 12-12m0-2c-7.732 0-14 6.268-14 14s6.268 14 14 14 14-6.268 14-14a14 14 0 0 0-14-14Z" }),
      /* @__PURE__ */ t.jsx("path", { d: "M12.2 21.52a1.805 1.805 0 0 1 3.6-.035 1.8 1.8 0 0 1-1.807 1.757A1.768 1.768 0 0 1 12.2 21.52Zm1.735-15.892h.155a1.224 1.224 0 0 1 1.224 1.234l-.077 9.367a1.225 1.225 0 0 1-2.449 0l-.078-9.367a1.224 1.224 0 0 1 1.225-1.234Z" })
    ] })
  }
), zs = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 28 29",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsx("g", { fill: "currentcolor", fillRule: "nonzero", children: /* @__PURE__ */ t.jsx(
      "g",
      {
        id: "DO-03-Personendaten",
        transform: "translate(-164.000000, -1417.000000)",
        fill: "currentcolor",
        fillRule: "nonzero",
        children: /* @__PURE__ */ t.jsx("g", { id: "links/pdf-link", transform: "translate(164.000000, 1417.870000)", children: /* @__PURE__ */ t.jsxs("g", { id: "ic_plus_circle_m", transform: "translate(-0.000000, 0.000000)", children: [
          /* @__PURE__ */ t.jsx(
            "path",
            {
              d: "M12,0 C5.372583,0 0,5.372583 0,12 C0,18.627417 5.372583,24 12,24 C18.627417,24 24,18.627417 24,12 C24,8.81740212 22.7357179,5.76515517 20.4852814,3.51471863 C18.2348448,1.26428208 15.1825979,0 12,0 L12,0 Z M12,22.2857143 C6.31935686,22.2857143 1.71428571,17.6806431 1.71428571,12 C1.71428571,6.31935686 6.31935686,1.71428571 12,1.71428571 C17.6806431,1.71428571 22.2857143,6.31935686 22.2857143,12 C22.279573,17.6780974 17.6780974,22.279573 12,22.2857143 Z",
              id: "Shape"
            }
          ),
          /* @__PURE__ */ t.jsx(
            "path",
            {
              d: "M18.8571429,11.1428571 L12.8571429,11.1428571 L12.8571429,5.14285714 C12.8571429,4.66947021 12.4733869,4.28571429 12,4.28571429 L12,4.28571429 C11.5266131,4.28571429 11.1428571,4.66947021 11.1428571,5.14285714 L11.1428571,11.1428571 L5.14285714,11.1428571 C4.66947021,11.1428571 4.28571429,11.5266131 4.28571429,12 L4.28571429,12 C4.28571429,12.4733869 4.66947021,12.8571429 5.14285714,12.8571429 L11.1428571,12.8571429 L11.1428571,18.8571429 C11.1428571,19.3305298 11.5266131,19.7142857 12,19.7142857 L12,19.7142857 C12.4733869,19.7142857 12.8571429,19.3305298 12.8571429,18.8571429 L12.8571429,12.8571429 L18.8571429,12.8571429 C19.3305298,12.8571429 19.7142857,12.4733869 19.7142857,12 L19.7142857,12 C19.7142857,11.5266131 19.3305298,11.1428571 18.8571429,11.1428571 Z",
              id: "Path"
            }
          )
        ] }) })
      }
    ) })
  }
), Fs = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsx("g", { fill: "none", fillRule: "evenodd", children: /* @__PURE__ */ t.jsx(
      "path",
      {
        d: "M47.962.143c-1.691 0-3.336.353-4.827 1-1.499.632-2.704 1.398-3.83 2.496-1.105 1.106-2.017 2.518-2.663 3.996-.633 1.492-1 2.97-1 4.661 0 1.692.367 3.337 1 4.828.646 1.472 1.558 2.73 2.663 3.83 1.126 1.111 2.331 2.017 3.83 2.663 1.491.633 3.136.999 4.827.999 1.705 0 3.337-.367 4.828-.999 1.479-.646 2.73-1.552 3.83-2.664 1.105-1.098 2.017-2.357 2.663-3.829.633-1.491 1-3.136 1-4.828 0-1.691-.367-3.17-1-4.661-.646-1.478-1.558-2.89-2.664-3.996-1.098-1.098-2.35-1.864-3.829-2.497a12.116 12.116 0 00-4.828-.999zM23.323 32.108c-1.691 0-3.17.186-4.661.832-1.492.64-2.884 1.558-3.996 2.664-1.105 1.105-1.864 2.504-2.497 3.995-.646 1.479-.999 2.97-.999 4.662v26.97h56.437v7.491H11.17v4.828c0 1.698.36 3.337 1 4.828.632 1.492 1.398 2.717 2.496 3.83a13.075 13.075 0 003.996 2.663c1.491.646 2.97.999 4.661.999h49.279c1.691 0 3.17-.353 4.661-1 1.498-.638 2.897-1.564 3.996-2.663 1.112-1.112 2.017-2.337 2.663-3.829.646-1.491.833-3.13.833-4.828V56.58H28.318v-7.325h56.437v-4.994c0-1.692-.18-3.183-.833-4.662-.639-1.491-1.551-2.89-2.663-3.995-1.1-1.106-2.498-2.025-3.996-2.664-1.492-.646-2.97-.832-4.661-.832H23.323z",
        fill: "currentcolor",
        fillRule: "nonzero"
      }
    ) })
  }
), Vs = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 26 27",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsxs("g", { fill: "currentcolor", fillRule: "nonzero", children: [
      /* @__PURE__ */ t.jsx("path", { d: "M21.541 26.845H4.43A3.448 3.448 0 0 1 .985 23.4V6.289A3.448 3.448 0 0 1 4.43 2.845h8.556a1 1 0 0 1 0 2H4.43c-.797 0-1.443.646-1.444 1.444V23.4c0 .797.647 1.443 1.444 1.444h17.112c.797 0 1.444-.647 1.444-1.444v-8.556a1 1 0 1 1 2 0V23.4a3.448 3.448 0 0 1-3.444 3.444Z" }),
      /* @__PURE__ */ t.jsx("path", { d: "M7.985 19.845a1 1 0 0 1-.97-1.242l1.2-4.816a1 1 0 0 1 .263-.464L19.92 1.886a3.553 3.553 0 1 1 5.025 5.025L13.507 18.345a1 1 0 0 1-.464.263l-4.816 1.2a1 1 0 0 1-.242.037Zm2.107-5.3-.733 2.93 2.93-.733L23.53 5.497a1.554 1.554 0 0 0 0-2.2 1.593 1.593 0 0 0-2.2 0L10.092 14.545Z" })
    ] })
  }
), Ds = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 29 29",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsx("g", { fill: "currentcolor", fillRule: "nonzero", children: /* @__PURE__ */ t.jsx("path", { d: "M27.407 1a1.166 1.166 0 0 0-1.167 1.168V6.39a14.162 14.162 0 0 0-26 7.778 1.167 1.167 0 0 0 2.334 0A11.835 11.835 0 0 1 24.507 8h-4.1a1.167 1.167 0 1 0 0 2.334h7a1.166 1.166 0 0 0 1.167-1.167v-7A1.167 1.167 0 0 0 27.407 1ZM27.407 13a1.166 1.166 0 0 0-1.167 1.168 11.836 11.836 0 0 1-21.933 6.167h4.1a1.167 1.167 0 1 0 0-2.334h-7A1.166 1.166 0 0 0 .24 19.168v7a1.167 1.167 0 0 0 2.334 0V21.95a14.164 14.164 0 0 0 26-7.782A1.167 1.167 0 0 0 27.407 13Z" }) })
  }
), Bs = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 24 28",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsx("g", { fill: "currentcolor", fillRule: "nonzero", children: /* @__PURE__ */ t.jsx("path", { d: "M12.096 12.877a6 6 0 1 1 0-12 6 6 0 0 1 0 12Zm0-10a4 4 0 1 0 0 8 4 4 0 0 0 0-8ZM21.996 27.877H2.201a2 2 0 0 1-1.99-2.2l.62-6.2a3.987 3.987 0 0 1 3.98-3.6h14.57a3.987 3.987 0 0 1 3.98 3.6l.62 6.2a2 2 0 0 1-1.985 2.2Zm-17.185-10a1.994 1.994 0 0 0-1.99 1.8l-.62 6.2h19.795l-.622-6.2a1.994 1.994 0 0 0-1.99-1.8H4.811Z" }) })
  }
), Zs = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 29 29",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsxs("g", { fill: "currentcolor", fillRule: "nonzero", children: [
      /* @__PURE__ */ t.jsx("path", { d: "M12.506 23.197a1.5 1.5 0 0 1 3-.03 1.5 1.5 0 0 1-1.5 1.464 1.472 1.472 0 0 1-1.5-1.434Zm1.446-13.241h.129a1.02 1.02 0 0 1 1.025 1.034l-.065 7.8a1.019 1.019 0 0 1-1.02 1.01 1.02 1.02 0 0 1-1.025-1.01l-.065-7.8a1.021 1.021 0 0 1 1.02-1.034Z" }),
      /* @__PURE__ */ t.jsx("path", { d: "M27.784 25.39 15.837 1.527a2.043 2.043 0 0 0-3.662 0L.228 25.39a2.071 2.071 0 0 0 .09 2.028c.37.605 1.03.974 1.74.972h23.895c.71.002 1.37-.368 1.74-.975.381-.613.416-1.38.09-2.025Zm-1.778 1L2.02 26.365a.078.078 0 0 1 0-.083L14.048 2.42 26.006 26.39Z" })
    ] })
  }
), Hs = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 28 23",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsxs("g", { fill: "currentcolor", fillRule: "nonzero", children: [
      /* @__PURE__ */ t.jsx("path", { d: "M18.243 9.435 15 12.677V1.435a1 1 0 0 0-2 0v11.242L9.757 9.435a1 1 0 0 0-1.414 1.414l4.95 4.95a1 1 0 0 0 1.414 0l4.95-4.95a1 1 0 0 0-1.414-1.414Z" }),
      /* @__PURE__ */ t.jsx("path", { d: "M26 22.263H2a2 2 0 0 1-2-2v-5h2v5h24v-5h2v5a2 2 0 0 1-2 2Z" })
    ] })
  }
), qs = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 75 80",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsxs("g", { fill: "currentcolor", fillRule: "nonzero", children: [
      /* @__PURE__ */ t.jsx(
        "path",
        {
          d: "M20.251 8.384a1.42 1.42 0 0 0-.63 1.95l6.63 12.33a1.4 1.4 0 0 0 1.76.65 17.84 17.84 0 0 1 5.18-1.23 1.4 1.4 0 0 0 1.28-1.4v-14a1.43 1.43 0 0 0-1.5-1.39 34.52 34.52 0 0 0-12.72 3.09Z",
          fill: "#8DBF22"
        }
      ),
      /* @__PURE__ */ t.jsx(
        "path",
        {
          d: "M18.951 50.794a1.39 1.39 0 0 0 .4-1.86c-4.927-8.241-2.422-18.906 5.66-24.09a1.39 1.39 0 0 0 .46-1.84l-6.63-12.31a1.41 1.41 0 0 0-2-.56 34.56 34.56 0 0 0-11.34 48.38 1.4 1.4 0 0 0 2 .36l11.45-8.08Z",
          fill: "#007049"
        }
      ),
      /* @__PURE__ */ t.jsx(
        "path",
        {
          d: "M35.321 1.424v19.33a1.4 1.4 0 0 0 1.23 1.4 17.78 17.78 0 1 1-15.19 29.49 1.42 1.42 0 0 0-1.87-.2l-15.76 11.19a1.41 1.41 0 0 0-.3 2c11.411 14.36 31.147 19.085 47.824 11.45C67.933 68.449 77.252 50.422 73.837 32.4 70.423 14.378 55.157 1.01 36.841.004a1.42 1.42 0 0 0-1.52 1.42Z",
          fill: "#009963"
        }
      )
    ] })
  }
), Gs = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 29 27",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsx(
      "path",
      {
        d: "M28.889 21.102a.968.968 0 0 0-.235-.4l-4-4a1 1 0 0 0-1.414 1.414l2.296 2.298H22.05a.993.993 0 0 1-.846-.466l-4.124-6.534 4.127-6.534c.182-.29.5-.467.843-.466h3.483L23.24 8.707a1 1 0 0 0 1.414 1.414l4-4a.968.968 0 0 0 .235-.4 1 1 0 0 0 .049-.25c0-.033.006-.065 0-.1a.991.991 0 0 0-.062-.315c0-.01 0-.018-.006-.026a1 1 0 0 0-.2-.294c-.008-.01-.011-.021-.02-.03l-4-4a1 1 0 0 0-1.414 1.414l2.3 2.294H22.05a2.985 2.985 0 0 0-2.538 1.4l-3.618 5.73-5.51-8.73a2.985 2.985 0 0 0-2.534-1.4h-5.9a1 1 0 1 0 0 2h5.9a.993.993 0 0 1 .846.466l6.018 9.534-6.021 9.534a.993.993 0 0 1-.843.466h-5.9a1 1 0 0 0 0 2h5.9a2.985 2.985 0 0 0 2.538-1.4l5.512-8.73 3.618 5.73a2.985 2.985 0 0 0 2.532 1.4h3.483l-2.293 2.293a1 1 0 1 0 1.414 1.414l4-4c.009-.01.012-.021.02-.03a1 1 0 0 0 .2-.294c0-.008 0-.017.006-.026a.991.991 0 0 0 .062-.316v-.1a1 1 0 0 0-.053-.253Z",
        fill: "currentcolor",
        fillRule: "nonzero"
      }
    )
  }
), Us = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 22 29",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsxs("g", { fillRule: "nonzero", fill: "currentcolor", children: [
      /* @__PURE__ */ t.jsx(
        "path",
        {
          d: "m21.707 8.18-7-7A1 1 0 0 0 14 .885H2a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2v-18a1 1 0 0 0-.293-.707ZM15 4.3l3.586 3.586H15V4.3ZM2 26.886v-24h11v5a2 2 0 0 0 2 2h5v17H2Z",
          fill: "#000"
        }
      ),
      /* @__PURE__ */ t.jsx(
        "path",
        {
          d: "M10.611 10.83a.719.719 0 0 0-.07.024.248.248 0 0 0-.082.018.275.275 0 0 0-.132.1c-.077.16-.12.335-.13.512a4.612 4.612 0 0 0-.018 1.052 7.4 7.4 0 0 0 .2 1.118c.156-.647.272-1.304.346-1.966l.029-.286c.018-.176.038-.356.042-.462a1.425 1.425 0 0 0-.185-.108m-.1 5.55a22.326 22.326 0 0 1-1.332 2.804c.036-.01.071-.022.109-.034a19.124 19.124 0 0 1 2.126-.516c.219-.042.419-.078.6-.108a16.772 16.772 0 0 1-.448-.57 16.119 16.119 0 0 1-1.064-1.58m3.447 2.944a10.085 10.085 0 0 0 1.328 1.198c.287.228.607.41.949.54.18.06.375.06.555 0a.464.464 0 0 0 .27-.2.568.568 0 0 0-.024-.436 1.275 1.275 0 0 0-.483-.526 2.786 2.786 0 0 0-.877-.35 7.973 7.973 0 0 0-1.238-.208 9.402 9.402 0 0 0-.48-.024m-7.106 1.8a6.086 6.086 0 0 0-1.517 1.07 1.247 1.247 0 0 0-.4.636c-.008.03-.012.06-.016.084.292-.099.559-.263.779-.48a8.71 8.71 0 0 0 1.155-1.308m-2.082 2.768a.679.679 0 0 1-.651-.388 1.344 1.344 0 0 1-.07-.882c.105-.421.33-.803.648-1.1a7.254 7.254 0 0 1 1.851-1.289c.374-.188.817-.382 1.3-.568a21.99 21.99 0 0 0 1.912-3.873c.066-.176.126-.354.184-.532a9.075 9.075 0 0 1-.372-1.1 9.094 9.094 0 0 1-.292-1.52 5.843 5.843 0 0 1 .022-1.27c.025-.323.12-.635.278-.917a1.192 1.192 0 0 1 .857-.526.833.833 0 0 1 .447.01c.123.044.241.104.35.176v-.006c.555.272.5.752.431 1.414l-.03.28a19.3 19.3 0 0 1-.715 3.4c.03.066.064.132.1.2.368.696.795 1.359 1.274 1.982.246.324.532.676.827 1.022.466-.032.934-.03 1.4.006.465.04.926.118 1.379.232.406.088.793.247 1.144.468.364.225.653.553.831.942.177.39.183.834.016 1.227a1.3 1.3 0 0 1-.815.694c-.354.12-.737.122-1.092.006a4.437 4.437 0 0 1-1.217-.674c-.501-.376-.97-.795-1.4-1.25-.2-.21-.409-.435-.613-.663-.334.038-.7.1-1.169.188a18.925 18.925 0 0 0-3.141.868l-.136.21a12.627 12.627 0 0 1-2.018 2.5 2.717 2.717 0 0 1-1.3.713 1.425 1.425 0 0 1-.218.02",
          fill: "red"
        }
      )
    ] })
  }
), Ys = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 28 23",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsxs("g", { fill: "currentcolor", fillRule: "nonzero", children: [
      /* @__PURE__ */ t.jsx("path", { d: "M18.243 7.091 15 3.85v11.242a1 1 0 0 1-2 0V3.85L9.757 7.091a1 1 0 0 1-1.414-1.414l4.95-4.95a1 1 0 0 1 1.414 0l4.95 4.95a1 1 0 0 1-1.414 1.414Z" }),
      /* @__PURE__ */ t.jsx("path", { d: "M26 22.263H2a2 2 0 0 1-2-2v-5h2v5h24v-5h2v5a2 2 0 0 1-2 2Z" })
    ] })
  }
), Ws = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 28 29",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsxs("g", { transform: "translate(0 .435)", fill: "currentcolor", fillRule: "nonzero", children: [
      /* @__PURE__ */ t.jsx("rect", { x: 10, y: 9, width: 2, height: 14, rx: 1 }),
      /* @__PURE__ */ t.jsx("rect", { x: 16, y: 9, width: 2, height: 14, rx: 1 }),
      /* @__PURE__ */ t.jsx("path", { d: "M19 4V3a3 3 0 0 0-3-3h-4a3 3 0 0 0-3 3v1H1a1 1 0 1 0 0 2h26a1 1 0 0 0 0-2h-8Zm-8 0V3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1h-6ZM22.051 28H5.949a2 2 0 0 1-2-1.894L3 7h2l.95 19h16.1L23 7h2l-.95 19.1a2 2 0 0 1-1.999 1.9Z" })
    ] })
  }
), Ks = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsx(
      "path",
      {
        d: "M27.163 28.516H4.819a1.335 1.335 0 01-1.335-1.315V10.282a1.28 1.28 0 011.278-1.228l.078.002h6.185a1.27 1.27 0 11-.004 2.534H6.19v14.291h19.62V11.59h-4.835a1.27 1.27 0 11.004-2.534h6.184l.075-.002c.688 0 1.25.544 1.278 1.225V27.2a1.335 1.335 0 01-1.335 1.316h-.019zm-15.52-12.741a1.373 1.373 0 00-.952-.381c-.374 0-.714.149-.962.391a1.29 1.29 0 00.01 1.862l5.355 5.157c.247.236.582.381.952.381s.705-.145.952-.381l5.353-5.156a1.29 1.29 0 00.01-1.862 1.374 1.374 0 00-.962-.391c-.369 0-.705.145-.952.381l-3.056 2.943L17.352 4.8a1.354 1.354 0 00-2.706.001v.005l.039 13.9z",
        fill: "currentcolor",
        fillRule: "nonzero"
      }
    )
  }
), Js = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsx(
      "path",
      {
        d: "M31.055 19.562h.004c.78 0 1.412-.631 1.414-1.41V5.203a1.414 1.414 0 00-1.414-1.41H9.531c-.78 0-1.412.631-1.414 1.41v12.949c.002.779.634 1.41 1.414 1.41H31.056zm-20.103-2.82V6.614h18.685v10.128zM6.69 9.531v11.477h18.62s1.432-.253 1.432 1.435c0 1.047-.668 1.435-1.432 1.435H5.258a1.476 1.476 0 01-1.432-1.432V9.532c.023-.782.65-1.411 1.43-1.435s1.435.39 1.435 1.435zm17.188 17.215c.091 1.035-.187 1.371-1.432 1.435-.512.067-21.533 0-21.533 0H.904c-.756 0-1.37-.61-1.376-1.366V14.45a1.375 1.375 0 011.375-1.366h.01c.004 0 1.411.128 1.411 1.42 0 .208.069 10.809.069 10.809h20.053s1.432-.252 1.432 1.435z",
        fill: "currentcolor",
        fillRule: "nonzero"
      }
    )
  }
), Xs = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 27 20",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsxs("g", { fill: "currentcolor", fillRule: "nonzero", children: [
      /* @__PURE__ */ t.jsx("path", { d: "M5.618 10.53H4.5l.188-.743h.84c0-.09-.012-.182-.012-.272V9.23c0-.216.013-.432.037-.647H4.5l.188-.744h.991a3.543 3.543 0 0 1 3.638-2.834 5.453 5.453 0 0 1 2.116.399l-.445 1.354a3.568 3.568 0 0 0-.412-.139A6.058 6.058 0 0 0 9.5 6.45a1.974 1.974 0 0 0-2.055 1.385h3.143l-.199.744H7.294a5.28 5.28 0 0 0-.048.628c-.002.192.01.384.036.575h2.682l-.193.743H7.378a1.903 1.903 0 0 0 2.055 1.819 4.65 4.65 0 0 0 1.626-.26l.441 1.372a7.307 7.307 0 0 1-2.285.393c-1.65 0-3.21-.834-3.597-3.318ZM25.257 11.425h-4.879a1.03 1.03 0 0 0-1 1v4.88a1 1 0 0 0 2 0v-2.466l3.915 3.915a1 1 0 0 0 1.414-1.414l-3.915-3.915h2.465a1 1 0 0 0 0-2Z" }),
      /* @__PURE__ */ t.jsx("path", { d: "M24 8.925V3.992a1.568 1.568 0 0 0-1.566-1.567H3.566A1.568 1.568 0 0 0 2 3.992v10.867a1.568 1.568 0 0 0 1.566 1.566H16.88v2H3.565A3.57 3.57 0 0 1 0 14.86V3.992A3.57 3.57 0 0 1 3.566.425h18.868A3.57 3.57 0 0 1 26 3.992v4.933h-2Z" })
    ] })
  }
), Qs = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 27 20",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsxs("g", { fill: "currentcolor", fillRule: "nonzero", children: [
      /* @__PURE__ */ t.jsx("path", { d: "M5.615 11.53H4.497l.188-.743h.84c0-.09-.012-.182-.012-.272v-.284c0-.216.012-.432.036-.647H4.497l.188-.744h.99a3.543 3.543 0 0 1 3.64-2.834 5.453 5.453 0 0 1 2.115.399l-.445 1.354a3.568 3.568 0 0 0-.412-.139 6.058 6.058 0 0 0-1.076-.17 1.974 1.974 0 0 0-2.055 1.385h3.143l-.2.744H7.292a5.28 5.28 0 0 0-.048.628c-.002.192.01.384.036.575H9.96l-.193.743H7.375a1.903 1.903 0 0 0 2.055 1.819 4.65 4.65 0 0 0 1.625-.26l.442 1.372a7.307 7.307 0 0 1-2.285.393c-1.65 0-3.21-.834-3.597-3.318ZM21.118.425h4.879a1.03 1.03 0 0 1 1 1v4.88a1 1 0 0 1-2 0V3.84l-3.915 3.914a1 1 0 1 1-1.414-1.414l3.915-3.915h-2.465a1 1 0 0 1 0-2Z" }),
      /* @__PURE__ */ t.jsx("path", { d: "M23.997 15.859a1.568 1.568 0 0 1-1.567 1.566H3.563a1.568 1.568 0 0 1-1.566-1.566V4.992a1.568 1.568 0 0 1 1.566-1.567h14.434v-2H3.563A3.57 3.57 0 0 0-.003 4.992v10.867a3.57 3.57 0 0 0 3.566 3.566H22.43a3.57 3.57 0 0 0 3.567-3.566V9.425h-2v6.434Z" })
    ] })
  }
), ea = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 29 29",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsxs("g", { transform: "translate(.94 .425)", fill: "currentcolor", fillRule: "nonzero", children: [
      /* @__PURE__ */ t.jsx("path", { d: "M14.949 5.955c2.212-.097 4.42.282 6.473 1.109a1.004 1.004 0 1 1-.892 1.8 14.043 14.043 0 0 0-5.581-.9 1.002 1.002 0 1 1 0-2.005v-.004Z" }),
      /* @__PURE__ */ t.jsx("circle", { cx: 9.93, cy: 10.968, r: 1.003 }),
      /* @__PURE__ */ t.jsx("path", { d: "m.9 11.769 2.267-1.507C4.049 8.815 4.63 7.789 4.823 7.39L4.09 2.296A2 2 0 0 1 4.643.603a1.98 1.98 0 0 1 1.648-.59 6.9 6.9 0 0 1 5.109 2.69 18.317 18.317 0 0 1 5.561-.757C22.276 1.945 28 4.768 28 10.968c0 2.515-1.077 5.682-1.943 8.225a32.436 32.436 0 0 0-.992 3.23 2 2 0 0 1-1.965 1.58h-3.269a1.986 1.986 0 0 1-1.945-1.514 1.768 1.768 0 0 0-1.933-1.494c-.94-.098-1.79.56-1.932 1.494a1.987 1.987 0 0 1-1.945 1.514H7.725a2 2 0 0 1-1.956-1.554 13.117 13.117 0 0 0-1.143-3.46H2.713a2.013 2.013 0 0 1-1.966-1.6c-.166-.8-.52-2.6-.71-3.575A2 2 0 0 1 .9 11.769Zm1.818 5.215h2.2c.987 0 1.844.852 2.814 5.014l4.343.02a3.745 3.745 0 0 1 3.885-3.028 3.733 3.733 0 0 1 3.871 3.013H23.1c.288-1.168.64-2.32 1.053-3.45.819-2.4 1.836-5.4 1.836-7.58 0-5.551-5.909-7.018-9.035-7.018a16.4 16.4 0 0 0-4.947.662 1.99 1.99 0 0 1-2.259-.75 4.894 4.894 0 0 0-3.673-1.85l.765 5.328c.059.4.087.6-1.961 3.955-.151.25-.356.464-.6.626l-2.271 1.507c.192.97.54 2.755.705 3.55h.005Z" }),
      /* @__PURE__ */ t.jsx("path", { d: "M27 28.003H1a1 1 0 0 1-1-1v-4a1 1 0 1 1 2 0v3h24v-3a1 1 0 1 1 2 0v4a1 1 0 0 1-1 1Z" })
    ] })
  }
), ta = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 26 27",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsxs("g", { fill: "currentcolor", fillRule: "nonzero", children: [
      /* @__PURE__ */ t.jsx("path", { d: "M26.9997328,26.7320962 L13.9997328,26.7320962 C13.4474481,26.7320962 12.9997328,26.284381 12.9997328,25.7320962 C12.9997328,25.1798115 13.4474481,24.7320962 13.9997328,24.7320962 L26.9997328,24.7320962 C27.5520176,24.7320962 27.9997328,25.1798115 27.9997328,25.7320962 C27.9997328,26.284381 27.5520176,26.7320962 26.9997328,26.7320962 Z" }),
      /* @__PURE__ */ t.jsx("path", { d: "M0.999732808,26.7320973 C0.69194292,26.7320973 0.401339594,26.5901927 0.21188848,26.3476172 C0.0224373663,26.1050416 -0.0447523594,25.7887375 0.0297328079,25.4900962 L1.47473281,19.7120962 C1.51832519,19.5362221 1.60888426,19.375497 1.73673281,19.2470962 L19.7927328,1.19009624 C21.3799992,-0.396893988 23.9532426,-0.396670131 25.5402328,1.19059624 C27.127223,2.77786261 27.1269992,5.35110601 25.5397328,6.93809624 L7.48373281,24.9940962 C7.35572807,25.1221528 7.19535704,25.2130528 7.01973281,25.2570962 L1.24173281,26.7010962 C1.16273598,26.721799 1.08139729,26.7320973 0.999732808,26.7320973 Z M3.34773281,20.4660962 L2.37373281,24.3580962 L6.26573281,23.3850962 L24.1257328,5.52509624 C24.9320685,4.71903665 24.9322924,3.41193198 24.1262328,2.60559624 C23.3201732,1.79926051 22.0130685,1.79903665 21.2067328,2.60509624 L3.34773281,20.4660962 Z" })
    ] })
  }
), na = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "50 14 134 110",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsx(
      "path",
      {
        fill: "currentcolor",
        fillRule: "nonzero",
        d: "M72.9 17.9 69 21.8V48h5V36.1c0-10.2.3-12.2 1.9-14.2l1.9-2.4 37.9-.3c47.2-.3 43.3-1.8 43.3 16.4V48h6.2l-.4-12.8c-.3-10.4-.7-13.2-2.2-15.5-3.8-5.7-4-5.7-46.7-5.7H76.8l-3.9 3.9zM58.3 56.1c-1.7.5-4.3 2.3-5.7 4L50 63.2V103l3.4 3.8 3.4 3.7 58.9.3c56.2.2 58.9.1 61.9-1.7 5.5-3.4 6.4-6.9 6.4-26.1 0-23.2-1.6-26.4-13.7-27.6C158.8 54.2 151 59 151 67.3V71H83.2l-.6-4.5c-1.5-9.4-12-14-24.3-10.4zm17 6.7c1.3 1.4 1.7 4.5 1.9 14.7l.3 13 39.3.3 39.2.2V78.2c0-16.3.6-17.2 11.2-17.2 11 0 10.8-.4 10.8 21.8 0 15.9-.2 18.8-1.7 20.4-1.5 1.7-4.7 1.8-59.9 1.8H58.1l-1.5-2.2c-1.3-1.8-1.6-5.6-1.6-20C55 61 55 61 66.3 61c5.8 0 7.7.4 9 1.8zM151 80.5V85H83v-9h68v4.5zM56 121.5v2.5h20v-5H56v2.5zM157 121.5v2.5h21v-5h-21v2.5z"
      }
    )
  }
), ra = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsxs(
  "svg",
  {
    viewBox: "0.48 0.35 95.34 113.65",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: [
      /* @__PURE__ */ t.jsx(
        "path",
        {
          fill: "currentcolor",
          fillRule: "nonzero",
          d: "M32.3 2c-2.9 1.5-4.8 3.4-6 6.1l-1.8 3.8-11.6.1c-9 0-11.8.3-12.2 1.4C-.4 16.2 2.4 17 13.5 17h11l2 3.7c2 3.8 4.9 5.3 6.7 3.5.7-.7.4-1.9-1.1-3.8-6-7.7 1.4-18.3 9.8-14 5.4 2.8 6.6 7.8 3.1 13.1-2.5 3.7-2.5 5.5-.2 5.5 2 0 5.5-3.4 6.5-6.3.6-1.5 2.5-1.7 21.4-1.7 11.4 0 21.4-.4 22.2-.9.8-.5 1.1-1.6.8-2.5-.6-1.4-3.3-1.6-21.9-1.6H52.5l-2-3.7C46.4.8 39.4-1.6 32.3 2zM5.2 26.3C2.9 28.6 1 31.2 1 32c0 2 8.1 10 10.1 10 2.6 0 3-2.6.8-5.4l-2-2.6h7.5c7.6 0 9.7-1 7.6-3.5-.9-1.1-3.3-1.5-8.3-1.5h-7l2.2-2.4c1.3-1.4 2-2.9 1.6-3.5-1.3-2.1-4.2-1-8.3 3.2z"
        }
      ),
      /* @__PURE__ */ t.jsx(
        "path",
        {
          fill: "currentcolor",
          fillRule: "nonzero",
          d: "M62.7 23.2c-.2.7.5 2.3 1.6 3.5l2 2.3h-7c-5 0-7.4.4-8.3 1.5-2.1 2.5 0 3.5 7.6 3.5h7.5l-2 2.6c-2 2.6-1.9 5.4.3 5.4C65.8 42 75 32.9 75 31.5c0-.5-1.9-2.9-4.2-5.2-4.2-4.3-7.2-5.4-8.1-3.1z"
        }
      ),
      /* @__PURE__ */ t.jsx(
        "path",
        {
          fill: "currentcolor",
          fillRule: "nonzero",
          d: "M35.3 25.5c-1.6.7-3.3 2-3.7 3-.3.9-.6 10.2-.6 20.5 0 10.4-.4 19.1-.9 19.4-.5.4-1.7-1.4-2.7-3.9-.9-2.6-2.6-5.3-3.8-6.1-2.5-1.7-8.7-1.9-10.4-.2-1.6 1.6-1.5 6.8.2 10.9.8 1.9 2.4 8.3 3.6 14.4 2.4 12 2.9 13.2 7.1 18.6 2.1 2.7 2.9 4.8 2.9 7.8 0 3.7.2 4.1 2.5 4.1 2.4 0 2.5-.3 2.5-5.7 0-5.2-.3-6.1-3.5-9.3-2.7-2.7-3.8-5.2-5.1-10.5-2-8.7-5.1-21.2-6-24.4-1.2-4.2 2.9-2 5.4 2.9 3.7 7.4 6.6 8.7 10.7 4.5C36 69.1 36 69 36 49.6c0-10.7.4-19.7.9-20 .5-.4 1.6-.3 2.5 0 1.4.5 1.6 3 1.6 17.8 0 9.4.4 17.7.9 18.5.5.8 1.6 1.1 2.5.8 1.1-.4 1.6-2.3 1.8-6.9.3-6 .4-6.3 3.1-6.6l2.7-.3V62c0 8.9.1 9.1 2.3 8.8 1.9-.3 2.2-1 2.5-6.1.3-5.6.4-5.7 3.2-5.7h3v9.6c0 9.3.1 9.5 2.3 9.2 2-.3 2.2-.9 2.5-6.6.3-5.8.4-6.2 2.7-6.2H73v13.5c0 14.4-.5 16.8-5.4 23.9-1.7 2.6-2.6 5.2-2.6 7.8 0 3.5.2 3.9 2.3 3.6 1.6-.2 2.3-1.1 2.5-3.3.2-1.6 2-5.7 4-8.9l3.7-5.9.3-16.2c.4-18.2 0-19.5-6.3-19.5-2.7 0-3.7-.6-4.7-2.8-1.1-2.2-2.1-2.8-5.6-3-2.3-.2-4.2-.7-4.2-1.3 0-2.2-4.1-4.9-7.5-4.9H46v-9.1c0-5-.4-9.9-1-10.9-1.5-2.8-6.1-4-9.7-2.5z"
        }
      )
    ]
  }
), sa = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 800 800",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsxs("g", { fill: "currentcolor", fillRule: "nonzero", children: [
      /* @__PURE__ */ t.jsx(
        "path",
        {
          fill: "#829CA4",
          d: "M616.06 451.578c26.258 5.942 52.52 11.869 78.773 17.83 21.391 4.857 42.774 9.752 64.156 14.65.924.211 1.803.625 2.668.933-39.32 178.371-209.77 301.946-391.826 285.563-220.76-19.867-358.992-215.93-337.357-407.885C56.875 146.168 242.149 27.686 399.899 30.69c0 49.074 0 98.163-.492 147.756-14.951 2.175-29.521 3.217-43.836 5.72-11.236 1.965-22.424 5.001-33.137 8.92-9.922 3.63-19.041 9.39-28.77 13.625-14.987 6.521-27.672 16.47-39.615 27.135-18.275 16.32-33.923 34.925-46.25 56.378-18.662 32.48-28.245 67.465-29.548 104.599-.501 14.294.637 28.902 3.15 42.988 4.43 24.835 12.216 48.717 24.913 70.828 14.203 24.731 31.934 46.273 54.111 64.36 34.432 28.08 73.865 44.241 117.718 48.634 19.385 1.941 39.265 1.843 58.636-1.874 24.21-4.645 47.426-12.29 69.21-24.237 31.913-17.503 58.029-41.194 78.346-71.32 15.01-22.259 25.438-46.544 31.724-72.625z"
        }
      ),
      /* @__PURE__ */ t.jsx(
        "path",
        {
          fill: "#003745",
          d: "M402.915 179.015c-.167-1.478-.478-2.956-.48-4.435-.03-46.656-.034-93.311-.028-139.967 0-1.296.156-2.593.238-3.866C632.09 27.87 816.53 248.121 762.378 482.137c-16.435-3.708-32.874-7.408-49.31-11.126-31.318-7.085-62.633-14.179-93.947-21.282-.464-.105-.892-.373-1.693-1.05 6.058-29.445 6.697-58.624 1.213-87.686-10.65-56.448-38.776-102.553-84.585-137.3-38.646-29.315-82.39-44.571-131.141-44.678z"
        }
      ),
      /* @__PURE__ */ t.jsx(
        "path",
        {
          fill: "#BECBCF",
          d: "M616.083 451.419c-6.31 26.24-16.738 50.525-31.748 72.783-20.317 30.127-46.433 53.818-78.347 71.32-21.783 11.948-45 19.593-69.21 24.238-19.37 3.717-39.25 3.815-58.635 1.874-43.853-4.393-83.286-20.554-117.718-48.635-22.177-18.086-39.908-39.628-54.11-64.359-12.698-22.111-20.485-45.993-24.914-70.828-2.513-14.086-3.651-28.694-3.15-42.988 1.303-37.134 10.886-72.118 29.549-104.599 12.326-21.453 27.974-40.059 46.249-56.378 11.943-10.666 24.628-20.614 39.614-27.135 9.73-4.234 18.85-9.995 28.771-13.625 10.713-3.919 21.901-6.955 33.137-8.92 14.315-2.503 28.885-3.545 43.793-5.262.449 11.416.449 22.877.449 34.632-4.832.482-9.396 1.127-13.982 1.365-29.39 1.522-56.175 11.067-81.247 26.057-13.78 8.238-26.346 18.088-37.409 29.625-26.83 27.98-43.77 61.047-50.317 99.44-5.852 34.32-2.025 67.586 10.403 99.856 7.64 19.84 18.79 37.674 32.815 53.792 23.21 26.675 51.694 45.146 85.236 55.877 21.264 6.802 43.185 9.61 65.443 8.29 40.533-2.403 76.953-16.213 108.448-41.856 31.241-25.436 51.86-58.05 62.577-96.9 1.567-5.68 1.556-5.683 11.109-3.063 8.203 1.785 15.68 3.354 23.156 4.924 0 0 .062.316.038.475z"
        }
      ),
      /* @__PURE__ */ t.jsx(
        "path",
        {
          fill: "#99AFB5",
          d: "M402.627 179.311c49.039-.19 92.783 15.067 131.43 44.381 45.808 34.748 73.933 80.853 84.584 137.301 5.484 29.062 4.845 58.241-1.604 87.603-.166.508-.299.616-.98.537-8.053-1.834-15.556-3.481-23.06-5.128-.824-.104-1.664-.137-2.47-.323-7.15-1.655-7.045-1.644-5.733-8.941 6.908-38.431 2.186-75.292-13.905-110.977-9.014-19.988-21.038-37.746-36.236-53.253-28.182-28.755-62.288-46.73-102.046-53.52-9.79-1.673-19.763-2.277-30.267-3.44 0-11.148 0-22.546.287-34.24z"
        }
      ),
      /* @__PURE__ */ t.jsx(
        "path",
        {
          fill: "#E1E7E9",
          d: "M592.988 444.314c7.513 1.338 15.016 2.985 22.831 4.915.27.598.238.914.22 1.474-7.47-1.329-14.947-2.898-22.772-4.657-.329-.6-.309-1.011-.28-1.732z"
        }
      )
    ] })
  }
), aa = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsxs(
  "svg",
  {
    viewBox: "0 0 800 800",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: [
      /* @__PURE__ */ t.jsx(
        "path",
        {
          fill: "#003745",
          d: "M402.84 180.034c-.086-1.151-.246-2.302-.246-3.454-.013-46.83-.011-93.66-.01-140.49v-5.147c58.727.385 114.226 13.352 166.265 40.125C645.884 110.7 702.855 170 738.8 248.789c72.31 158.501 23.102 347.223-117.024 450.883-139.78 103.404-319.757 89.675-437.262 2.537 29.015-39.911 58.034-79.827 87.596-120.055.993-.106 1.486.037 1.887.314 45.944 31.743 96.698 45.083 152.207 38.767 59.722-6.795 108.912-33.972 146.71-80.383 38.687-47.504 54.694-102.493 48.346-163.519-5.243-50.416-26.21-93.804-61.21-130.282-23.629-24.626-51.746-42.716-83.881-54.253-23.654-8.493-48.051-13.306-73.328-12.764z"
        }
      ),
      /* @__PURE__ */ t.jsx(
        "path",
        {
          fill: "#829CA4",
          d: "m270.04 580.016-87.396 120.36C75.542 626.592 1.07 473.383 41.548 312.11 86.656 132.398 246.907 30.35 399.934 31.238c0 49.224 0 98.458-.395 148.012-1.361.135-2.351-.292-3.288-.196-9.04.927-18.072 1.938-27.105 2.934-21.983 2.423-42.848 8.942-62.652 18.465-27.812 13.374-52.25 31.383-72.415 55.008-19.313 22.626-34.343 47.751-43.55 76.006-9.68 29.7-12.583 60.265-9.735 91.465 2.145 23.504 7.865 46.034 17.188 67.574 12.723 29.393 31.49 54.6 55.274 75.998 5.13 4.616 11.026 8.382 16.616 12.784.046.245.168.728.168.728z"
        }
      ),
      /* @__PURE__ */ t.jsx(
        "path",
        {
          fill: "#99AFB5",
          d: "M402.585 180.351c25.532-.859 49.929 3.954 73.583 12.447 32.135 11.537 60.252 29.627 83.88 54.253 35.002 36.478 55.968 79.866 61.211 130.282 6.348 61.026-9.66 116.015-48.347 163.519-37.797 46.41-86.987 73.588-146.709 80.383-55.509 6.316-106.263-7.024-152.207-38.767-.4-.277-.894-.42-1.71-.601-.367.024-.45-.461-.097-.84 1.385-1.66 2.502-2.885 3.436-4.237 4.867-7.043 9.687-14.119 14.524-21.184 1.725.032 3.9-.612 5.11.193 30.536 20.308 63.824 31.617 100.72 32.506 47.717 1.15 89.695-13.83 126.057-44.274 17.72-14.837 32.069-32.695 43.143-53.203 11.463-21.227 18.866-43.7 21.52-67.56 4.76-42.79-3.957-82.873-26.657-119.522-26.45-42.703-64.466-70.28-112.925-82.927-12.926-3.374-26.567-4.015-39.884-5.876-1.452-.202-2.935-.175-4.903-.282 0-11.475 0-22.734.255-34.31z"
        }
      ),
      /* @__PURE__ */ t.jsx(
        "path",
        {
          fill: "#BECBCE",
          d: "M269.826 579.043c-5.544-4.157-11.44-7.923-16.57-12.54-23.784-21.398-42.55-46.604-55.274-75.997-9.323-21.54-15.043-44.07-17.188-67.574-2.848-31.2.055-61.764 9.734-91.465 9.208-28.255 24.238-53.38 43.55-76.006 20.166-23.625 44.604-41.634 72.416-55.008 19.804-9.523 40.669-16.042 62.652-18.465 9.033-.996 18.065-2.007 27.105-2.934.937-.096 1.927.331 3.247.653.355 11.59.355 23.042.355 34.74-6.229.512-12.133.992-18.035 1.485-19.388 1.619-37.86 6.77-55.649 14.507-23.643 10.284-44.309 24.875-61.753 43.805-25.284 27.438-41.73 59.417-47.372 96.48-1.716 11.276-2.956 22.783-2.775 34.159.418 26.343 6.286 51.57 17.39 75.626 11.207 24.276 27.399 44.645 47.004 62.51 2.565 2.336 5.547 4.209 8.189 6.469 1.184 1.013 2.003 2.453 2.665 4.142-1.367 1.705-2.45 2.937-3.447 4.234-5.426 7.051-10.832 14.118-16.244 21.179z"
        }
      ),
      /* @__PURE__ */ t.jsx(
        "path",
        {
          fill: "#DEE5E7",
          d: "M269.872 579.288c5.366-7.306 10.772-14.373 16.198-21.424a38.888 38.888 0 0 1 3.44-3.886c.375.19.436.474.567 1.194-4.765 7.5-9.585 14.575-14.452 21.618-.934 1.352-2.05 2.576-3.392 3.995-.75-.156-1.19-.448-1.912-.754-.28-.015-.403-.498-.45-.743z"
        }
      )
    ]
  }
), oa = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsxs(
  "svg",
  {
    viewBox: "0 0 800 800",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: [
      /* @__PURE__ */ t.jsx(
        "path",
        {
          fill: "#003745",
          d: "M402.962 179.007c-.12-1.32-.343-2.64-.344-3.96-.017-46.825-.014-93.65-.014-140.475v-3.383c105.105-3.121 260.581 54.348 335.458 215.458 71.549 153.95 27.331 338.428-106.43 444.997-132.153 105.289-321.567 107.271-454.59 5.022C35.271 587.692 5.757 414.845 48.556 288.094c32.202 10.478 64.41 20.949 96.61 31.441 14.933 4.866 29.852 9.774 44.82 15.326-10.308 34.31-12.757 68.583-6.61 103.186 10.211 57.484 38.412 104.52 85.054 139.698 50.915 38.4 108.533 52.252 171.309 41.795 53.522-8.916 98.145-34.755 132.762-76.604 43.914-53.089 59.806-114.335 48.008-181.942-9.87-56.561-38.64-102.56-84.444-137.294-39.225-29.745-83.63-45.001-133.103-44.693z"
        }
      ),
      /* @__PURE__ */ t.jsx(
        "path",
        {
          fill: "#829CA4",
          d: "M190.751 331.482 48.978 285.514c25.827-76.295 70.681-138.27 135.74-185.095 63.957-46.032 135.653-69.076 215.217-69.834 0 49.577 0 98.487-.477 147.912-10.55 1.273-20.746 1.282-30.67 2.931-27.836 4.626-54.302 13.225-78.702 27.937-22.559 13.602-42.48 30.174-59.13 50.49-12.655 15.44-23.387 32.207-31.202 50.702-2.955 6.994-6 13.951-9.003 20.925z"
        }
      ),
      /* @__PURE__ */ t.jsx(
        "path",
        {
          fill: "#99AFB5",
          d: "M402.672 179.302c49.763-.603 94.168 14.653 133.393 44.398 45.803 34.734 74.574 80.733 84.444 137.294 11.798 67.607-4.094 128.853-48.008 181.942-34.617 41.849-79.24 67.688-132.762 76.604-62.776 10.457-120.394-3.395-171.31-41.795-46.641-35.179-74.842-82.214-85.053-139.698-6.147-34.603-3.698-68.877 6.837-102.884 1.142-.355 2.101-.35 3.645-.025 7.77 2.502 14.955 4.683 22.14 6.865l6.878 2.56c-1.479 5.903-3.14 11.601-4.322 17.397-10.918 53.535-.88 102.87 30.555 147.538 28.209 40.085 66.964 64.672 114.676 74.786 39.842 8.446 78.43 3.548 115.498-13.392 23.977-10.957 44.801-26.293 62.044-46.097 24.76-28.437 39.82-61.442 44.917-98.992 5.328-39.253-1.345-76.467-19.755-111.207-25.444-48.013-64.767-79.576-117.39-93.572-13.22-3.517-27.162-4.418-40.822-6.119-4.253-.53-6.543-1.233-6.269-6.346.518-9.633.292-19.306.664-29.257z"
        }
      ),
      /* @__PURE__ */ t.jsx(
        "path",
        {
          fill: "#BECBCE",
          d: "M190.864 331.788c2.89-7.28 5.935-14.237 8.89-21.231 7.815-18.495 18.547-35.261 31.202-50.702 16.65-20.316 36.571-36.888 59.13-50.49 24.4-14.712 50.866-23.31 78.702-27.937 9.924-1.649 20.12-1.658 30.642-2.469.45 11.403.45 22.858.45 34.753-7.647.76-15.023 1.365-22.367 2.243-32.934 3.937-62.576 16.206-88.934 36.157-23.798 18.013-42.589 40.318-55.381 67.454-2.678 5.68-5.503 11.3-7.93 17.087-2.739 6.532-2.577 6.6-9.09 3.211-7.801-2.49-15.012-4.652-22.222-6.813-.993-.319-1.986-.638-3.092-1.263z"
        }
      ),
      /* @__PURE__ */ t.jsx(
        "path",
        {
          fill: "#DFE6E7",
          d: "M193.971 333.356c7.195 1.856 14.406 4.018 21.839 6.478.216.715.211 1.13.197 1.857-7.194-1.87-14.38-4.05-21.79-6.52-.226-.696-.228-1.103-.246-1.815z"
        }
      )
    ]
  }
), ia = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsxs(
  "svg",
  {
    viewBox: "0 0 800 800",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: [
      /* @__PURE__ */ t.jsx(
        "path",
        {
          fill: "#003745",
          d: "M402.666 178.057V30.65C566.3 27.239 743.461 151.67 768.812 354.798c27.715 222.057-143.36 412.92-361.463 416.899-215.594 3.932-389.463-177.278-376.013-393.604C44.454 167.115 223.44 27.743 399.876 30.57c0 48.77 0 97.551-.471 146.865-11.062 1.504-21.72 2.011-32.231 3.527-42.979 6.197-81.128 23.65-113.07 52.832-59.796 54.632-84.245 122.659-72.033 202.884 8.272 54.34 34.594 99.29 76.798 134.21 50.15 41.493 108.138 57.602 172.72 49.144 43.76-5.73 82.63-23.184 115.22-52.719 59.38-53.815 84.154-121.013 73.19-200.621-6.416-46.588-26.817-86.835-59.479-120.48-43.092-44.387-96.106-66.579-157.854-68.154z"
        }
      ),
      /* @__PURE__ */ t.jsx(
        "path",
        {
          fill: "#99AFB5",
          d: "M402.431 178.386c61.983 1.246 114.997 23.438 158.09 67.826 32.661 33.644 53.062 73.891 59.478 120.479 10.964 79.608-13.81 146.806-73.19 200.621-32.59 29.535-71.46 46.989-115.22 52.72-64.582 8.457-122.57-7.652-172.72-49.145-42.204-34.92-68.526-79.87-76.798-134.21-12.212-80.225 12.237-148.252 72.033-202.884 31.942-29.182 70.091-46.635 113.07-52.832 10.512-1.516 21.169-2.023 32.202-3.071.442 11.721.442 23.52.442 35.718-65.344 2.685-117.477 29.96-154.252 84.032-25.359 37.285-35.167 79.158-30.053 123.99 11.471 100.57 98.216 170.223 192.964 166.036 99.86-4.413 170.148-82.116 178.796-169.137 10.18-102.446-70.167-203.54-185.077-205.031 0-11.581 0-23.182.235-35.112z"
        }
      )
    ]
  }
), la = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 29 28",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsx(
      "path",
      {
        fill: "currentcolor",
        fillRule: "nonzero",
        d: "M27.663.868c0-.007-.007-.012-.01-.018a.91.91 0 0 0-.1-.218.85.85 0 0 0-.07-.134.985.985 0 0 0-.134-.122.993.993 0 0 0-.153-.13A1.115 1.115 0 0 0 27.07.2a.959.959 0 0 0-.245-.078c-.006 0-.011-.005-.018-.006-7.334-.81-17.993 2.67-22.205 9.152-1.735 2.666-3.1 6.988-.1 12.63L.366 26.027A1 1 0 1 0 1.78 27.44l4.1-4.1c2.116 1.35 4.56 2.1 7.069 2.166a11.2 11.2 0 0 0 6.556-2.185c6.58-4.703 9.788-15.93 8.158-22.453Zm-9.318 20.82c-3.3 2.358-6.993 2.41-11 .186l11.9-11.9a1 1 0 0 0-1.414-1.415L5.989 20.403c-1.763-3.645-1.68-7.022.29-10.05 3.62-5.567 13.01-8.736 19.58-8.3 1.066 5.89-1.886 15.615-7.514 19.636Z"
      }
    )
  }
), ca = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsxs("g", { fill: "currentcolor", fillRule: "nonzero", children: [
      /* @__PURE__ */ t.jsx("path", { d: "M16.872 1.635v2a11 11 0 1 1-12.83 12.85h-2a13 13 0 1 0 14.83-14.85Z" }),
      /* @__PURE__ */ t.jsx("path", { d: "M14.352.465a13.49 13.49 0 0 0-6.71 1.81 2.16 2.16 0 0 1 1.11.57l.72.72a11.4 11.4 0 0 1 3.88-1.06v10.46H2.892a11.44 11.44 0 0 1 1.31-4.39 7.25 7.25 0 0 1-1.85-.73 13.39 13.39 0 0 0-1.5 6.12 1 1 0 0 0 1 1h12.5a1 1 0 0 0 1-1v-12.5a1 1 0 0 0-1-1Z" }),
      /* @__PURE__ */ t.jsx("path", { d: "M.752 3.125c1.06 1.11 2.16 2.91 6.69 2.4l-.66-.67a.66.66 0 0 1 .93-.89l2 2a.65.65 0 0 1 0 .93l-2 2a.661.661 0 0 1-.95-.92l.64-.64s-5.27 1.09-7-4.12c0 0-.13-.49.33 0l.02-.09Z" })
    ] })
  }
), da = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 27 29",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsxs("g", { fill: "currentcolor", fillRule: "nonzero", children: [
      /* @__PURE__ */ t.jsx("path", { d: "M26.985 24.85v-20c0-.028-.014-.052-.016-.081a1.019 1.019 0 0 0-.06-.3.965.965 0 0 0-.12-.184.841.841 0 0 0-.091-.137 1.01 1.01 0 0 0-.307-.212l-.012-.008h-.007l-6.992-3a1 1 0 0 0-1.395.923v2h-14a1 1 0 0 0-1 1v7.5h2v-6.5h13v18h-13v-6.5h-2v7.5a1 1 0 0 0 1 1h14v2a1 1 0 0 0 1.394.919l6.992-3h.007c.006 0 .009-.008.015-.011.112-.051.213-.123.3-.21a.955.955 0 0 0 .092-.136.965.965 0 0 0 .119-.184c.035-.097.055-.198.06-.3 0-.03.016-.053.016-.082v.004h.005Zm-7-21.482 5 2.143v18.682l-5 2.142V3.368Z" }),
      /* @__PURE__ */ t.jsx("path", { d: "m14.692 14.145-4-4a1 1 0 0 0-1.414 1.414l2.293 2.292H1.985a1 1 0 1 0 0 2h9.586l-2.293 2.293a1 1 0 1 0 1.414 1.414l4-4a1 1 0 0 0 0-1.413Z" })
    ] })
  }
), ua = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 21 29",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsx("g", { fill: "currentcolor", fillRule: "nonzero", children: /* @__PURE__ */ t.jsx("path", { d: "M15.062 25.886h-9.6a1.017 1.017 0 1 1 0-2h9.6a1.017 1.017 0 1 1 0 2ZM14.262 28.886h-8a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2ZM15.262 22.886h-10a1 1 0 0 1-1-1v-3.183l-.233-.206a9.84 9.84 0 0 1-3.767-7.61c0-5.523 4.477-10 10-10s10 4.477 10 10a9.84 9.84 0 0 1-3.767 7.61l-.233.206v3.183a1 1 0 0 1-1 1Zm-9-2h8v-2.515c0-.565.38-.9.9-1.369a7.8 7.8 0 0 0 3.1-6.116 8 8 0 1 0-16 0 7.8 7.8 0 0 0 3.1 6.116c.524.467.9.8.9 1.366v2.518Z" }) })
  }
), ma = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 29 23",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsx(
      "path",
      {
        fill: "currentcolor",
        fillRule: "nonzero",
        d: "M5.04 8.935a.94.94 0 0 1 1-1h10.37a5.68 5.68 0 0 0-.61 2H6.04a.94.94 0 0 1-1-1Zm1-6h21a.94.94 0 0 0 1-1 .94.94 0 0 0-1-1h-21a.94.94 0 0 0-1 1 .94.94 0 0 0 1 1Zm-4.5 11.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm0-7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm0-7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm15.5 10a4.37 4.37 0 1 1 4.37 4.36 4.37 4.37 0 0 1-4.37-4.36Zm4.36 2.22a2.22 2.22 0 1 0-.03 0h.03Zm-5.58 2.28H6.04a1 1 0 0 0 0 2h8a3.33 3.33 0 0 1 1.78-2Zm12.37 6.85a1.07 1.07 0 0 1-.9 1.22H15.62a1 1 0 0 1-.76-.32 1.06 1.06 0 0 1-.31-.75.81.81 0 0 1 0-.16l.62-4.25a1.82 1.82 0 0 1 1.77-1.59h8.86a1.82 1.82 0 0 1 1.77 1.61l.62 4.24Zm-2.71-3.71h-8.21l-.41 2.79h9l-.38-2.79Z"
      }
    )
  }
), ha = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 29 21",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsx("g", { fill: "currentcolor", fillRule: "nonzero", children: /* @__PURE__ */ t.jsx("path", { d: "M28.668 5.42v-.1a1 1 0 0 0-.049-.25.986.986 0 0 0-.235-.4l-4-4a1 1 0 0 0-1.414 1.415l2.291 2.298H1.675a1 1 0 1 0 0 2h23.586l-2.293 2.293a1 1 0 1 0 1.414 1.414l4-4c.01-.01.012-.021.02-.03a1 1 0 0 0 .2-.294c0-.008 0-.017.006-.026a.991.991 0 0 0 .06-.32ZM.675 15.42v-.1a1 1 0 0 1 .05-.25.986.986 0 0 1 .235-.4l4-4a1.002 1.002 0 0 1 1.415 1.42l-2.293 2.293h23.586a1 1 0 0 1 0 2H4.082l2.293 2.293a1 1 0 1 1-1.414 1.414l-4-4c-.009-.01-.012-.021-.02-.03a1 1 0 0 1-.2-.294c0-.008 0-.017-.006-.026a.991.991 0 0 1-.06-.32Z" }) })
  }
), xa = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 29 28",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsx("g", { fill: "currentcolor", fillRule: "nonzero", children: /* @__PURE__ */ t.jsx("path", { d: "M1.993 21a1 1 0 0 0 .71-.3l9.29-9.31 2.87 2.86a1 1 0 0 0 1.42 0l10.61-10.86v6.25a1 1 0 0 0 2 0V1c.001-.13-.023-.26-.07-.38a1 1 0 0 0-.93-.62h-8.67a1 1 0 0 0 0 2h6.26l-9.9 10.18-2.89-2.91a1 1 0 0 0-1.41 0l-10 10a1 1 0 0 0 .71 1.73ZM27.993 14a1 1 0 0 0-1 1v11h-25a1 1 0 0 0 0 2h26a1 1 0 0 0 1-1V15a1 1 0 0 0-1-1Z" }) })
  }
), fa = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 25 28",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsxs("g", { fill: "currentcolor", fillRule: "nonzero", children: [
      /* @__PURE__ */ t.jsx("path", { d: "M2.006 6.877a1 1 0 0 0 .6-.2l4-3a1 1 0 0 0-1.2-1.6l-4 3a1 1 0 0 0 .6 1.8ZM21.406 6.677a1 1 0 1 0 1.2-1.6l-4-3a1 1 0 0 0-1.2 1.6l4 3Z" }),
      /* @__PURE__ */ t.jsx("path", { d: "M12.996 3.927c0-.017.01-.032.01-.05v-1h1a1 1 0 1 0 0-2h-4a1 1 0 1 0 0 2h1v1c0 .018.01.033.01.05-6.413.53-11.265 6.025-11 12.454.266 6.43 5.556 11.505 11.99 11.505 6.435 0 11.724-5.075 11.99-11.505.266-6.429-4.587-11.923-11-12.454Zm-.99 21.95c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10c-.006 5.52-4.48 9.994-10 10Z" }),
      /* @__PURE__ */ t.jsx("path", { d: "M8.006 19.877a1 1 0 0 1-.6-1.8l3.6-2.7v-6.5a1 1 0 0 1 2 0v7a1 1 0 0 1-.4.8l-4 3a.994.994 0 0 1-.6.2Z" })
    ] })
  }
), ga = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsxs(
  "svg",
  {
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: [
      /* @__PURE__ */ t.jsx("defs", { children: /* @__PURE__ */ t.jsx(
        "mask",
        {
          id: "b",
          x: "0",
          y: "0",
          width: "60",
          height: "60",
          maskUnits: "userSpaceOnUse",
          children: /* @__PURE__ */ t.jsx("g", { id: "c", children: /* @__PURE__ */ t.jsx("rect", { width: "60", height: "60", fill: "#d9d9d9" }) })
        }
      ) }),
      /* @__PURE__ */ t.jsx("g", { mask: "url(#b)", children: /* @__PURE__ */ t.jsx(
        "path",
        {
          d: "M30,30c-2.75,0-5.1-.98-7.06-2.94s-2.94-4.31-2.94-7.06.98-5.1,2.94-7.06,4.31-2.94,7.06-2.94,5.1.98,7.06,2.94,2.94,4.31,2.94,7.06-.98,5.1-2.94,7.06-4.31,2.94-7.06,2.94ZM10,50v-7c0-1.42.36-2.72,1.09-3.91.73-1.19,1.7-2.09,2.91-2.72,2.58-1.29,5.21-2.26,7.88-2.91,2.67-.65,5.38-.97,8.12-.97s5.46.32,8.12.97c2.67.65,5.29,1.61,7.88,2.91,1.21.62,2.18,1.53,2.91,2.72.73,1.19,1.09,2.49,1.09,3.91v7H10ZM15,45h30v-2c0-.46-.11-.88-.34-1.25-.23-.38-.53-.67-.91-.88-2.25-1.12-4.52-1.97-6.81-2.53s-4.6-.84-6.94-.84-4.65.28-6.94.84-4.56,1.41-6.81,2.53c-.38.21-.68.5-.91.88-.23.38-.34.79-.34,1.25v2ZM30,25c1.38,0,2.55-.49,3.53-1.47.98-.98,1.47-2.16,1.47-3.53s-.49-2.55-1.47-3.53c-.98-.98-2.16-1.47-3.53-1.47s-2.55.49-3.53,1.47c-.98.98-1.47,2.16-1.47,3.53s.49,2.55,1.47,3.53c.98.98,2.16,1.47,3.53,1.47Z",
          fill: "#1c1b1f"
        }
      ) })
    ]
  }
), pa = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 28 29",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsxs("g", { fill: "currentcolor", fillRule: "nonzero", children: [
      /* @__PURE__ */ t.jsx("path", { d: "M14 2.435c6.627 0 12 5.372 12 12 0 6.627-5.373 12-12 12s-12-5.373-12-12c.007-6.625 5.376-11.993 12-12m0-2c-7.732 0-14 6.268-14 14s6.268 14 14 14 14-6.268 14-14a14 14 0 0 0-14-14Z" }),
      /* @__PURE__ */ t.jsx("path", { d: "M14 4.435c-5.523 0-10 4.477-10 10 0 5.522 4.477 10 10 10s10-4.478 10-10a10 10 0 0 0-10-10Zm5.707 7.707-7 7a1 1 0 0 1-1.414 0l-3-3a1 1 0 0 1 1.414-1.414L12 17.02l6.293-6.293a1 1 0 0 1 1.414 1.414Z" })
    ] })
  }
), va = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 29 29",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsxs("g", { fill: "currentcolor", fillRule: "nonzero", children: [
      /* @__PURE__ */ t.jsx("path", { d: "M14.94.425c-7.733 0-14 6.268-14 14s6.267 14 14 14c7.731 0 14-6.268 14-14a14 14 0 0 0-14-14Zm0 26c-6.628 0-12-5.372-12-12 0-6.627 5.372-12 12-12 6.627 0 12 5.373 12 12-.008 6.625-5.376 11.993-12 12Z" }),
      /* @__PURE__ */ t.jsx("path", { d: "m19.885 8.058-4.946 4.953-4.953-4.947A1 1 0 1 0 8.572 9.48l4.953 4.946-4.947 4.953a1 1 0 1 0 1.415 1.414l4.946-4.953 4.952 4.947a1 1 0 1 0 1.414-1.415l-4.952-4.946L21.3 9.473a1 1 0 0 0-1.415-1.415Z" })
    ] })
  }
), ba = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 29 29",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsxs("g", { fillRule: "nonzero", fill: "currentcolor", children: [
      /* @__PURE__ */ t.jsx("path", { d: "M14.18.845C6.487.875.27 7.132.29 14.826c.021 7.695 6.27 13.919 13.964 13.909 7.695-.01 13.927-6.25 13.927-13.945-.024-7.714-6.287-13.952-14-13.945Zm0 25.89c-6.589-.03-11.91-5.392-11.89-11.982.021-6.59 5.374-11.918 11.964-11.908 6.59.01 11.927 5.355 11.927 11.945-.023 6.609-5.391 11.952-12 11.945Z" }),
      /* @__PURE__ */ t.jsx("path", { d: "M11.646 21.86a1 1 0 0 1 0-1.413l5.656-5.657-5.656-5.657a1 1 0 0 1 1.414-1.414l6.363 6.364a1 1 0 0 1 0 1.414L13.06 21.86a1 1 0 0 1-1.414 0Z" })
    ] })
  }
), ja = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 29 25",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsx(
      "path",
      {
        fill: "#000",
        fillRule: "nonzero",
        d: "M28.092 15.19a3.349 3.349 0 0 0-3.008-3.321v-.214a2.468 2.468 0 0 0-1.772-2.359c0-.013.008-.024.008-.037a9.259 9.259 0 1 0-18.518 0c0 .015.008.028.009.043a2.468 2.468 0 0 0-1.753 2.353v.214a3.337 3.337 0 0 0 0 6.641v.214a2.475 2.475 0 0 0 2.473 2.473h1.04a2.475 2.475 0 0 0 2.473-2.473v-7.069a2.467 2.467 0 0 0-2.238-2.449 7.256 7.256 0 0 1 14.512 0 2.468 2.468 0 0 0-2.218 2.447v7.069c0 .652.258 1.277.718 1.739-.913.854-3.374 2.533-8.6 2.533a1 1 0 0 0 0 2c7.345 0 10.069-3.054 10.625-3.8h.768a2.475 2.475 0 0 0 2.473-2.473v-.214a3.349 3.349 0 0 0 3.008-3.317Zm-26.042 0a1.355 1.355 0 0 1 1.008-1.3v2.609A1.355 1.355 0 0 1 2.05 15.19Zm4.993-3.535v7.069a.473.473 0 0 1-.473.473H5.53a.473.473 0 0 1-.472-.473v-7.069a.473.473 0 0 1 .473-.473h1.04c.26 0 .472.212.472.473Zm16.04 7.069a.473.473 0 0 1-.472.473h-1.04a.473.473 0 0 1-.473-.473v-7.069a.473.473 0 0 1 .473-.473h1.04c.26 0 .473.212.473.473v7.069Zm2-2.23v-2.609a1.348 1.348 0 0 1 0 2.609Z"
      }
    )
  }
), wa = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 27 17",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsxs("g", { fill: "currentcolor", fillRule: "nonzero", transform: "translate(0 .877)", children: [
      /* @__PURE__ */ t.jsx("rect", { width: 20, height: 2, x: 6, y: 13, fill: "#CCC", rx: 1 }),
      /* @__PURE__ */ t.jsx("rect", { width: 10, height: 2, x: 16, y: 1, fill: "#CCC", rx: 1 }),
      /* @__PURE__ */ t.jsx(
        "path",
        {
          fill: "#000",
          d: "M16 0a1.994 1.994 0 0 0-1.723 1H1a1 1 0 1 0 0 2h13.277A2 2 0 1 0 16 0ZM24 6a1.994 1.994 0 0 0-1.723 1H1a1 1 0 1 0 0 2h21.277A2 2 0 1 0 24 6ZM6 12a1.994 1.994 0 0 0-1.723 1H1a1 1 0 0 0 0 2h3.277A2 2 0 1 0 6 12Z"
        }
      )
    ] })
  }
), ya = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 29 28",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsxs("g", { fill: "currentcolor", fillRule: "nonzero", children: [
      /* @__PURE__ */ t.jsx(
        "path",
        {
          fill: "#408000",
          d: "M20.903 11.955a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm0 14a6 6 0 1 1 0-12 6 6 0 0 1 0 12Z"
        }
      ),
      /* @__PURE__ */ t.jsx(
        "path",
        {
          fill: "#408000",
          d: "M19.903 22.955a1 1 0 0 1-.709-.294l-2.009-2.006a1.002 1.002 0 1 1 1.418-1.415l1.3 1.3 3.3-3.3a1.002 1.002 0 0 1 1.418 1.415l-4.012 4.012a1 1 0 0 1-.706.288Z"
        }
      ),
      /* @__PURE__ */ t.jsx(
        "path",
        {
          fill: "#000",
          d: "M13.403 7.2a3.6 3.6 0 1 0 0-7.2 3.6 3.6 0 0 0 0 7.2Zm0-5.854a2.252 2.252 0 1 1 0 4.504 2.252 2.252 0 0 1 0-4.504Zm.692 25.218H3.492c-.118 0-.236-.016-.35-.045l6.78-6.781 1 1.079c.18.19.381.357.6.5a9.447 9.447 0 0 1-.119-1.362c0-.2.018-.384.03-.575L3.34 10.615a2.248 2.248 0 0 1 1.056-.26H22.41c.37-.001.734.09 1.06.263l-.153.165c.929.245 1.815.63 2.627 1.143a3.6 3.6 0 0 0-3.534-2.922H4.397a3.6 3.6 0 0 0-3.6 3.6v12.609a2.7 2.7 0 0 0 2.7 2.7h12.241a9.607 9.607 0 0 1-1.643-1.349Zm-11.95-1.351V12.604c0-.357.084-.709.247-1.026l6.611 7.163-6.813 6.821a1.422 1.422 0 0 1-.045-.349Z"
        }
      )
    ] })
  }
), _a = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsxs(
  "svg",
  {
    viewBox: "0 0 64.6 43.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: [
      /* @__PURE__ */ t.jsx("style", { children: ".st0{fill:none;stroke:#020203;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}" }),
      /* @__PURE__ */ t.jsxs("g", { transform: "translate(.94 .425)", fill: "currentcolor", fillRule: "nonzero", children: [
        /* @__PURE__ */ t.jsx(
          "path",
          {
            d: "M35.8 31.8h23.5v10.3H29.6v-3.2M35.8 31.8h27.8V21.5H37.5M37.5 21.5h21.8V11.3H32.8M27.4 7.3V1h29.7v10.3H32.8",
            className: "st0"
          }
        ),
        /* @__PURE__ */ t.jsx(
          "circle",
          {
            cx: 19.3,
            cy: 23.7,
            r: 18.3,
            className: "st0",
            transform: "rotate(-22.5 19.339 23.731)"
          }
        ),
        /* @__PURE__ */ t.jsx(
          "path",
          {
            d: "M25.4 29.5c-1.4 1.3-3.2 2-5.3 2-4.3 0-7.8-3.5-7.8-7.8s3.5-7.8 7.8-7.8c2 0 3.9.8 5.3 2M9.7 21.4h10.1M9.7 26.1h10.1",
            className: "st0"
          }
        )
      ] })
    ]
  }
), Ca = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    width: e,
    height: n,
    viewBox: "0 0 74 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsx("g", { fill: "currentcolor", fillRule: "nonzero", children: /* @__PURE__ */ t.jsx("path", { d: "M0.333328 53.6663V44.333C0.333328 42.4441 0.819439 40.708 1.79166 39.1247C2.76388 37.5413 4.05555 36.333 5.66666 35.4997C9.1111 33.7775 12.6111 32.4858 16.1667 31.6247C19.7222 30.7636 23.3333 30.333 27 30.333C30.6667 30.333 34.2778 30.7636 37.8333 31.6247C41.3889 32.4858 44.8889 33.7775 48.3333 35.4997C49.9444 36.333 51.2361 37.5413 52.2083 39.1247C53.1805 40.708 53.6667 42.4441 53.6667 44.333V53.6663H0.333328ZM60.3333 53.6663V43.6663C60.3333 41.2219 59.6528 38.8747 58.2917 36.6247C56.9305 34.3747 55 32.4441 52.5 30.833C55.3333 31.1663 58 31.7358 60.5 32.5413C63 33.3469 65.3333 34.333 67.5 35.4997C69.5 36.6108 71.0278 37.8469 72.0833 39.208C73.1389 40.5691 73.6667 42.0552 73.6667 43.6663V53.6663H60.3333ZM27 26.9997C23.3333 26.9997 20.1944 25.6941 17.5833 23.083C14.9722 20.4719 13.6667 17.333 13.6667 13.6663C13.6667 9.99967 14.9722 6.86079 17.5833 4.24967C20.1944 1.63856 23.3333 0.333008 27 0.333008C30.6667 0.333008 33.8055 1.63856 36.4167 4.24967C39.0278 6.86079 40.3333 9.99967 40.3333 13.6663C40.3333 17.333 39.0278 20.4719 36.4167 23.083C33.8055 25.6941 30.6667 26.9997 27 26.9997ZM60.3333 13.6663C60.3333 17.333 59.0278 20.4719 56.4167 23.083C53.8055 25.6941 50.6667 26.9997 47 26.9997C46.3889 26.9997 45.6111 26.9302 44.6667 26.7913C43.7222 26.6525 42.9444 26.4997 42.3333 26.333C43.8333 24.5552 44.9861 22.583 45.7917 20.4163C46.5972 18.2497 47 15.9997 47 13.6663C47 11.333 46.5972 9.08301 45.7917 6.91634C44.9861 4.74967 43.8333 2.77745 42.3333 0.999674C43.1111 0.721897 43.8889 0.541341 44.6667 0.458008C45.4444 0.374674 46.2222 0.333008 47 0.333008C50.6667 0.333008 53.8055 1.63856 56.4167 4.24967C59.0278 6.86079 60.3333 9.99967 60.3333 13.6663ZM6.99999 46.9997H47V44.333C47 43.7219 46.8472 43.1663 46.5417 42.6663C46.2361 42.1663 45.8333 41.7775 45.3333 41.4997C42.3333 39.9997 39.3055 38.8747 36.25 38.1247C33.1944 37.3747 30.1111 36.9997 27 36.9997C23.8889 36.9997 20.8055 37.3747 17.75 38.1247C14.6944 38.8747 11.6667 39.9997 8.66666 41.4997C8.16666 41.7775 7.76388 42.1663 7.45833 42.6663C7.15277 43.1663 6.99999 43.7219 6.99999 44.333V46.9997ZM27 20.333C28.8333 20.333 30.4028 19.6802 31.7083 18.3747C33.0139 17.0691 33.6667 15.4997 33.6667 13.6663C33.6667 11.833 33.0139 10.2636 31.7083 8.95801C30.4028 7.65245 28.8333 6.99967 27 6.99967C25.1667 6.99967 23.5972 7.65245 22.2917 8.95801C20.9861 10.2636 20.3333 11.833 20.3333 13.6663C20.3333 15.4997 20.9861 17.0691 22.2917 18.3747C23.5972 19.6802 25.1667 20.333 27 20.333Z" }) })
  }
), Na = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: /* @__PURE__ */ t.jsx(
      "path",
      {
        fill: "currentcolor",
        fillRule: "nonzero",
        d: "m20 50-3.5-3.563L22.938 40H5v-5h17.938L16.5 28.562 20 25l12.5 12.5L20 50Zm20-15L27.5 22.5 40 10l3.5 3.563L37.062 20H55v5H37.062l6.438 6.438L40 35Z"
      }
    )
  }
), Sa = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsxs(
  "svg",
  {
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: [
      /* @__PURE__ */ t.jsx(
        "path",
        {
          fill: "currentcolor",
          fillRule: "nonzero",
          d: "M30 53.833c-4.044 0-7.764-.92-11.158-2.762-3.394-1.842-6.175-4.298-8.342-7.367v3.63c0 .613-.207 1.128-.623 1.543-.415.415-.93.623-1.543.623-.614 0-1.129-.208-1.544-.623-.415-.415-.623-.93-.623-1.544v-8.666c0-.614.208-1.129.623-1.544.415-.415.93-.623 1.544-.623H17c.614 0 1.129.208 1.544.623.415.415.623.93.623 1.544 0 .613-.208 1.128-.623 1.543-.415.416-.93.623-1.544.623h-3.195c1.733 2.6 4.017 4.695 6.852 6.284C23.49 48.705 26.606 49.5 30 49.5c5.092 0 9.47-1.697 13.136-5.092 3.665-3.394 5.75-7.565 6.256-12.512.072-.578.325-1.038.758-1.382A2.373 2.373 0 0 1 51.667 30c.614 0 1.137.19 1.57.569.434.379.615.84.542 1.38-.252 3.07-1.047 5.932-2.383 8.586a24.106 24.106 0 0 1-5.2 6.934c-2.13 1.968-4.577 3.52-7.34 4.658-2.762 1.137-5.714 1.706-8.856 1.706ZM30 10.5c-5.091 0-9.47 1.697-13.135 5.091-3.665 3.395-5.75 7.566-6.256 12.513-.073.578-.325 1.038-.759 1.381A2.372 2.372 0 0 1 8.334 30c-.614 0-1.138-.19-1.571-.569-.434-.38-.614-.84-.542-1.381.253-3.07 1.047-5.931 2.383-8.586a24.103 24.103 0 0 1 5.2-6.933c2.131-1.968 4.578-3.52 7.34-4.658C23.907 6.735 26.86 6.166 30 6.166c4.045 0 7.764.921 11.159 2.763 3.394 1.842 6.175 4.297 8.341 7.367v-3.63c0-.613.208-1.128.623-1.543.416-.415.93-.623 1.544-.623s1.128.207 1.544.623c.415.415.623.93.623 1.543v8.667c0 .614-.208 1.129-.623 1.544-.416.415-.93.623-1.544.623H43c-.614 0-1.128-.208-1.543-.623-.416-.415-.623-.93-.623-1.544s.207-1.128.623-1.544c.415-.415.93-.623 1.543-.623h3.196c-1.733-2.6-4.017-4.694-6.852-6.283C36.51 11.294 33.394 10.5 30 10.5Z"
        }
      ),
      /* @__PURE__ */ t.jsx(
        "path",
        {
          fill: "currentcolor",
          fillRule: "nonzero",
          d: "M23.831 28.957a7.11 7.11 0 0 0 .017 2.196h6.599c.808 0 1.463.658 1.463 1.471 0 .813-.655 1.472-1.463 1.472h-5.385a7.005 7.005 0 0 0 5.711 2.96c1.937 0 3.532-.64 4.768-1.793a1.458 1.458 0 0 1 2.068.077c.55.596.516 1.527-.077 2.08-1.81 1.69-4.129 2.58-6.759 2.58-4.034 0-7.514-2.427-9.073-5.904h-2.236A1.468 1.468 0 0 1 18 32.624c0-.813.655-1.471 1.463-1.471h1.43a10.13 10.13 0 0 1-.012-2.196h-1.418A1.467 1.467 0 0 1 18 27.485c0-.813.655-1.471 1.463-1.471h2.189C23.186 22.478 26.697 20 30.773 20c2.558 0 4.955 1.023 6.716 2.541.614.529.685 1.458.159 2.075a1.458 1.458 0 0 1-2.064.16c-1.284-1.107-3.02-1.833-4.811-1.833a7.008 7.008 0 0 0-5.788 3.07h5.462c.808 0 1.463.66 1.463 1.472 0 .813-.655 1.472-1.463 1.472H23.83Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Ia = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsxs(
  "svg",
  {
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: [
      /* @__PURE__ */ t.jsx(
        "path",
        {
          fill: "currentcolor",
          fillRule: "nonzero",
          d: "M12.5 40V27.5c0-.708.24-1.302.719-1.781.479-.48 1.073-.719 1.781-.719s1.302.24 1.781.719c.48.479.719 1.073.719 1.781V40c0 .708-.24 1.302-.719 1.781-.479.48-1.073.719-1.781.719s-1.302-.24-1.781-.719c-.48-.479-.719-1.073-.719-1.781Zm15 0V27.5c0-.708.24-1.302.719-1.781.479-.48 1.073-.719 1.781-.719s1.302.24 1.781.719c.48.479.719 1.073.719 1.781V40c0 .708-.24 1.302-.719 1.781-.479.48-1.073.719-1.781.719s-1.302-.24-1.781-.719c-.48-.479-.719-1.073-.719-1.781Zm25-20H7.25a2.17 2.17 0 0 1-1.594-.656A2.17 2.17 0 0 1 5 17.75v-1.375c0-.458.115-.854.344-1.188.229-.333.531-.604.906-.812l21.5-10.75a5.22 5.22 0 0 1 2.25-.5 5.22 5.22 0 0 1 2.25.5l21.375 10.688c.458.208.802.52 1.031.937.23.417.344.854.344 1.313v.937c0 .708-.24 1.302-.719 1.781-.479.48-1.073.719-1.781.719Zm-36.313-5h27.625L30 8.125 16.187 15ZM7.5 52.5c-.708 0-1.302-.24-1.781-.719C5.239 51.302 5 50.708 5 50s.24-1.302.719-1.781c.479-.48 1.073-.719 1.781-.719h25.125c.708 0 1.302.24 1.781.719.48.479.719 1.073.719 1.781s-.24 1.302-.719 1.781c-.479.48-1.073.719-1.781.719H7.5ZM45 31.875c-.708 0-1.302-.24-1.781-.719-.48-.479-.719-1.073-.719-1.781V27.5c0-.708.24-1.302.719-1.781.479-.48 1.073-.719 1.781-.719s1.302.24 1.781.719c.48.479.719 1.073.719 1.781v1.875c0 .708-.24 1.302-.719 1.781-.479.48-1.073.719-1.781.719Z"
        }
      ),
      /* @__PURE__ */ t.jsx(
        "path",
        {
          fill: "currentcolor",
          fillRule: "nonzero",
          d: "M44.831 44.957a7.11 7.11 0 0 0 .017 2.196h6.599c.808 0 1.463.658 1.463 1.471 0 .813-.655 1.472-1.463 1.472h-5.385a7.005 7.005 0 0 0 5.711 2.96c1.937 0 3.532-.64 4.768-1.793a1.458 1.458 0 0 1 2.068.077c.55.596.516 1.527-.077 2.08-1.81 1.69-4.129 2.58-6.759 2.58-4.034 0-7.514-2.427-9.073-5.904h-2.236A1.468 1.468 0 0 1 39 48.624c0-.813.655-1.471 1.464-1.471h1.429a10.13 10.13 0 0 1-.012-2.196h-1.417A1.467 1.467 0 0 1 39 43.485c0-.813.655-1.471 1.464-1.471h2.188C44.186 38.478 47.697 36 51.773 36c2.558 0 4.955 1.023 6.716 2.541.614.529.685 1.458.159 2.075a1.458 1.458 0 0 1-2.064.16c-1.284-1.107-3.02-1.833-4.811-1.833a7.008 7.008 0 0 0-5.788 3.07h5.462c.808 0 1.463.66 1.463 1.472 0 .813-.655 1.472-1.463 1.472H44.83Z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), ka = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsxs(
  "svg",
  {
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: [
      /* @__PURE__ */ t.jsx(
        "mask",
        {
          width: 45,
          height: 45,
          x: 0,
          y: 0,
          maskUnits: "userSpaceOnUse",
          style: {
            maskType: "alpha"
          },
          children: /* @__PURE__ */ t.jsx("path", { fill: "currentcolor", fillRule: "nonzero", d: "M0 0h44.92v44.92H0z" })
        }
      ),
      /* @__PURE__ */ t.jsx(
        "path",
        {
          fill: "currentcolor",
          fillRule: "nonzero",
          d: "M18.608 13.462h13.318c.398 0 .731.135 1 .404.27.269.404.603.404 1 0 .398-.134.732-.404 1a1.359 1.359 0 0 1-1 .404H18.61c-.398 0-.732-.135-1-.404a1.359 1.359 0 0 1-.404-1c0-.399.134-.732.404-1a1.358 1.358 0 0 1 1-.404Zm0 5.4h13.318c.398 0 .731.134 1 .403.27.269.404.602.404 1s-.134.732-.404 1a1.358 1.358 0 0 1-1 .404H18.61c-.398 0-.732-.135-1-.404a1.36 1.36 0 0 1-.404-1c0-.399.134-.732.404-1a1.359 1.359 0 0 1 1-.404Zm-7.378 21.38c-1.308 0-2.415-.454-3.32-1.36-.906-.905-1.36-2.012-1.36-3.32v-3.707c0-.48.163-.881.487-1.206a1.637 1.637 0 0 1 1.206-.486h3.923v-22.1c0-.93.331-1.727.994-2.39a3.258 3.258 0 0 1 2.39-.993h19.436c.93 0 1.727.331 2.39.994.662.662.993 1.459.993 2.39v11.049c0 .398-.135.731-.404 1a1.36 1.36 0 0 1-1 .404c-.398 0-.732-.135-1-.404a1.36 1.36 0 0 1-.403-1V8.063a.56.56 0 0 0-.162-.414.56.56 0 0 0-.414-.162H15.549a.56.56 0 0 0-.414.162.56.56 0 0 0-.162.414v22.1h5.94c.397 0 .73.135 1 .404.268.269.403.602.403 1s-.135.732-.403 1a1.36 1.36 0 0 1-1 .403H9.357v2.592c0 .53.18.975.538 1.334.36.358.804.538 1.334.538h9.682c.398 0 .731.134 1 .404.27.269.404.602.404 1s-.135.731-.403 1a1.36 1.36 0 0 1-1 .403H11.23Zm15.19-1.693v-2.548c0-.22.04-.434.122-.64a1.69 1.69 0 0 1 .385-.573l9.653-9.607a2.01 2.01 0 0 1 .754-.49c.27-.095.54-.143.81-.143a2.275 2.275 0 0 1 1.604.662l1.73 1.75c.202.232.358.485.469.756.11.27.165.542.165.813 0 .271-.05.547-.15.828-.102.28-.262.537-.483.77l-9.607 9.607a1.678 1.678 0 0 1-1.213.507h-2.548c-.48 0-.881-.162-1.205-.486a1.637 1.637 0 0 1-.487-1.206Zm2.23-.54h1.779l6.075-6.104-.86-.89-.87-.877-6.123 6.094v1.778Zm6.994-6.993-.87-.878 1.73 1.767-.86-.89Z"
        }
      )
    ]
  }
), La = ({
  width: e,
  height: n,
  color: r,
  onClick: a,
  className: s
}) => /* @__PURE__ */ t.jsxs(
  "svg",
  {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: n,
    color: r,
    onClick: a,
    className: s,
    children: [
      /* @__PURE__ */ t.jsx(
        "mask",
        {
          id: "mask0_4221_33989",
          style: { maskType: "alpha" },
          maskUnits: "userSpaceOnUse",
          x: "0",
          y: "0",
          width: "25",
          height: "25",
          children: /* @__PURE__ */ t.jsx("rect", { x: "0.5", y: "0.262451", width: "24", height: "24", fill: "#D9D9D9" })
        }
      ),
      /* @__PURE__ */ t.jsx("g", { mask: "url(#mask0_4221_33989)", children: /* @__PURE__ */ t.jsx(
        "path",
        {
          d: "M5.5 22.2625C4.95 22.2625 4.47917 22.0666 4.0875 21.675C3.69583 21.2833 3.5 20.8125 3.5 20.2625V6.26245C3.5 5.71245 3.69583 5.24162 4.0875 4.84995C4.47917 4.45828 4.95 4.26245 5.5 4.26245H6.5V2.26245H8.5V4.26245H16.5V2.26245H18.5V4.26245H19.5C20.05 4.26245 20.5208 4.45828 20.9125 4.84995C21.3042 5.24162 21.5 5.71245 21.5 6.26245V20.2625C21.5 20.8125 21.3042 21.2833 20.9125 21.675C20.5208 22.0666 20.05 22.2625 19.5 22.2625H5.5ZM5.5 20.2625H19.5V10.2625H5.5V20.2625ZM5.5 8.26245H19.5V6.26245H5.5V8.26245Z",
          fill: "#444444"
        }
      ) })
    ]
  }
);
var F = /* @__PURE__ */ ((e) => (e.crossedOutEye = "crossedOutEye", e.eye = "eye", e.addMore = "addMore", e.art = "art", e.arrowRight = "arrowRight", e.checkCircle = "checkCircle", e.checkmark = "checkmark", e.close = "close", e.informationFilled = "InformationFilled", e.chevronDown = "chevronDown", e.lock = "lock", e.chevronRight = "chevronRight", e.userFilled = "userFilled", e.hintCircle = "hintCircle", e.plusCircle = "plusCircle", e.logo = "logo", e.formEdit = "formEdit", e.update = "update", e.user = "user", e.edit = "edit", e.error = "error", e.download = "download", e.demoDonut = "demoDonut", e.nextCrossed = "nextCrossed", e.pdf = "pdf", e.person = "person", e.upload = "upload", e.delete = "delete", e.payIn = "payIn", e.changeSavings = "changeSavings", e.banknoteIn = "banknoteIn", e.banknoteOut = "banknoteOut", e.piggyBankUnite = "piggyBankUnite", e.comfort = "comfort", e.individual = "individual", e.donut30 = "donut30", e.donut60 = "donut60", e.donut80 = "donut80", e.donut100 = "donut100", e.leaf = "leaf", e.quarterCircleArrow = "quarterCircleArrow", e.exit = "exit", e.lightBulb = "lightBulb", e.menuUser = "menuUser", e.exchange = "exchange", e.chartArrowUp = "chartArrowUp", e.standardStopwatch = "standardStopwatch", e.progressCircleFull = "progressCircleFull", e.cancelCircle = "cancelCircle", e.nextCircle = "nextCircle", e.headset = "headset", e.filter = "filter", e.epostfachCheckCirkle = "epostfachCheckCirkle", e.feeModal = "feeModal", e.usersJoint = "usersJoint", e.compareArrows = "compareArrows", e.assetManagementFee = "assetManagementFee", e.entranceFee = "entranceFee", e.contactEdit = "contactEdit", e.calendar = "calendar", e))(F || {});
const Ea = {
  crossedOutEye: Cs,
  eye: Ns,
  addMore: Ss,
  art: Is,
  arrowRight: ks,
  checkCircle: Ls,
  checkmark: Es,
  close: $s,
  InformationFilled: Ms,
  chevronDown: Os,
  lock: Ps,
  chevronRight: Ts,
  userFilled: Rs,
  hintCircle: As,
  plusCircle: zs,
  logo: Fs,
  formEdit: Vs,
  update: Ds,
  user: Bs,
  error: Zs,
  download: Hs,
  demoDonut: qs,
  nextCrossed: Gs,
  pdf: Us,
  person: ga,
  upload: Ys,
  delete: Ws,
  payIn: Ks,
  changeSavings: Js,
  banknoteIn: Xs,
  banknoteOut: Qs,
  piggyBankUnite: ea,
  edit: ta,
  comfort: na,
  individual: ra,
  donut30: sa,
  donut60: aa,
  donut80: oa,
  donut100: ia,
  leaf: la,
  quarterCircleArrow: ca,
  exit: da,
  lightBulb: ua,
  menuUser: ma,
  exchange: ha,
  chartArrowUp: xa,
  standardStopwatch: fa,
  progressCircleFull: pa,
  cancelCircle: va,
  nextCircle: ba,
  headset: ja,
  filter: wa,
  epostfachCheckCirkle: ya,
  feeModal: _a,
  usersJoint: Ca,
  compareArrows: Na,
  assetManagementFee: Sa,
  entranceFee: Ia,
  contactEdit: ka,
  calendar: La
};
var X = /* @__PURE__ */ ((e) => (e.xs = "xs", e.s = "s", e.m = "m", e.l = "l", e.xl = "xl", e.xxl = "xxl", e.demo = "demo", e))(X || {});
const $a = {
  xs: {
    width: 12,
    height: 12
  },
  s: {
    width: 16,
    height: 16
  },
  m: {
    width: 24,
    height: 24
  },
  l: {
    width: 32,
    height: 32
  },
  xl: {
    width: 48,
    height: 48
  },
  xxl: {
    width: 60,
    height: 60
  },
  // TODO Created for demo. Should be deleted
  demo: {
    width: 80,
    height: 80
  }
}, Z = ({
  size: e,
  name: n,
  color: r,
  onClick: a,
  className: s,
  containerClassName: o = ""
}) => {
  const l = Ea[n], i = $a[e];
  return l ? /* @__PURE__ */ t.jsx("div", { id: n, className: o, children: /* @__PURE__ */ t.jsx(
    l,
    {
      className: s,
      color: r,
      width: i.width,
      height: i.height,
      onClick: a
    }
  ) }) : null;
};
Z.defaultProps = {
  size: "m",
  color: "",
  onClick: void 0,
  className: ""
};
const A = (...e) => e.map(
  (n) => n && typeof n == "object" ? Object.keys(n).filter((r) => n[r]) : n
).reduce((n, r) => n.concat(r), []).filter((n) => n).join(" "), fn = "N/A", Ma = (e, n) => e + encodeURIComponent(n), Cr = (e = 2) => {
  const n = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  return Array(e).fill(0).reduce(
    (a) => a + n.charAt(Math.floor(Math.random() * n.length)),
    ""
  );
}, de = (e, n) => e.replace(/(\$\w+?\$)/g, (r) => n[r] || r), ue = (e) => Number(e).toLocaleString("de-DE", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
}), _e = (e) => Number(e).toLocaleString("de-DE", {
  style: "currency",
  currency: "EUR",
  minimumFractionDigits: 2
}), Nr = (e) => !isNaN(Number(e)), un = (e, n = 2) => {
  if (!Nr) return fn;
  const r = Math.abs(Number(Number(e).toFixed(n))) === Number(0 .toFixed(n)) ? 0 : e;
  return ue(r);
}, zt = (e, { multiplier: n } = { multiplier: 1 }) => Nr(e) ? `${un(Number(e) * n)}%` : `${fn} %`, Sr = (e) => {
  if (typeof e == "string") {
    const n = e.split("_");
    return n.length === 2 ? n[1] : e;
  }
  return "";
}, Ke = {
  1: "Januar",
  2: "Februar",
  3: "März",
  4: "April",
  5: "Mai",
  6: "Juni",
  7: "Juli",
  8: "August",
  9: "September",
  10: "Oktober",
  11: "November",
  12: "Dezember"
}, Re = (e) => {
  const n = new Date(e);
  if (typeof n.getTime() == "number") {
    const r = n.getFullYear(), a = n.getMonth() + 1, s = n.getDate(), o = s < 10 ? `0${s}` : String(s), l = a < 10 ? `0${a}` : String(a);
    return `${o}.${l}.${r}`;
  }
  return fn;
}, Ir = (e) => {
  if (typeof e.getTime() == "number") {
    const n = e.getFullYear(), r = e.getMonth() + 1, a = e.getDate(), s = a < 10 ? `0${a}` : String(a), o = r < 10 ? `0${r}` : String(r);
    return `${n}-${o}-${s}`;
  }
  return fn;
}, Oa = "_text_16m2z_1", Pa = "_bold_16m2z_9", Ta = "_regular_16m2z_15", Ra = "_md_16m2z_21", Aa = "_sm_16m2z_29", za = "_left_16m2z_39", Fa = "_center_16m2z_47", Va = "_right_16m2z_55", rn = {
  text: Oa,
  bold: Pa,
  regular: Ta,
  md: Ra,
  sm: Aa,
  left: za,
  center: Fa,
  right: Va
}, me = ({
  children: e,
  className: n,
  fontSize: r = "md",
  fontWeight: a = "regular",
  textAlign: s = "left",
  testId: o
}) => {
  const l = A(
    rn.text,
    { [rn[r]]: !!r },
    { [rn[a]]: !!a },
    rn[s],
    n
  ), i = typeof e == "string" ? e.split("<br/>") : e;
  return Array.isArray(i) && typeof e == "string" ? /* @__PURE__ */ t.jsx(t.Fragment, { children: i.map((c, d) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ t.jsx(Ie.Fragment, { children: c.length === 0 ? /* @__PURE__ */ t.jsx("br", {}) : /* @__PURE__ */ t.jsx("p", { "data-cy": o, className: l, children: c }) }, `${c}${d}`)
  )) }) : /* @__PURE__ */ t.jsx("p", { "data-cy": o, className: l, children: e });
}, Da = "_text_dv5g9_1", Ba = "_bold_dv5g9_13", Za = "_regular_dv5g9_19", Ha = "_xs_dv5g9_25", qa = "_sm_dv5g9_33", Ga = "_md_dv5g9_41", Ua = "_lg_dv5g9_51", Ya = "_xl_dv5g9_61", Cn = {
  text: Da,
  bold: Ba,
  regular: Za,
  xs: Ha,
  sm: qa,
  md: Ga,
  lg: Ua,
  xl: Ya
}, w = ({
  children: e,
  className: n,
  fontSize: r = "md",
  fontWeight: a = "regular",
  textAlign: s = "left",
  textClass: o,
  testId: l
}) => {
  const i = A(
    Cn.text,
    { [Cn[r]]: !!r },
    { [Cn[a]]: !!a },
    { [s]: !!s },
    o,
    n
  ), c = typeof e == "string" ? e.split("<br/>") : e;
  return Array.isArray(c) && typeof e == "string" ? /* @__PURE__ */ t.jsx(t.Fragment, { children: c.map((d, u) => (
    // eslint-disable-next-line react/no-array-index-key
    /* @__PURE__ */ t.jsx(Ie.Fragment, { children: d.length === 0 ? /* @__PURE__ */ t.jsx("br", {}) : /* @__PURE__ */ t.jsx("p", { "data-cy": l, className: i, children: d }) }, `${d}${u}`)
  )) }) : /* @__PURE__ */ t.jsx("p", { "data-cy": l, className: i, children: e });
}, S = new bs(), bl = ({ heading: e, message: n }) => {
  const r = S.get("useLanguage"), { t: a } = r();
  return /* @__PURE__ */ t.jsxs("div", { className: "flex flex-col items-center gap-8", children: [
    /* @__PURE__ */ t.jsx(
      Z,
      {
        size: X.xxl,
        name: F.error,
        color: "var(--secondary-dark)"
      }
    ),
    /* @__PURE__ */ t.jsx(w, { fontSize: "xl", textAlign: "center", children: a(e || "error.warning1") }),
    /* @__PURE__ */ t.jsx(me, { textAlign: "center", children: a(n || "error.technical-error1") })
  ] });
}, Wa = "_medium_xpm77_53", Ka = "_big_xpm77_93", Nn = {
  "popover-background": "_popover-background_xpm77_1",
  "popover-content": "_popover-content_xpm77_19",
  medium: Wa,
  "medium-small": "_medium-small_xpm77_73",
  big: Ka
};
var Rt = /* @__PURE__ */ ((e) => (e.TOP = "top", e.RIGHT = "right", e.BOTTOM = "bottom", e.LEFT = "left", e.BOTTOM_RIGHT = "bottom-right", e.BOTTOM_LEFT = "bottom-left", e))(Rt || {});
const Ja = ({
  placement: e,
  containerXCoordinate: n,
  contentWidth: r,
  containerWidth: a
}) => e === "top" || e === "bottom" ? n - r / 2 : e === "left" || e === "bottom-left" ? n - r : e === "right" || e === "bottom-right" ? n + a : n - r / 2, Xa = ({
  placement: e,
  containerYCoordinate: n,
  contentHeight: r,
  containerHeight: a
}) => e === "bottom" || e === "bottom-left" || e === "bottom-right" ? n + a : e === "left" || e === "right" ? n - r / 2 : e === "top" ? n - r : n, Qa = ({
  defaultXCoordinate: e,
  contentWidth: n,
  screenWidth: r
}) => e < 0 ? 10 : e + n > r ? r - 10 - n : e, eo = ({
  defaultYCoordinate: e,
  contentHeight: n,
  screenHeight: r
}) => e < 0 ? 10 : e + n > r ? r - 10 - n : e;
var Kt = /* @__PURE__ */ ((e) => (e.SMALL = "small", e.MEDIUM = "medium", e.MEDIUM_SMALL = "medium-small", e.BIG = "big", e))(Kt || {});
const to = {
  small: 260,
  "medium-small": 320,
  medium: 380,
  big: 520
}, At = ({
  children: e,
  content: n,
  placement: r = Rt.BOTTOM,
  className: a,
  ariaLabel: s = "Info Popover",
  size: o = "small",
  id: l
}) => {
  const [i, c] = ce(!1), d = ye(null), u = ye(null), x = A(Nn["popover-content"], {
    [Nn[o]]: !!o
  }), h = A("pointer", a), f = () => {
    c(!i);
  }, g = (b) => {
    (b.code === "Enter" || b.code === "NumpadEnter") && c(!i);
  }, y = typeof n == "string" ? n.split("<br/>") : n;
  ve(() => {
    var j, _;
    const b = (j = d == null ? void 0 : d.current) == null ? void 0 : j.getBoundingClientRect(), v = (_ = u == null ? void 0 : u.current) == null ? void 0 : _.getBoundingClientRect();
    if (b && (d != null && d.current) && v && (u != null && u.current)) {
      const I = window.innerWidth, k = window.innerHeight, O = to[o], C = O < I - 20 ? O : I - 20, R = v.x, P = v.y, M = b.height, D = M <= k ? M : k - 20, B = Ja({
        placement: r,
        containerXCoordinate: R,
        contentWidth: C,
        containerWidth: v.width
      }), J = Xa({
        placement: r,
        containerYCoordinate: P,
        contentHeight: D,
        containerHeight: v.height
      }), ee = Qa({
        defaultXCoordinate: B,
        contentWidth: C,
        screenWidth: I
      }), T = eo({
        defaultYCoordinate: J,
        contentHeight: D,
        screenHeight: k
      });
      d.current.style.left = `${ee}px`, d.current.style.top = `${T}px`, d.current.style.height = `${D}px`, d.current.style.width = `${C}px`;
    }
  }, [i, r, o]);
  const p = ps();
  return /* @__PURE__ */ t.jsxs(
    "div",
    {
      onClick: f,
      className: h,
      tabIndex: 0,
      onKeyDown: g,
      role: "button",
      id: l,
      ref: u,
      "aria-haspopup": "true",
      "aria-expanded": i,
      "aria-controls": p,
      "aria-label": s,
      children: [
        i && /* @__PURE__ */ t.jsx(t.Fragment, { children: hn(
          /* @__PURE__ */ t.jsx(
            "div",
            {
              onClick: f,
              className: Nn["popover-background"],
              children: /* @__PURE__ */ t.jsx(
                "div",
                {
                  ref: d,
                  className: x,
                  role: "dialog",
                  tabIndex: 0,
                  id: p,
                  children: Array.isArray(y) && typeof n == "string" ? y.map((b, v) => (
                    // eslint-disable-next-line react/no-array-index-key
                    /* @__PURE__ */ t.jsx(Ie.Fragment, { children: b.length === 0 ? /* @__PURE__ */ t.jsx("br", {}) : /* @__PURE__ */ t.jsx("p", { children: b }) }, `${b}${v}`)
                  )) : n
                }
              )
            }
          ),
          document.body
        ) }),
        e && e
      ]
    }
  );
}, no = "_text_1pwe3_1", ro = "_light_1pwe3_19", so = "_popoverContainer_1pwe3_41", ao = "_left_1pwe3_57", oo = "_right_1pwe3_67", io = "_center_1pwe3_77", sn = {
  text: no,
  light: ro,
  popoverContainer: so,
  left: ao,
  right: oo,
  center: io
}, Le = ({
  size: e = 1,
  children: n,
  info: r,
  light: a = !1,
  textAlign: s = "left",
  className: o = ""
}) => {
  const l = e > 3 ? X.s : X.m, i = {
    1: "h1",
    2: "h2",
    3: "h3",
    4: "h4",
    5: "h5",
    6: "h6"
  }, c = i[String(e)] ? i[e] : "h1", d = A(
    sn.text,
    { [sn.light]: a },
    { [sn[s]]: !!s },
    o
  );
  return /* @__PURE__ */ t.jsxs(c, { className: d, children: [
    n,
    r && /* @__PURE__ */ t.jsx("div", { className: sn.popoverContainer, children: /* @__PURE__ */ t.jsx(
      At,
      {
        placement: r.placement,
        content: r.text,
        size: r.size,
        children: /* @__PURE__ */ t.jsx(
          Z,
          {
            name: F.informationFilled,
            color: "var(--primary-darker)",
            size: l
          }
        )
      }
    ) })
  ] });
}, lo = "_card_1e3pa_1", ar = {
  card: lo
}, Ee = ({ children: e, className: n }) => /* @__PURE__ */ t.jsx("div", { className: A(ar.card, n), children: /* @__PURE__ */ t.jsx("div", { className: A(ar["card-body"]), children: e }) });
Ee.defaultProps = {
  className: ""
};
const jl = {
  monthly: "monatlich",
  biMonthly: "zweimonatlich",
  quarterly: "vierteljaehrlich",
  semiAnnually: "halbjaehrlich",
  annually: "jaehrlich"
}, Rn = {
  3: "monthly",
  9: "biMonthly",
  6: "quarterly",
  7: "semiAnnually",
  8: "annually"
}, wl = {
  3: 12,
  // monthly
  9: 6,
  // biMonthly
  6: 4,
  // quarterly
  7: 2,
  // semiAnnually
  8: 1
  // annually
}, kr = {
  monthly: "monatlich",
  biMonthly: "zweimonatlich",
  quarterly: "vierteljährlich",
  semiAnnually: "halbjährlich",
  annually: "jährlich"
}, yl = 0, _l = 1, Cl = 2, Nl = "budgetarySurplus", Sl = "currentProperty", Vn = /* @__PURE__ */ new Date(), co = Vn.getMonth() + 1, uo = Vn.getFullYear(), xt = ({
  day: e,
  month: n,
  year: r
}) => `${r}-${n < 10 ? "0" : ""}${n}-${e < 10 ? "0" : ""}${e}`, Dn = (e, n = null) => {
  let r = Vn.getDate() + 1, a = co, s = uo;
  if (n) {
    const i = new Date(n);
    r = i.getDate() + 1, a = i.getMonth() + 1, s = i.getFullYear();
  }
  if (Number(e) <= r && a !== 12) {
    const i = a + 1, c = `${e}. ${Ke[String(i)]} ${s}`, d = xt({
      day: e,
      month: i,
      year: s
    });
    return { renderExecutionDay: c, requestExecutionDay: d };
  }
  if (Number(e) <= r && a === 12) {
    const c = s + 1, d = `${e}. ${Ke[1]} ${c}`, u = xt({
      day: Number(e),
      month: 1,
      year: c
    });
    return { renderExecutionDay: d, requestExecutionDay: u };
  }
  const o = `${e}. ${Ke[a]} ${s}`, l = xt({
    day: e,
    month: a,
    year: s
  });
  return { renderExecutionDay: o, requestExecutionDay: l };
};
var Ve = /* @__PURE__ */ ((e) => (e.timeLimitToggle = "timeLimitToggle", e.timeLimitYear = "timeLimitYear", e.timeLimitMonth = "timeLimitMonth", e.startIncreaseYear = "startIncreaseYear", e.startIncreaseMonth = "startIncreaseMonth", e))(Ve || {});
const Lr = /* @__PURE__ */ new Date();
Lr.getMonth() + 1;
const mo = Lr.getFullYear(), ho = 4, xo = Array.from(
  { length: ho },
  (e, n) => n + mo
), fo = xo.map((e) => ({
  label: String(e),
  value: String(e)
})), go = Object.entries(Ke).map(
  ([e, n]) => ({ label: n, value: e })
), Bn = ({
  timeLimitYear: e,
  timeLimitMonth: n,
  executionDay: r,
  transactionDate: a
}) => {
  if (r && e && n) {
    const { requestExecutionDay: s } = Dn(
      Number(r),
      a
    ), o = new Date(s).getTime();
    return new Date(
      xt({
        day: Number(r),
        month: Number(n),
        year: Number(e)
      })
    ).getTime() > o;
  }
  return !!r;
}, Zn = ({
  timeLimitYear: e,
  timeLimitMonth: n
}) => {
  if (e && n) {
    const r = /* @__PURE__ */ new Date(), a = new Date(r).setMonth(
      r.getMonth() + 36
    ), s = new Date(
      xt({
        day: 1,
        month: Number(n),
        year: Number(e)
      })
    ).getTime();
    return a > s;
  }
  return !0;
}, Er = (e, n) => {
  const r = e != null && e.timeLimitToggle && (e != null && e.timeLimitMonth) && (e != null && e.timeLimitYear) ? `${Ke[e.timeLimitMonth]} ${e.timeLimitYear}` : "", a = e != null && e.dynamicSavingsPlan && (e != null && e.startIncreaseYear) && e.startIncreaseMonth ? `${Ke[e.startIncreaseMonth]} ${e.startIncreaseYear}` : "", s = {
    Sparrate: _e(e.monthlySavingsRate),
    Ausführungsdatum: e != null && e.executionDay ? `${e.executionDay}. eines Monats` : "",
    [n("wizard.savings-plan-limit")]: r,
    Ausführungsintervall: e != null && e.quarterSavingsPlan ? kr[e.quarterSavingsPlan] : "",
    Dynamisierungssatz: e != null && e.dynamicSavingsPlan && (e != null && e.annualIncrease) ? zt(Number(e.annualIncrease), { multiplier: 1 }) : "",
    [n("wizard.dynamic-saving-plan-start")]: a
  };
  return Object.keys(s).reduce((l, i) => s[i] ? [...l, { key: `${i}:`, value: s[i] }] : l, []);
}, gt = {
  savingAction: "savingAction",
  transactionDate: "transactionDate",
  monthlySavingsRate: "monthlySavingsRate",
  executionDay: "executionDay",
  quarterSavingsPlan: "quarterSavingsPlan",
  dynamicSavingsPlan: "dynamicSavingsPlan",
  deleteCheckbox: "deleteCheckbox",
  annualIncrease: "annualIncrease",
  startIncreaseYear: Ve.startIncreaseYear,
  startIncreaseMonth: Ve.startIncreaseMonth,
  timeLimitMonth: Ve.timeLimitMonth,
  timeLimitYear: Ve.timeLimitYear,
  timeLimitToggle: Ve.timeLimitToggle,
  budgetarySurplus: "budgetarySurplus"
}, $r = {
  savingAction: "savingAction",
  transactionDate: "transactionDate",
  monthlySavingsRate: "monthlySavingsRate2",
  executionDay: "executionDay2",
  quarterSavingsPlan: "quarterSavingsPlan2",
  dynamicSavingsPlan: "dynamicSavingsPlan2",
  deleteCheckbox: "deleteCheckbox2",
  annualIncrease: "annualIncrease2",
  startIncreaseYear: `${Ve.startIncreaseYear}2`,
  startIncreaseMonth: `${Ve.startIncreaseMonth}2`,
  timeLimitMonth: `${Ve.timeLimitMonth}2`,
  timeLimitYear: `${Ve.timeLimitYear}2`,
  timeLimitToggle: `${Ve.timeLimitToggle}2`,
  budgetarySurplus: "budgetarySurplus"
}, bt = (e = !1) => e ? $r : gt, Oe = {
  CREATE_MODIFY: "1",
  DELETE: "2"
}, po = (e) => [
  {
    value: Oe.CREATE_MODIFY,
    label: e("toggle.savings-plan-change")
  },
  { value: Oe.DELETE, label: e("toggle.savings-plan-extinguish") }
], vo = [
  { value: "5", label: "5. eines Monats" },
  { value: "20", label: "20. eines Monats" }
], bo = [
  { value: "monthly", label: "monatlich", id: 3 },
  { value: "biMonthly", label: "zweimonatlich", id: 9 },
  { value: "quarterly", label: "vierteljährlich", id: 6 },
  { value: "semiAnnually", label: "halbjährlich", id: 8 },
  { value: "annually", label: "jährlich", id: 7 }
], Mr = /* @__PURE__ */ new Date(), An = Mr.getFullYear(), Or = Mr.getMonth() + 1, Pr = Or === 12, jo = Pr ? An + 1 : An, wo = Pr ? 5 : 6, yo = Array.from(
  { length: wo },
  (e, n) => n + jo
), _o = Object.entries(Ke).map(
  ([e, n]) => ({
    label: n,
    value: e
  })
), Co = yo.map((e) => ({
  value: String(e),
  label: String(e)
})), No = ({
  budgetarySurplusVal: e,
  monthlySavingsRateVal: n
}) => !e && e !== 0 || !n ? !0 : e >= n, Tr = ({
  startIncreaseMonth: e,
  startIncreaseYear: n,
  timeLimitYear: r,
  timeLimitMonth: a,
  executionDay: s,
  timeLimitToggle: o
}) => {
  if (!e || !n || !r || !a || !s || !o)
    return !0;
  const l = xt({
    day: Number(s),
    month: Number(a),
    year: Number(r)
  }), i = xt({
    day: 1,
    month: Number(e),
    year: Number(n)
  });
  return new Date(l).getTime() >= new Date(i).getTime();
}, Rr = ({
  startIncreaseYear: e,
  startIncreaseMonth: n,
  executionDay: r,
  transactionDate: a
}) => {
  if (!r || !e || !n)
    return !0;
  const { requestExecutionDay: s } = Dn(
    Number(r),
    a
  ), o = new Date(s).getTime(), l = xt({
    day: 1,
    month: Number(n),
    year: Number(e)
  });
  return new Date(l).getTime() > o;
}, So = (e, n = !1) => {
  const r = bt(n);
  return le().when(
    [
      r.timeLimitMonth,
      r.timeLimitYear,
      r.startIncreaseMonth,
      r.executionDay,
      r.timeLimitToggle,
      r.transactionDate
    ],
    (a, s, o, l, i, c) => Je().required(e("error.validation.dropdown-cannot-be-empty")).test(
      "dynamization_later_end_date",
      e("error.validation.startIncrease-date-later-than-first-endDate"),
      (d) => Tr({
        startIncreaseMonth: o,
        startIncreaseYear: d,
        timeLimitMonth: a,
        timeLimitYear: s,
        executionDay: l,
        timeLimitToggle: i
      })
    ).test(
      "increase_later_execution_day",
      e(
        "error.validation.startIncrease-date-later-than-first-execution-date"
      ),
      (d) => Rr({
        startIncreaseYear: d,
        startIncreaseMonth: o,
        executionDay: l,
        transactionDate: c
      })
    )
  );
}, Io = (e, n = !1) => {
  const r = bt(n);
  return le().when(
    [
      r.timeLimitMonth,
      r.timeLimitYear,
      r.startIncreaseYear,
      r.executionDay,
      r.timeLimitToggle,
      r.transactionDate
    ],
    (a, s, o, l, i, c) => Je().required(e("error.validation.dropdown-cannot-be-empty")).test(
      "dynamization_later_end_date",
      e("error.validation.startIncrease-date-later-than-first-endDate"),
      (d) => Tr({
        startIncreaseMonth: d,
        startIncreaseYear: o,
        timeLimitMonth: a,
        timeLimitYear: s,
        executionDay: l,
        timeLimitToggle: i
      })
    ).test(
      "increase_later_executin_day",
      e(
        "error.validation.startIncrease-date-later-than-first-execution-date"
      ),
      (d) => Rr({
        startIncreaseYear: o,
        startIncreaseMonth: d,
        executionDay: l,
        transactionDate: c
      })
    )
  );
}, ko = (e, n = !1) => {
  const r = bt(n);
  return le().when(
    [r.monthlySavingsRate],
    (a) => Tt().transform(
      (s) => Number.isNaN(s) ? void 0 : Number(s)
    ).required(e("error.validation.cannot-be-empty")).test(
      "is_household_surplus_more_total_saving_amount",
      e("error.saving-plan-rate-greater-than-budgetarySurplus"),
      (s) => No({
        budgetarySurplusVal: s,
        monthlySavingsRateVal: a
      })
    )
  );
}, Lo = (e, n) => Tt().transform(
  (r) => Number.isNaN(r) ? void 0 : Number(r)
).required(
  de(e("error.validation.amount-between"), {
    $minValue$: ue(n.minValues["DekaCore.SavingsPlan"]),
    $maxValue$: ue(n.maxValues["DekaCore.SavingsPlan"])
  })
).min(
  n.minValues["DekaCore.SavingsPlan"],
  de(e("error.validation.amount-between"), {
    $minValue$: ue(n.minValues["DekaCore.SavingsPlan"]),
    $maxValue$: ue(n.maxValues["DekaCore.SavingsPlan"])
  })
).max(
  n.maxValues["DekaCore.SavingsPlan"],
  de(e("error.validation.amount-between"), {
    $minValue$: ue(n.minValues["DekaCore.SavingsPlan"]),
    $maxValue$: ue(n.maxValues["DekaCore.SavingsPlan"])
  })
), Eo = (e) => Je().required(e("error.validation.cannot-be-empty")), $o = (e) => Je().required(e("error.validation.cannot-be-empty")), Mo = (e, n) => Tt().transform(
  (r) => Number.isNaN(r) ? 0 : Number(r)
).required(
  de(e("error.validation.amount-between-percentage"), {
    $minValue$: n.minValues["DekaCore.AnnualIncrease"],
    $maxValue$: n.maxValues["DekaCore.AnnualIncrease"]
  })
).min(
  n.minValues["DekaCore.AnnualIncrease"],
  de(e("error.validation.amount-between-percentage"), {
    $minValue$: n.minValues["DekaCore.AnnualIncrease"],
    $maxValue$: n.maxValues["DekaCore.AnnualIncrease"]
  })
).max(
  n.maxValues["DekaCore.AnnualIncrease"],
  de(e("error.validation.amount-between-percentage"), {
    $minValue$: n.minValues["DekaCore.AnnualIncrease"],
    $maxValue$: n.maxValues["DekaCore.AnnualIncrease"]
  })
), Oo = (e, n = !1) => {
  const r = bt(n);
  return le().when(r.timeLimitToggle, {
    is: !0,
    then: le().when(
      [r.executionDay, r.timeLimitYear, r.transactionDate],
      (a, s, o) => Je().test(
        "date_less_then_36_month",
        e("error.validation.end-date-not-later-than-36-months"),
        (l) => Zn({
          timeLimitMonth: l,
          timeLimitYear: s
        })
      ).test(
        "date_less_then_first_execution_date",
        e("error.validation.end-date-later-than-first-execution-date"),
        (l) => Bn({
          timeLimitMonth: l,
          timeLimitYear: s,
          executionDay: a,
          transactionDate: o
        })
      ).required(e("error.validation.dropdown-cannot-be-empty"))
    )
  });
}, Po = (e, n = !1) => {
  const r = bt(n);
  return le().when(r.timeLimitToggle, {
    is: !0,
    then: le().when(
      [r.timeLimitMonth, r.executionDay, r.transactionDate],
      (a, s, o) => Je().test(
        "date_less_then_36_month",
        e("error.validation.end-date-not-later-than-36-months"),
        (l) => Zn({
          timeLimitMonth: a,
          timeLimitYear: l
        })
      ).test(
        "date_less_then_first_execution_date",
        e("error.validation.end-date-later-than-first-execution-date"),
        (l) => Bn({
          timeLimitMonth: a,
          timeLimitYear: l,
          executionDay: s,
          transactionDate: o
        })
      ).required(e("error.validation.dropdown-cannot-be-empty"))
    )
  });
}, Il = (e) => (n) => ft().shape({
  executionDay: le().when("savingAction", {
    is: Oe.CREATE_MODIFY,
    then: Eo(e)
  }),
  quarterSavingsPlan: le().when("savingAction", {
    is: Oe.CREATE_MODIFY,
    then: $o(e)
  }),
  startIncreaseYear: le().when("dynamicSavingsPlan", {
    is: !0,
    then: le().when("savingAction", {
      is: Oe.CREATE_MODIFY,
      then: So(e)
    })
  }),
  startIncreaseMonth: le().when("dynamicSavingsPlan", {
    is: !0,
    then: le().when("savingAction", {
      is: Oe.CREATE_MODIFY,
      then: Io(e)
    })
  }),
  monthlySavingsRate: le().when("savingAction", {
    is: Oe.CREATE_MODIFY,
    then: Lo(e, n)
  }),
  [gt.budgetarySurplus]: le().when("savingAction", {
    is: Oe.CREATE_MODIFY,
    then: ko(e)
  }),
  annualIncrease: le().when("dynamicSavingsPlan", {
    is: !0,
    then: le().when("savingAction", {
      is: Oe.CREATE_MODIFY,
      then: Mo(e, n)
    })
  }),
  [Ve.timeLimitMonth]: le().when("savingAction", {
    is: Oe.CREATE_MODIFY,
    then: Oo(e)
  }),
  [Ve.timeLimitYear]: le().when("savingAction", {
    is: Oe.CREATE_MODIFY,
    then: Po(e)
  }),
  deleteCheckbox: le().when("savingAction", {
    is: Oe.DELETE,
    then: xn().oneOf([!0], e("error.validation.cannot-be-empty"))
  })
}), To = (e) => {
  const n = {}, r = (e == null ? void 0 : e.attributes) && JSON.parse(e.attributes);
  if (e != null && e.amount && (n.monthlySavingsRate = e == null ? void 0 : e.amount), r != null && r.AnnualIncrease && (n.annualIncrease = r.AnnualIncrease), r != null && r.ExecutionDay && (n.executionDay = r.ExecutionDay), e != null && e.endDate) {
    const a = new Date(e.endDate), s = a && String(a.getFullYear()), o = a && a.getMonth() + 1;
    n.timeLimitToggle = !0, n.timeLimitMonth = String(o), n.timeLimitYear = String(s);
  }
  if (r != null && r.StartIncrease) {
    const a = new Date(r.StartIncrease), s = String(a.getFullYear()), o = a.getMonth() + 1;
    n.startIncreaseMonth = String(o), n.startIncreaseYear = String(s), n.dynamicSavingsPlan = !0;
  }
  return e != null && e.recurrenceTypeId && (n.quarterSavingsPlan = Rn[e.recurrenceTypeId]), n;
}, Ro = (e, n) => Er(To(e), n), kl = {
  annualIncrease: "2",
  startIncreaseYear: String(An + 1),
  startIncreaseMonth: String(Or),
  dynamicSavingsPlan: !0
}, mt = {
  under1000: "under1000",
  "1000to1500": "1000to1500",
  "1500to2500": "1500to2500",
  over2500: "over2500"
}, Ll = (e) => e < 1e3 ? mt.under1000 : e >= 1e3 && e < 1500 ? mt["1000to1500"] : e >= 1500 && e < 2500 ? mt["1500to2500"] : mt.over2500, El = (e, n) => {
  const r = [
    mt.under1000,
    mt["1000to1500"],
    mt["1500to2500"],
    mt.over2500
  ];
  return r.indexOf(e) <= r.indexOf(n);
}, Sn = ({ title: e, value: n }) => /* @__PURE__ */ t.jsxs("div", { className: "flex flex-col gap-2", children: [
  /* @__PURE__ */ t.jsx(w, { fontSize: "sm", children: e }),
  /* @__PURE__ */ t.jsx(w, { fontWeight: "bold", children: n })
] }), Ao = ({ funding: e, onNext: n }) => {
  const r = S.get("useLanguage"), { t: a } = r(), s = kr[Rn[String(e.recurrenceTypeId)]], o = () => {
    if (!n)
      return;
    const u = (e == null ? void 0 : e.attributes) && JSON.parse(e.attributes), x = u != null && u.AnnualIncrease ? String(u.AnnualIncrease) : void 0, h = u != null && u.StartIncrease ? String(new Date(u.StartIncrease).getFullYear()) : void 0, f = u != null && u.StartIncrease ? String(new Date(u.StartIncrease).getMonth() + 1) : void 0, g = {
      savingAction: Oe.CREATE_MODIFY,
      monthlySavingsRate: e != null && e.amount ? String(e.amount) : void 0,
      executionDay: u != null && u.ExecutionDay ? String(u.ExecutionDay) : void 0,
      annualIncrease: x,
      startIncreaseYear: h,
      startIncreaseMonth: f,
      quarterSavingsPlan: e != null && e.recurrenceTypeId ? Rn[e.recurrenceTypeId] : void 0,
      dynamicSavingsPlan: !!(x || h),
      deleteCheckbox: !1
    };
    e != null && e.endDate && (g.timeLimitYear = String(
      new Date(e.endDate).getFullYear()
    ), g.timeLimitMonth = String(
      new Date(e.endDate).getMonth() + 1
    ), g.timeLimitToggle = !0);
    const y = e.id;
    n({ fundingId: y, savingAnswers: g, funding: e });
  }, l = (u) => {
    (u.code === "Enter" || u.code === "NumpadEnter") && o();
  }, i = _e(e.amount), c = Re(e.firstExecutionDate), d = {
    role: n ? "button" : void 0,
    tabIndex: n ? 0 : void 0,
    onKeyDown: n ? l : void 0,
    onClick: n ? o : void 0
  };
  return /* @__PURE__ */ t.jsx(
    "div",
    {
      ...d,
      children: /* @__PURE__ */ t.jsx(Ee, { children: /* @__PURE__ */ t.jsxs("div", { className: "flex flex-wrap items-center justify-between", children: [
        /* @__PURE__ */ t.jsx(
          Sn,
          {
            title: a("saving-plan.attribute-name.amount"),
            value: i
          }
        ),
        /* @__PURE__ */ t.jsx(
          Sn,
          {
            title: a("saving-plan.attribute-name.frequencies"),
            value: s
          }
        ),
        /* @__PURE__ */ t.jsx(
          Sn,
          {
            title: a("saving-plan.attribute-name.first-execution-date"),
            value: c
          }
        ),
        /* @__PURE__ */ t.jsx("div", { className: "bg-success-200 px-6 py-0.5 rounded-badge ", children: /* @__PURE__ */ t.jsx(w, { children: a("saving-plan-active") }) })
      ] }) })
    }
  );
}, zo = ({
  fundings: e,
  onNext: n,
  withHeader: r = !0
}) => {
  const a = S.get("useLanguage"), { t: s } = a();
  if (!e.length)
    return null;
  const o = e.length;
  return /* @__PURE__ */ t.jsxs("div", { className: "space-y-4", children: [
    r && /* @__PURE__ */ t.jsx(Le, { size: 3, children: de(s("current-savings-plans"), {
      $count$: String(o)
    }) }),
    n && /* @__PURE__ */ t.jsx(me, { children: s("savig-plan-selection.text") }),
    e.map((l) => /* @__PURE__ */ t.jsx("div", { className: "px-4", children: /* @__PURE__ */ t.jsx(Ao, { funding: l, onNext: n }) }, l.id))
  ] });
}, Fo = {
  "col-1": "_col-1_1b9r6_1",
  "col-2": "_col-2_1b9r6_3",
  "col-3": "_col-3_1b9r6_5",
  "col-4": "_col-4_1b9r6_7",
  "col-5": "_col-5_1b9r6_9",
  "col-6": "_col-6_1b9r6_11",
  "col-7": "_col-7_1b9r6_13",
  "col-8": "_col-8_1b9r6_15",
  "col-9": "_col-9_1b9r6_17",
  "col-10": "_col-10_1b9r6_19",
  "col-11": "_col-11_1b9r6_21",
  "col-12": "_col-12_1b9r6_23",
  "col-sm-1": "_col-sm-1_1b9r6_25",
  "col-sm-2": "_col-sm-2_1b9r6_27",
  "col-sm-3": "_col-sm-3_1b9r6_29",
  "col-sm-4": "_col-sm-4_1b9r6_31",
  "col-sm-5": "_col-sm-5_1b9r6_33",
  "col-sm-6": "_col-sm-6_1b9r6_35",
  "col-sm-7": "_col-sm-7_1b9r6_37",
  "col-sm-8": "_col-sm-8_1b9r6_39",
  "col-sm-9": "_col-sm-9_1b9r6_41",
  "col-sm-10": "_col-sm-10_1b9r6_43",
  "col-sm-11": "_col-sm-11_1b9r6_45",
  "col-sm-12": "_col-sm-12_1b9r6_47",
  "col-md-1": "_col-md-1_1b9r6_49",
  "col-md-2": "_col-md-2_1b9r6_51",
  "col-md-3": "_col-md-3_1b9r6_53",
  "col-md-4": "_col-md-4_1b9r6_55",
  "col-md-5": "_col-md-5_1b9r6_57",
  "col-md-6": "_col-md-6_1b9r6_59",
  "col-md-7": "_col-md-7_1b9r6_61",
  "col-md-8": "_col-md-8_1b9r6_63",
  "col-md-9": "_col-md-9_1b9r6_65",
  "col-md-10": "_col-md-10_1b9r6_67",
  "col-md-11": "_col-md-11_1b9r6_69",
  "col-md-12": "_col-md-12_1b9r6_71",
  "col-lg-1": "_col-lg-1_1b9r6_73",
  "col-lg-2": "_col-lg-2_1b9r6_75",
  "col-lg-3": "_col-lg-3_1b9r6_77",
  "col-lg-4": "_col-lg-4_1b9r6_79",
  "col-lg-5": "_col-lg-5_1b9r6_81",
  "col-lg-6": "_col-lg-6_1b9r6_83",
  "col-lg-7": "_col-lg-7_1b9r6_85",
  "col-lg-8": "_col-lg-8_1b9r6_87",
  "col-lg-9": "_col-lg-9_1b9r6_89",
  "col-lg-10": "_col-lg-10_1b9r6_91",
  "col-lg-11": "_col-lg-11_1b9r6_93",
  "col-lg-12": "_col-lg-12_1b9r6_95",
  "col-xl-2": "_col-xl-2_1b9r6_97",
  "col-xl-1": "_col-xl-1_1b9r6_99",
  "col-xl-3": "_col-xl-3_1b9r6_101",
  "col-xl-4": "_col-xl-4_1b9r6_103",
  "col-xl-5": "_col-xl-5_1b9r6_105",
  "col-xl-6": "_col-xl-6_1b9r6_107",
  "col-xl-7": "_col-xl-7_1b9r6_109",
  "col-xl-8": "_col-xl-8_1b9r6_111",
  "col-xl-9": "_col-xl-9_1b9r6_113",
  "col-xl-10": "_col-xl-10_1b9r6_115",
  "col-xl-11": "_col-xl-11_1b9r6_117",
  "col-xl-12": "_col-xl-12_1b9r6_119"
}, Vo = ({ children: e, size: n, className: r }) => {
  const a = A(r, {
    [Fo[`col-${n}`]]: !!n
  });
  return /* @__PURE__ */ t.jsx("div", { className: a, children: e });
};
Vo.defaultProps = {
  className: "",
  children: null
};
const Do = "_row_bfniu_1", Bo = {
  row: Do
}, Zo = ({ children: e, className: n }) => {
  const r = A(n, Bo.row);
  return /* @__PURE__ */ t.jsx("div", { className: r, children: e });
};
Zo.defaultProps = {
  className: ""
};
const Ho = "_error_1nd67_1", qo = {
  error: Ho
}, $e = ({ children: e, className: n, id: r }) => /* @__PURE__ */ t.jsx("div", { className: A(qo.error, n), id: r, children: e }), Go = "_expanded_utr2c_31", Uo = "_arrow_utr2c_37", Zt = {
  "collapse-container": "_collapse-container_utr2c_1",
  "main-view": "_main-view_utr2c_17",
  expanded: Go,
  arrow: Uo,
  "is-expanded": "_is-expanded_utr2c_45"
}, Yo = ({
  children: e,
  className: n = "",
  expandedClassName: r = "",
  mainClassName: a = "",
  title: s,
  titleSize: o = "md"
}) => {
  const [l, i] = ce(!1), c = A(
    Zt.arrow,
    {
      [Zt["is-expanded"]]: l
    },
    n
  ), d = A(Zt["main-view"], {
    [a]: !!a
  }), u = A(Zt.expanded, {
    [r]: !!r
  });
  return /* @__PURE__ */ t.jsxs("div", { className: Zt["collapse-container"], children: [
    /* @__PURE__ */ t.jsxs(
      "div",
      {
        className: d,
        onClick: () => i(!l),
        tabIndex: 0,
        onKeyDown: () => i(!l),
        role: "button",
        children: [
          /* @__PURE__ */ t.jsx(w, { fontSize: o, fontWeight: "bold", children: s }),
          /* @__PURE__ */ t.jsx("div", { className: c, children: /* @__PURE__ */ t.jsx(Z, { name: F.chevronDown, size: X.xs }) })
        ]
      }
    ),
    l && /* @__PURE__ */ t.jsx("div", { className: u, children: e })
  ] });
}, Wo = {
  "download-link": "_download-link_19ye1_1"
}, $l = ({
  className: e,
  url: n = "",
  title: r = ""
}) => {
  const a = A("pa-4", Wo["download-link"], e);
  return /* @__PURE__ */ t.jsxs("a", { className: a, href: n, target: "_blank", rel: "noreferrer", children: [
    /* @__PURE__ */ t.jsx("span", { children: /* @__PURE__ */ t.jsx(Z, { size: X.m, name: F.pdf }) }),
    /* @__PURE__ */ t.jsx(w, { fontSize: "sm", fontWeight: "bold", children: r })
  ] });
}, Ko = {
  "ex-ante-container": "_ex-ante-container_19doe_1"
}, Jo = (e) => {
  const n = ";base64,", r = e.indexOf(n) + n.length, a = e.substring(r), s = window.atob(a), o = s.length, l = new Uint8Array(new ArrayBuffer(o));
  for (let i = 0; i < o; i++)
    l[i] = s.charCodeAt(i);
  return new Blob([l]);
}, Xo = () => {
  const { userAgent: e } = navigator;
  return e.match(/chrome|chromium|crios/i) ? "CHROME" : e.match(/firefox|fxios/i) ? "FIREFOX" : e.match(/safari/i) ? "SAFARI" : e.match(/opr/i) ? "OPERA" : e.match(/edg/i) ? "EDGE" : "UNKNOWN";
}, gn = ({ name: e, exAnteFile: n }) => {
  const r = async () => {
    try {
      const a = Xo(), s = a === "SAFARI", o = a === "FIREFOX", l = `data:application/pdf;base64,${n}`, i = document.createElement("a");
      if (s || o) {
        const x = Jo(l), h = URL.createObjectURL(x);
        i.href = h, i.download = `${e}.pdf`, i.click(), URL.revokeObjectURL(h);
        return;
      }
      const d = await (await fetch(l)).blob(), u = URL.createObjectURL(d);
      i.target = "_blank", i.href = u, i.click(), URL.revokeObjectURL(u);
    } catch {
    }
  };
  return /* @__PURE__ */ t.jsxs(
    "div",
    {
      tabIndex: 0,
      role: "link",
      onClick: r,
      className: Ko["ex-ante-container"],
      onKeyUp: r,
      children: [
        /* @__PURE__ */ t.jsx(Z, { name: F.pdf, className: "mr-10" }),
        /* @__PURE__ */ t.jsx(w, { children: e })
      ]
    }
  );
};
var Hn = /* @__PURE__ */ ((e) => (e.BUTTON_TYPE_PRIMARY = "primary", e.BUTTON_TYPE_SECONDARY = "secondary", e.BUTTON_TYPE_THIRD = "third", e.BUTTON_TYPE_DANGER = "danger", e.BUTTON_TYPE_LINK = "link", e))(Hn || {}), Ar = /* @__PURE__ */ ((e) => (e.BUTTON_SIZE_SMALL = "small", e.BUTTON_SIZE_MEDIUM = "medium", e.BUTTON_SIZE_LARGE = "large", e))(Ar || {});
const Qo = "_button_10q85_1", In = {
  button: Qo,
  "button-small": "_button-small_10q85_37",
  "button-large": "_button-large_10q85_49",
  "button-secondary": "_button-secondary_10q85_61",
  "button-third": "_button-third_10q85_89",
  "button-danger": "_button-danger_10q85_117",
  "button-link": "_button-link_10q85_141"
}, _t = ({
  buttonType: e = Hn.BUTTON_TYPE_PRIMARY,
  htmlType: n,
  size: r = Ar.BUTTON_SIZE_MEDIUM,
  children: a,
  className: s,
  onClick: o,
  disabled: l,
  testId: i,
  ...c
}) => {
  const d = A(
    In.button,
    s,
    { [In[`button-${r}`]]: !!r },
    { [In[`button-${e}`]]: !!e }
  );
  return /* @__PURE__ */ t.jsx(
    "button",
    {
      type: n,
      className: d,
      onClick: o,
      disabled: l,
      "data-cy": i,
      ...c,
      children: a
    }
  );
}, ei = "_container_1vyuy_1", ti = "_colored_1vyuy_15", ni = "_hint_1vyuy_31", Ht = {
  container: ei,
  colored: ti,
  "hint-icon": "_hint-icon_1vyuy_31",
  hint: ni,
  "hint-description": "_hint-description_1vyuy_47"
}, De = ({
  text: e,
  textSize: n = "md",
  colored: r = !1,
  description: a,
  info: s = !1,
  className: o,
  button: l
}) => {
  const i = A(o, Ht.container, {
    [Ht.colored]: r
  }), c = s ? F.informationFilled : F.hintCircle;
  return /* @__PURE__ */ t.jsxs("div", { className: i, children: [
    /* @__PURE__ */ t.jsxs("div", { className: Ht.hint, children: [
      /* @__PURE__ */ t.jsx("div", { className: Ht["hint-icon"], children: /* @__PURE__ */ t.jsx(Z, { name: c }) }),
      /* @__PURE__ */ t.jsx(me, { fontSize: n, children: e }),
      l && /* @__PURE__ */ t.jsx(
        _t,
        {
          className: "ml-auto",
          onClick: l.onClick,
          buttonType: Hn.BUTTON_TYPE_LINK,
          children: l.title
        }
      )
    ] }),
    a && /* @__PURE__ */ t.jsx("div", { className: Ht["hint-description"], children: /* @__PURE__ */ t.jsx(me, { fontSize: "sm", children: a }) })
  ] });
}, ri = {
  "icon-button-container": "_icon-button-container_r6x4a_1"
}, Ml = ({
  children: e,
  className: n,
  iconName: r,
  onClick: a,
  colored: s = !0
}) => /* @__PURE__ */ t.jsxs(
  "div",
  {
    tabIndex: 0,
    onKeyDown: a,
    role: "button",
    className: A(ri["icon-button-container"], n),
    onClick: a,
    children: [
      /* @__PURE__ */ t.jsx(
        Z,
        {
          name: r,
          color: s ? "var(--secondary-default)" : ""
        }
      ),
      /* @__PURE__ */ t.jsx(w, { fontSize: "sm", children: e })
    ]
  }
), si = "_container_103r3_1", ai = "_colored_103r3_19", oi = "_xs_103r3_39", ii = "_s_103r3_47", li = "_m_103r3_55", ci = "_l_103r3_63", di = "_xl_103r3_71", ui = "_xxl_103r3_79", kn = {
  container: si,
  colored: ai,
  xs: oi,
  s: ii,
  m: li,
  l: ci,
  xl: di,
  xxl: ui
}, zr = ({
  text: e,
  icon: n,
  className: r,
  onClick: a,
  colored: s = !1,
  fontWeight: o = "bold",
  size: l = X.m,
  testId: i,
  disabled: c
}) => /* @__PURE__ */ t.jsxs(
  "button",
  {
    type: "button",
    onClick: a,
    className: A(
      kn.container,
      { [kn.colored]: s },
      kn[l],
      r
    ),
    "data-cy": i,
    disabled: c,
    children: [
      n && /* @__PURE__ */ t.jsx(Z, { size: X[l], name: n }),
      /* @__PURE__ */ t.jsx(w, { fontWeight: o, children: e })
    ]
  }
), Ln = {
  "icon-text-icon": "_icon-text-icon_1fs9m_1",
  "icon-text": "_icon-text_1fs9m_1",
  "icon-text-description": "_icon-text-description_1fs9m_17"
}, Ol = ({
  iconName: e = "checkCircle",
  text: n,
  description: r,
  className: a
}) => /* @__PURE__ */ t.jsxs("div", { className: A(a), children: [
  /* @__PURE__ */ t.jsxs("div", { className: Ln["icon-text"], children: [
    /* @__PURE__ */ t.jsx("div", { className: A(Ln["icon-text-icon"]), children: /* @__PURE__ */ t.jsx(Z, { name: e }) }),
    /* @__PURE__ */ t.jsx(me, { fontWeight: "bold", children: n })
  ] }),
  r && /* @__PURE__ */ t.jsx("div", { className: Ln["icon-text-description"], children: /* @__PURE__ */ t.jsx(me, { fontSize: "sm", children: r }) })
] }), en = vt((e, n) => {
  const {
    label: r = "",
    info: a = null,
    error: s,
    onChange: o,
    testId: l,
    ...i
  } = e, { id: c, name: d, disabled: u, checked: x } = e, h = A(
    "flex items-center cursor-pointer font-bold group",
    { "cursor-not-allowed": !!u }
  ), f = A(
    "relative !inline-block !h-6 !w-6 !rounded-[--border-radius-small] !text-[--grey-80] hover:!text-[--input-hover-border] !border-2 !border-[--grey-80] !bg-none !bg-transparent hover:!border-[--input-hover-border] checked:!bg-[--accent-default] checked:!border-[--accent-default] checked:hover:!border-[--accent-default] disabled:!border-[--grey-20] checked:hover:disabled:!border-[--grey-20] disabled:!bg-[--grey-20] disabled:!text-white !outline !outline-1 !outline-offset-1 !mr-[0.625rem] cursor-pointer disabled:!cursor-not-allowed disabled:!shadow-none !appearance-none !ring-0",
    {
      "!outline-[--negative-default]": !!s
    },
    {
      "!outline-transparent focus:!outline-[--grey-80]": !s
    }
  ), g = A(
    "absolute inset-0 h-6 w-6 p-[3px] pointer-events-none",
    { block: !!x },
    { hidden: !x }
  ), y = c ?? d;
  return /* @__PURE__ */ t.jsxs("div", { children: [
    /* @__PURE__ */ t.jsxs("div", { className: "flex items-center space-x-[0.625rem]", children: [
      /* @__PURE__ */ t.jsxs("div", { className: "relative", children: [
        /* @__PURE__ */ t.jsx(
          "input",
          {
            id: y,
            className: f,
            onChange: (p) => o(p.target.checked),
            type: "checkbox",
            ref: n,
            "data-cy": l ?? d,
            ...i
          }
        ),
        /* @__PURE__ */ t.jsx(
          "svg",
          {
            className: g,
            viewBox: "0 0 15 11",
            fill: "none",
            id: `svg-id-${y}`,
            children: /* @__PURE__ */ t.jsx(
              "path",
              {
                d: "M1 4.5L5 9L14 1",
                strokeWidth: "2",
                stroke: x ? "#fff" : "none"
              }
            )
          }
        )
      ] }),
      /* @__PURE__ */ t.jsx("label", { className: h, htmlFor: y, children: r }),
      a && /* @__PURE__ */ t.jsx("div", { children: /* @__PURE__ */ t.jsx(
        At,
        {
          placement: a.placement,
          content: a.text,
          size: a.size,
          children: /* @__PURE__ */ t.jsx(
            Z,
            {
              name: F.informationFilled,
              size: X.m,
              color: "var(--black)"
            }
          )
        }
      ) })
    ] }),
    (s == null ? void 0 : s.message) && typeof s.message == "string" && /* @__PURE__ */ t.jsx($e, { children: s.message })
  ] });
});
en.displayName = "Checkbox";
const or = {
  1: "h-1",
  2: "h-2",
  3: "h-3",
  4: "h-4",
  5: "h-5",
  6: "h-6",
  7: "h-7",
  8: "h-8",
  9: "h-9",
  10: "h-10",
  11: "h-11",
  12: "h-12",
  13: "h-13",
  14: "h-14",
  15: "h-15",
  16: "h-16",
  17: "h-17",
  18: "h-18",
  19: "h-19",
  20: "h-20",
  24: "h-24",
  28: "h-28",
  32: "h-32",
  36: "h-36",
  40: "h-40",
  44: "h-44",
  48: "h-48",
  52: "h-52",
  56: "h-56",
  60: "h-60",
  64: "h-64",
  72: "h-72",
  80: "h-80",
  96: "h-96",
  short: "h-1/3",
  medium: "h-1/2",
  long: "h-2/3",
  full: "h-full",
  auto: "h-auto"
}, ir = {
  1: "w-1",
  2: "w-2",
  3: "w-3",
  4: "w-4",
  5: "w-5",
  6: "w-6",
  7: "w-7",
  8: "w-8",
  9: "w-9",
  10: "w-10",
  11: "w-11",
  12: "w-12",
  13: "w-13",
  14: "w-14",
  15: "w-15",
  16: "w-16",
  17: "w-17",
  18: "w-18",
  19: "w-19",
  20: "w-20",
  24: "w-24",
  28: "w-28",
  32: "w-32",
  36: "w-36",
  40: "w-40",
  44: "w-44",
  48: "w-48",
  52: "w-52",
  56: "w-56",
  60: "w-60",
  64: "w-64",
  72: "w-72",
  80: "w-80",
  96: "w-96",
  short: "w-1/3",
  medium: "w-1/2",
  long: "w-2/3",
  full: "w-full",
  auto: "w-auto"
}, fe = ({
  height: e,
  width: n,
  className: r,
  style: a,
  as: s
}) => {
  const o = n && ir[n] || ir.full, l = e && or[e] || or[3], i = s || "div";
  return /* @__PURE__ */ t.jsx(
    i,
    {
      style: a,
      className: A(
        "bg-misc-200 rounded animate-pulse",
        o,
        l,
        r || ""
      )
    }
  );
}, mi = (e) => {
  const n = ye(null);
  return ve(() => {
    n.current = e;
  }, [e]), n.current;
}, lr = {
  "mtan-input-container": "_mtan-input-container_zzcqb_1",
  "form-input": "_form-input_zzcqb_11",
  "error-input": "_error-input_zzcqb_61"
}, hi = (e) => {
  const { focus: n, error: r, testId: a, ariaLabel: s, ...o } = e, l = ye(null), i = mi(!!n), c = A(lr["form-input"], {
    [lr["error-input"]]: !!r
  });
  return yr(() => {
    l.current && (n && l.current.focus(), n && n !== i && (l.current.focus(), l.current.select()));
  }, [n, i]), // eslint-disable-next-line react/jsx-props-no-spreading
  /* @__PURE__ */ t.jsx(
    "input",
    {
      ref: l,
      ...o,
      className: c,
      "data-cy": a,
      "aria-label": s
    }
  );
}, xi = zn(hi), fi = 6, gi = ({
  onChange: e,
  isLoading: n,
  error: r,
  inputLength: a = fi,
  type: s
}) => {
  const [o, l] = ce(0), [i, c] = ce(Array(a).fill("")), d = pe(
    (j) => {
      const _ = j.join("");
      e(_);
    },
    [e]
  ), u = pe(
    (j) => {
      const _ = [...i];
      _[o] = j[0] || "", c(_), d(_);
    },
    [o, d, i]
  ), x = pe(
    (j) => {
      const _ = Math.max(Math.min(a - 1, j), 0);
      l(_);
    },
    [a]
  ), h = pe(() => {
    x(o - 1);
  }, [o, x]), f = pe(() => {
    x(o + 1);
  }, [o, x]), g = pe(
    (j) => () => {
      x(j);
    },
    [x]
  ), y = pe(
    (j) => {
      const _ = j.currentTarget.value;
      if (!_) {
        j.preventDefault();
        return;
      }
      u(_), f();
    },
    [u, f]
  ), p = pe(() => {
    l(-1);
  }, []), b = pe(
    (j) => {
      j.preventDefault();
      const I = j.clipboardData.getData("text/plain").split("").filter(
        (k) => s === "number" ? !Number.isNaN(Number(k)) : !0
      );
      I.length > a || (c(I), d(I), x(I.length));
    },
    [d, x, a, s]
  ), v = pe(
    (j) => {
      const _ = j.key;
      switch (_) {
        case "Backspace":
        case "Delete": {
          j.preventDefault(), i[o] ? u("") : h();
          break;
        }
        case "ArrowLeft": {
          j.preventDefault(), h();
          break;
        }
        case "ArrowRight": {
          j.preventDefault(), f();
          break;
        }
        case "Control":
          break;
        default: {
          s === "number" && _.match(/^[^0-9v]$/) && j.preventDefault();
          break;
        }
      }
    },
    [
      o,
      u,
      f,
      h,
      i,
      s
    ]
  );
  return /* @__PURE__ */ t.jsx("div", { className: "flex flex-col items-center space-y-2", children: n ? /* @__PURE__ */ t.jsx("div", { className: "flex space-x-1 lg:space-x-2", children: Array.from(Array(a).keys()).map((j) => /* @__PURE__ */ t.jsx(fe, { width: 12, height: 20 }, j)) }) : /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
    /* @__PURE__ */ t.jsx("div", { className: "flex space-x-1 lg:space-x-2", children: Array(a).fill("").map((j, _) => /* @__PURE__ */ t.jsx(
      xi,
      {
        focus: o === _,
        value: i.at(_) ?? "",
        onFocus: g(_),
        onChange: y,
        onKeyDown: v,
        onBlur: p,
        onPaste: b,
        error: r,
        type: s,
        testId: `mtan-${_}`,
        ariaLabel: `MTan input ${_ + 1} of ${a}`
      },
      Ma(_, "-SingleInput")
    )) }),
    (r == null ? void 0 : r.message) && typeof r.message == "string" && /* @__PURE__ */ t.jsx($e, { children: r.message })
  ] }) });
}, pi = zn(gi), vi = "_checkboxes_12cu3_1", bi = {
  checkboxes: vi
}, ji = (e, n) => e.map((r) => ({
  ...r,
  checked: n == null ? void 0 : n.includes(r.id)
})), wi = ({
  options: e,
  label: n,
  onChange: r,
  error: a,
  value: s,
  id: o
}) => {
  const [l, i] = ce(
    () => ji(e, s)
  ), c = (u) => (x) => {
    const h = l.map(
      (g) => g.name === u ? { ...g, checked: x } : g
    );
    i(h);
    const f = h.reduce(
      (g, y) => y.checked ? [...g, y.id] : g,
      []
    );
    r(f);
  };
  ve(() => {
    const u = l.map(
      (x) => s != null && s.includes(x.id) ? { ...x, checked: !0 } : { ...x, checked: !1 }
    );
    i(u);
  }, [s]);
  const d = o ? `${o}-error` : "";
  return /* @__PURE__ */ t.jsxs("div", { children: [
    n && /* @__PURE__ */ t.jsx(w, { children: n }),
    /* @__PURE__ */ t.jsx("div", { className: bi.checkboxes, children: l.map((u) => /* @__PURE__ */ t.jsx(
      en,
      {
        ...u,
        onChange: c(u.name),
        error: a && { message: "" },
        testId: u.name
      },
      u.name
    )) }),
    (a == null ? void 0 : a.message) && /* @__PURE__ */ t.jsx($e, { id: d, children: a.message })
  ] });
};
function Fr(e, n) {
  var r = {};
  for (var a in e)
    Object.prototype.hasOwnProperty.call(e, a) && n.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var s = 0, a = Object.getOwnPropertySymbols(e); s < a.length; s++)
      n.indexOf(a[s]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[s]) && (r[a[s]] = e[a[s]]);
  return r;
}
var Jt;
(function(e) {
  e.event = "event", e.props = "prop";
})(Jt || (Jt = {}));
function dt() {
}
function yi(e) {
  var n, r = void 0;
  return function() {
    for (var a = [], s = arguments.length; s--; ) a[s] = arguments[s];
    return n && a.length === n.length && a.every(function(o, l) {
      return o === n[l];
    }) || (n = a, r = e.apply(void 0, a)), r;
  };
}
function Xt(e) {
  return !!(e || "").match(/\d/);
}
function Pt(e) {
  return e == null;
}
function _i(e) {
  return typeof e == "number" && isNaN(e);
}
function Vr(e) {
  return Pt(e) || _i(e) || typeof e == "number" && !isFinite(e);
}
function Dr(e) {
  return e.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
}
function Ci(e) {
  switch (e) {
    case "lakh":
      return /(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g;
    case "wan":
      return /(\d)(?=(\d{4})+(?!\d))/g;
    case "thousand":
    default:
      return /(\d)(?=(\d{3})+(?!\d))/g;
  }
}
function Ni(e, n, r) {
  var a = Ci(r), s = e.search(/[1-9]/);
  return s = s === -1 ? e.length : s, e.substring(0, s) + e.substring(s, e.length).replace(a, "$1" + n);
}
function Si(e) {
  var n = ye(e);
  n.current = e;
  var r = ye(function() {
    for (var a = [], s = arguments.length; s--; ) a[s] = arguments[s];
    return n.current.apply(n, a);
  });
  return r.current;
}
function qn(e, n) {
  n === void 0 && (n = !0);
  var r = e[0] === "-", a = r && n;
  e = e.replace("-", "");
  var s = e.split("."), o = s[0], l = s[1] || "";
  return {
    beforeDecimal: o,
    afterDecimal: l,
    hasNegation: r,
    addNegation: a
  };
}
function Ii(e) {
  if (!e)
    return e;
  var n = e[0] === "-";
  n && (e = e.substring(1, e.length));
  var r = e.split("."), a = r[0].replace(/^0+/, "") || "0", s = r[1] || "";
  return (n ? "-" : "") + a + (s ? "." + s : "");
}
function Br(e, n, r) {
  for (var a = "", s = r ? "0" : "", o = 0; o <= n - 1; o++)
    a += e[o] || s;
  return a;
}
function cr(e, n) {
  return Array(n + 1).join(e);
}
function Zr(e) {
  var n = e + "", r = n[0] === "-" ? "-" : "";
  r && (n = n.substring(1));
  var a = n.split(/[eE]/g), s = a[0], o = a[1];
  if (o = Number(o), !o)
    return r + s;
  s = s.replace(".", "");
  var l = 1 + o, i = s.length;
  return l < 0 ? s = "0." + cr("0", Math.abs(l)) + s : l >= i ? s = s + cr("0", l - i) : s = (s.substring(0, l) || "0") + "." + s.substring(l), r + s;
}
function dr(e, n, r) {
  if (["", "-"].indexOf(e) !== -1)
    return e;
  var a = (e.indexOf(".") !== -1 || r) && n, s = qn(e), o = s.beforeDecimal, l = s.afterDecimal, i = s.hasNegation, c = parseFloat("0." + (l || "0")), d = l.length <= n ? "0." + l : c.toFixed(n), u = d.split("."), x = o;
  o && Number(u[0]) && (x = o.split("").reverse().reduce(function(y, p, b) {
    return y.length > b ? (Number(y[0]) + Number(p)).toString() + y.substring(1, y.length) : p + y;
  }, u[0]));
  var h = Br(u[1] || "", n, r), f = i ? "-" : "", g = a ? "." : "";
  return "" + f + x + g + h;
}
function yt(e, n) {
  if (e.value = e.value, e !== null) {
    if (e.createTextRange) {
      var r = e.createTextRange();
      return r.move("character", n), r.select(), !0;
    }
    return e.selectionStart || e.selectionStart === 0 ? (e.focus(), e.setSelectionRange(n, n), !0) : (e.focus(), !1);
  }
}
var Hr = yi(function(e, n) {
  for (var r = 0, a = 0, s = e.length, o = n.length; e[r] === n[r] && r < s; )
    r++;
  for (; e[s - 1 - a] === n[o - 1 - a] && o - a > r && s - a > r; )
    a++;
  return {
    from: { start: r, end: s - a },
    to: { start: r, end: o - a }
  };
}), ki = function(e, n) {
  var r = Math.min(e.selectionStart, n);
  return {
    from: { start: r, end: e.selectionEnd },
    to: { start: r, end: n }
  };
};
function Li(e, n, r) {
  return Math.min(Math.max(e, n), r);
}
function En(e) {
  return Math.max(e.selectionStart, e.selectionEnd);
}
function Ei() {
  return typeof navigator < "u" && !(navigator.platform && /iPhone|iPod/.test(navigator.platform));
}
function $i(e) {
  return {
    from: {
      start: 0,
      end: 0
    },
    to: {
      start: 0,
      end: e.length
    },
    lastValue: ""
  };
}
function Mi(e) {
  var n = e.currentValue, r = e.formattedValue, a = e.currentValueIndex, s = e.formattedValueIndex;
  return n[a] === r[s];
}
function Oi(e, n, r, a, s, o, l) {
  l === void 0 && (l = Mi);
  var i = s.findIndex(function(_) {
    return _;
  }), c = e.slice(0, i);
  !n && !r.startsWith(c) && (n = c, r = c + r, a = a + c.length);
  for (var d = r.length, u = e.length, x = {}, h = new Array(d), f = 0; f < d; f++) {
    h[f] = -1;
    for (var g = 0, y = u; g < y; g++) {
      var p = l({
        currentValue: r,
        lastValue: n,
        formattedValue: e,
        currentValueIndex: f,
        formattedValueIndex: g
      });
      if (p && x[g] !== !0) {
        h[f] = g, x[g] = !0;
        break;
      }
    }
  }
  for (var b = a; b < d && (h[b] === -1 || !o(r[b])); )
    b++;
  var v = b === d || h[b] === -1 ? u : h[b];
  for (b = a - 1; b > 0 && h[b] === -1; )
    b--;
  var j = b === -1 || h[b] === -1 ? 0 : h[b] + 1;
  return j > v ? v : a - j < v - a ? j : v;
}
function ur(e, n, r, a) {
  var s = e.length;
  if (n = Li(n, 0, s), a === "left") {
    for (; n >= 0 && !r[n]; )
      n--;
    n === -1 && (n = r.indexOf(!0));
  } else {
    for (; n <= s && !r[n]; )
      n++;
    n > s && (n = r.lastIndexOf(!0));
  }
  return n === -1 && (n = s), n;
}
function Pi(e) {
  for (var n = Array.from({ length: e.length + 1 }).map(function() {
    return !0;
  }), r = 0, a = n.length; r < a; r++)
    n[r] = !!(Xt(e[r]) || Xt(e[r - 1]));
  return n;
}
function qr(e, n, r, a, s, o) {
  o === void 0 && (o = dt);
  var l = Si(function(g, y) {
    var p, b;
    return Vr(g) ? (b = "", p = "") : typeof g == "number" || y ? (b = typeof g == "number" ? Zr(g) : g, p = a(b)) : (b = s(g, void 0), p = a(b)), { formattedValue: p, numAsString: b };
  }), i = ce(function() {
    return l(Pt(e) ? n : e, r);
  }), c = i[0], d = i[1], u = function(g, y) {
    g.formattedValue !== c.formattedValue && d({
      formattedValue: g.formattedValue,
      numAsString: g.value
    }), o(g, y);
  }, x = e, h = r;
  Pt(e) && (x = c.numAsString, h = !0);
  var f = l(x, h);
  return G(function() {
    d(f);
  }, [f.formattedValue]), [c, u];
}
function Ti(e) {
  return e.replace(/[^0-9]/g, "");
}
function Ri(e) {
  return e;
}
function Ai(e) {
  var n = e.type;
  n === void 0 && (n = "text");
  var r = e.displayType;
  r === void 0 && (r = "input");
  var a = e.customInput, s = e.renderText, o = e.getInputRef, l = e.format;
  l === void 0 && (l = Ri);
  var i = e.removeFormatting;
  i === void 0 && (i = Ti);
  var c = e.defaultValue, d = e.valueIsNumericString, u = e.onValueChange, x = e.isAllowed, h = e.onChange;
  h === void 0 && (h = dt);
  var f = e.onKeyDown;
  f === void 0 && (f = dt);
  var g = e.onMouseUp;
  g === void 0 && (g = dt);
  var y = e.onFocus;
  y === void 0 && (y = dt);
  var p = e.onBlur;
  p === void 0 && (p = dt);
  var b = e.value, v = e.getCaretBoundary;
  v === void 0 && (v = Pi);
  var j = e.isValidInputCharacter;
  j === void 0 && (j = Xt);
  var _ = e.isCharacterSame, I = Fr(e, ["type", "displayType", "customInput", "renderText", "getInputRef", "format", "removeFormatting", "defaultValue", "valueIsNumericString", "onValueChange", "isAllowed", "onChange", "onKeyDown", "onMouseUp", "onFocus", "onBlur", "value", "getCaretBoundary", "isValidInputCharacter", "isCharacterSame"]), k = qr(b, c, !!d, l, i, u), O = k[0], C = O.formattedValue, R = O.numAsString, P = k[1], M = ye(), D = ye({ formattedValue: C, numAsString: R }), B = function($, z) {
    D.current = { formattedValue: $.formattedValue, numAsString: $.value }, P($, z);
  }, J = ce(!1), ee = J[0], T = J[1], E = ye(null), Y = ye({
    setCaretTimeout: null,
    focusTimeout: null
  });
  ve(function() {
    return T(!0), function() {
      clearTimeout(Y.current.setCaretTimeout), clearTimeout(Y.current.focusTimeout);
    };
  }, []);
  var se = l, W = function($, z) {
    var H = parseFloat(z);
    return {
      formattedValue: $,
      value: z,
      floatValue: isNaN(H) ? void 0 : H
    };
  }, ae = function($, z, H) {
    $.selectionStart === 0 && $.selectionEnd === $.value.length || (yt($, z), Y.current.setCaretTimeout = setTimeout(function() {
      $.value === H && $.selectionStart !== z && yt($, z);
    }, 0));
  }, ie = function($, z, H) {
    return ur($, z, v($), H);
  }, Ae = function($, z, H) {
    var re = v(z), ge = Oi(z, C, $, H, re, j, _);
    return ge = ur(z, ge, re), ge;
  }, Ue = function($) {
    var z = $.formattedValue;
    z === void 0 && (z = "");
    var H = $.input, re = $.source, ge = $.event, K = $.numAsString, U;
    if (H) {
      var Ce = $.inputValue || H.value, ze = En(H);
      H.value = z, U = Ae(Ce, z, ze), U !== void 0 && ae(H, U, z);
    }
    z !== C && B(W(z, K), { event: ge, source: re });
  };
  ve(function() {
    var $ = D.current, z = $.formattedValue, H = $.numAsString;
    (C !== z || R !== H) && B(W(C, R), {
      event: void 0,
      source: Jt.props
    });
  }, [C, R]);
  var Qe = E.current ? En(E.current) : void 0, at = typeof window < "u" ? yr : ve;
  at(function() {
    var $ = E.current;
    if (C !== D.current.formattedValue && $) {
      var z = Ae(D.current.formattedValue, C, Qe);
      $.value = C, ae($, z, C);
    }
  }, [C]);
  var ot = function($, z, H) {
    var re = z.target, ge = M.current ? ki(M.current, re.selectionEnd) : Hr(C, $), K = Object.assign(Object.assign({}, ge), { lastValue: C }), U = i($, K), Ce = se(U);
    if (U = i(Ce, void 0), x && !x(W(Ce, U))) {
      var ze = z.target, Te = En(ze), Ze = Ae($, C, Te);
      return ze.value = C, ae(ze, Ze, C), !1;
    }
    return Ue({
      formattedValue: Ce,
      numAsString: U,
      inputValue: $,
      event: z,
      source: H,
      input: z.target
    }), !0;
  }, qe = function($, z) {
    z === void 0 && (z = 0);
    var H = $.selectionStart, re = $.selectionEnd;
    M.current = { selectionStart: H, selectionEnd: re + z };
  }, it = function($) {
    var z = $.target, H = z.value, re = ot(H, $, Jt.event);
    re && h($), M.current = void 0;
  }, et = function($) {
    var z = $.target, H = $.key, re = z.selectionStart, ge = z.selectionEnd, K = z.value;
    K === void 0 && (K = "");
    var U;
    H === "ArrowLeft" || H === "Backspace" ? U = Math.max(re - 1, 0) : H === "ArrowRight" ? U = Math.min(re + 1, K.length) : H === "Delete" && (U = re);
    var Ce = 0;
    H === "Delete" && re === ge && (Ce = 1);
    var ze = H === "ArrowLeft" || H === "ArrowRight";
    if (U === void 0 || re !== ge && !ze) {
      f($), qe(z, Ce);
      return;
    }
    var Te = U;
    if (ze) {
      var Ze = H === "ArrowLeft" ? "left" : "right";
      Te = ie(K, U, Ze), Te !== U && $.preventDefault();
    } else H === "Delete" && !j(K[U]) ? Te = ie(K, U, "right") : H === "Backspace" && !j(K[U]) && (Te = ie(K, U, "left"));
    Te !== U && ae(z, Te, K), f($), qe(z, Ce);
  }, St = function($) {
    var z = $.target, H = function() {
      var re = z.selectionStart, ge = z.selectionEnd, K = z.value;
      if (K === void 0 && (K = ""), re === ge) {
        var U = ie(K, re);
        U !== re && ae(z, U, K);
      }
    };
    H(), requestAnimationFrame(function() {
      H();
    }), g($), qe(z);
  }, jt = function($) {
    $.persist && $.persist();
    var z = $.target, H = $.currentTarget;
    E.current = z, Y.current.focusTimeout = setTimeout(function() {
      var re = z.selectionStart, ge = z.selectionEnd, K = z.value;
      K === void 0 && (K = "");
      var U = ie(K, re);
      U !== re && !(re === 0 && ge === K.length) && ae(z, U, K), y(Object.assign(Object.assign({}, $), { currentTarget: H }));
    }, 0);
  }, It = function($) {
    E.current = null, clearTimeout(Y.current.focusTimeout), clearTimeout(Y.current.setCaretTimeout), p($);
  }, kt = ee && Ei() ? "numeric" : void 0, Ye = Object.assign({ inputMode: kt }, I, {
    type: n,
    value: C,
    onChange: it,
    onKeyDown: et,
    onMouseUp: St,
    onFocus: jt,
    onBlur: It
  });
  if (r === "text")
    return s ? Ie.createElement(Ie.Fragment, null, s(C, I) || null) : Ie.createElement("span", Object.assign({}, I, { ref: o }), C);
  if (a) {
    var tt = a;
    return Ie.createElement(tt, Object.assign({}, Ye, { ref: o }));
  }
  return Ie.createElement("input", Object.assign({}, Ye, { ref: o }));
}
function mr(e, n) {
  var r = n.decimalScale, a = n.fixedDecimalScale, s = n.prefix;
  s === void 0 && (s = "");
  var o = n.suffix;
  o === void 0 && (o = "");
  var l = n.allowNegative, i = n.thousandsGroupStyle;
  if (i === void 0 && (i = "thousand"), e === "" || e === "-")
    return e;
  var c = pn(n), d = c.thousandSeparator, u = c.decimalSeparator, x = r !== 0 && e.indexOf(".") !== -1 || r && a, h = qn(e, l), f = h.beforeDecimal, g = h.afterDecimal, y = h.addNegation;
  return r !== void 0 && (g = Br(g, r, !!a)), d && (f = Ni(f, d, i)), s && (f = s + f), o && (g = g + o), y && (f = "-" + f), e = f + (x && u || "") + g, e;
}
function pn(e) {
  var n = e.decimalSeparator;
  n === void 0 && (n = ".");
  var r = e.thousandSeparator, a = e.allowedDecimalSeparators;
  return r === !0 && (r = ","), a || (a = [n, "."]), {
    decimalSeparator: n,
    thousandSeparator: r,
    allowedDecimalSeparators: a
  };
}
function zi(e, n) {
  e === void 0 && (e = "");
  var r = new RegExp("(-)"), a = new RegExp("(-)(.)*(-)"), s = r.test(e), o = a.test(e);
  return e = e.replace(/-/g, ""), s && !o && n && (e = "-" + e), e;
}
function Fi(e, n) {
  return new RegExp("(^-)|[0-9]|" + Dr(e), "g");
}
function Vi(e, n, r) {
  return e === "" ? !0 : !(n != null && n.match(/\d/)) && !(r != null && r.match(/\d/)) && typeof e == "string" && !isNaN(Number(e));
}
function Di(e, n, r) {
  var a;
  n === void 0 && (n = $i(e));
  var s = r.allowNegative, o = r.prefix;
  o === void 0 && (o = "");
  var l = r.suffix;
  l === void 0 && (l = "");
  var i = r.decimalScale, c = n.from, d = n.to, u = d.start, x = d.end, h = pn(r), f = h.allowedDecimalSeparators, g = h.decimalSeparator, y = e[x] === g;
  if (Xt(e) && (e === o || e === l) && n.lastValue === "")
    return e;
  if (x - u === 1 && f.indexOf(e[u]) !== -1) {
    var p = i === 0 ? "" : g;
    e = e.substring(0, u) + p + e.substring(u + 1, e.length);
  }
  var b = function(E, Y, se) {
    var W = !1, ae = !1;
    o.startsWith("-") ? W = !1 : E.startsWith("--") ? (W = !1, ae = !0) : l.startsWith("-") && E.length === l.length ? W = !1 : E[0] === "-" && (W = !0);
    var ie = W ? 1 : 0;
    return ae && (ie = 2), ie && (E = E.substring(ie), Y -= ie, se -= ie), { value: E, start: Y, end: se, hasNegation: W };
  }, v = b(e, u, x), j = v.hasNegation;
  a = v, e = a.value, u = a.start, x = a.end;
  var _ = b(n.lastValue, c.start, c.end), I = _.start, k = _.end, O = _.value, C = e.substring(u, x);
  e.length && O.length && (I > O.length - l.length || k < o.length) && !(C && l.startsWith(C)) && (e = O);
  var R = 0;
  e.startsWith(o) ? R += o.length : u < o.length && (R = u), e = e.substring(R), x -= R;
  var P = e.length, M = e.length - l.length;
  e.endsWith(l) ? P = M : (x > M || x > e.length - l.length) && (P = x), e = e.substring(0, P), e = zi(j ? "-" + e : e, s), e = (e.match(Fi(g)) || []).join("");
  var D = e.indexOf(g);
  e = e.replace(new RegExp(Dr(g), "g"), function(E, Y) {
    return Y === D ? "." : "";
  });
  var B = qn(e, s), J = B.beforeDecimal, ee = B.afterDecimal, T = B.addNegation;
  return d.end - d.start < c.end - c.start && J === "" && y && !parseFloat(ee) && (e = T ? "-" : ""), e;
}
function Bi(e, n) {
  var r = n.prefix;
  r === void 0 && (r = "");
  var a = n.suffix;
  a === void 0 && (a = "");
  var s = Array.from({ length: e.length + 1 }).map(function() {
    return !0;
  }), o = e[0] === "-";
  s.fill(!1, 0, r.length + (o ? 1 : 0));
  var l = e.length;
  return s.fill(!1, l - a.length + 1, l + 1), s;
}
function Zi(e) {
  var n = pn(e), r = n.thousandSeparator, a = n.decimalSeparator, s = e.prefix;
  s === void 0 && (s = "");
  var o = e.allowNegative;
  if (o === void 0 && (o = !0), r === a)
    throw new Error(`
        Decimal separator can't be same as thousand separator.
        thousandSeparator: ` + r + ` (thousandSeparator = {true} is same as thousandSeparator = ",")
        decimalSeparator: ` + a + ` (default value for decimalSeparator is .)
     `);
  return s.startsWith("-") && o && (console.error(`
      Prefix can't start with '-' when allowNegative is true.
      prefix: ` + s + `
      allowNegative: ` + o + `
    `), o = !1), Object.assign(Object.assign({}, e), { allowNegative: o });
}
function Hi(e) {
  e = Zi(e), e.decimalSeparator, e.allowedDecimalSeparators, e.thousandsGroupStyle;
  var n = e.suffix, r = e.allowNegative, a = e.allowLeadingZeros, s = e.onKeyDown;
  s === void 0 && (s = dt);
  var o = e.onBlur;
  o === void 0 && (o = dt);
  var l = e.thousandSeparator, i = e.decimalScale, c = e.fixedDecimalScale, d = e.prefix;
  d === void 0 && (d = "");
  var u = e.defaultValue, x = e.value, h = e.valueIsNumericString, f = e.onValueChange, g = Fr(e, ["decimalSeparator", "allowedDecimalSeparators", "thousandsGroupStyle", "suffix", "allowNegative", "allowLeadingZeros", "onKeyDown", "onBlur", "thousandSeparator", "decimalScale", "fixedDecimalScale", "prefix", "defaultValue", "value", "valueIsNumericString", "onValueChange"]), y = pn(e), p = y.decimalSeparator, b = y.allowedDecimalSeparators, v = function(T) {
    return mr(T, e);
  }, j = function(T, E) {
    return Di(T, E, e);
  }, _ = Pt(x) ? u : x, I = h ?? Vi(_, d, n);
  Pt(x) ? Pt(u) || (I = I || typeof u == "number") : I = I || typeof x == "number";
  var k = function(T) {
    return Vr(T) ? T : (typeof T == "number" && (T = Zr(T)), I && typeof i == "number" ? dr(T, i, !!c) : T);
  }, O = qr(k(x), k(u), !!I, v, j, f), C = O[0], R = C.numAsString, P = C.formattedValue, M = O[1], D = function(T) {
    var E = T.target, Y = T.key, se = E.selectionStart, W = E.selectionEnd, ae = E.value;
    if (ae === void 0 && (ae = ""), (Y === "Backspace" || Y === "Delete") && W < d.length) {
      T.preventDefault();
      return;
    }
    if (se !== W) {
      s(T);
      return;
    }
    Y === "Backspace" && ae[0] === "-" && se === d.length + 1 && r && yt(E, 1), i && c && (Y === "Backspace" && ae[se - 1] === p ? (yt(E, se - 1), T.preventDefault()) : Y === "Delete" && ae[se] === p && T.preventDefault()), b != null && b.includes(Y) && ae[se] === p && yt(E, se + 1);
    var ie = l === !0 ? "," : l;
    Y === "Backspace" && ae[se - 1] === ie && yt(E, se - 1), Y === "Delete" && ae[se] === ie && yt(E, se + 1), s(T);
  }, B = function(T) {
    var E = R;
    if (E.match(/\d/g) || (E = ""), a || (E = Ii(E)), c && i && (E = dr(E, i, c)), E !== R) {
      var Y = mr(E, e);
      M({
        formattedValue: Y,
        value: E,
        floatValue: parseFloat(E)
      }, {
        event: T,
        source: Jt.event
      });
    }
    o(T);
  }, J = function(T) {
    return T === p ? !0 : Xt(T);
  }, ee = function(T) {
    var E = T.currentValue, Y = T.lastValue, se = T.formattedValue, W = T.currentValueIndex, ae = T.formattedValueIndex, ie = E[W], Ae = se[ae], Ue = Hr(Y, E), Qe = Ue.to;
    return W >= Qe.start && W < Qe.end && b && b.includes(ie) && Ae === p ? !0 : ie === Ae;
  };
  return Object.assign(Object.assign({}, g), {
    value: P,
    valueIsNumericString: !1,
    isValidInputCharacter: J,
    isCharacterSame: ee,
    onValueChange: M,
    format: v,
    removeFormatting: j,
    getCaretBoundary: function(T) {
      return Bi(T, e);
    },
    onKeyDown: D,
    onBlur: B
  });
}
function qi(e) {
  var n = Hi(e);
  return Ie.createElement(Ai, Object.assign({}, n));
}
const Se = 21, Gi = "_group_16v96_1", Ui = "_shrink_16v96_245", we = {
  group: Gi,
  "form-input": "_form-input_16v96_9",
  "disabled-input": "_disabled-input_16v96_77",
  "password-input": "_password-input_16v96_91",
  "error-input": "_error-input_16v96_163",
  "form-input-label": "_form-input-label_16v96_199",
  "two-line-label": "_two-line-label_16v96_237",
  shrink: Ui,
  "disabled-input-label": "_disabled-input-label_16v96_273",
  "form-info": "_form-info_16v96_281"
}, Yi = (e) => typeof e == "number" ? !!e : !!(e != null && e.length), pt = vt((e, n) => {
  const {
    value: r,
    onChange: a,
    label: s,
    symbol: o,
    error: l,
    thousandSeparator: i = ".",
    decimalSeparator: c = ",",
    allowNegative: d = !0,
    allowLeadingZeros: u = !1,
    className: x,
    testId: h,
    onFocus: f,
    onBlur: g,
    ...y
  } = e, { disabled: p, name: b, id: v } = e, [j, _] = ce(0), [I, k] = ce(!1), O = ye(null), C = Yi(r), R = A(
    we["form-input"],
    { [we["disabled-input"]]: !!p },
    { [we["error-input"]]: !!l }
  ), P = A(
    { [we.shrink]: C },
    we["form-input-label"],
    { [we["disabled-input-label"]]: !!p },
    {
      "!top-[9px]": j > Se && !(C || I)
    },
    { "right-[28px]": !!o }
  ), M = A(we["form-info"]), D = A(x, we.group), B = (ee) => {
    a(ee.value);
  };
  ve(() => {
    const ee = O.current;
    if (!ee) return;
    const T = () => {
      _(ee.clientHeight);
    }, E = new ResizeObserver(() => {
      T();
    });
    return E.observe(ee), T(), () => {
      E.disconnect();
    };
  }, []);
  const J = G(() => {
    const ee = j > Se ? Math.ceil(j / Se) : 1;
    return `${j > Se ? (C || I ? ee : ee - 1) * Se + 40 : 60}px`;
  }, [j, I, C]);
  return /* @__PURE__ */ t.jsxs("div", { className: D, children: [
    /* @__PURE__ */ t.jsx(
      qi,
      {
        id: v,
        getInputRef: n,
        value: r,
        type: "text",
        thousandSeparator: i,
        decimalSeparator: c,
        allowLeadingZeros: u,
        className: R,
        inputMode: "decimal",
        pattern: "[0-9],.*",
        allowNegative: d,
        onValueChange: B,
        "data-cy": h ?? b,
        onFocus: (ee) => {
          k(!0), f == null || f(ee);
        },
        onBlur: (ee) => {
          k(!1), g == null || g(ee);
        },
        ...y,
        style: {
          height: J,
          padding: j > Se ? `${j}px 18px 6px` : "24px 18px 6px"
        }
      }
    ),
    s && /* @__PURE__ */ t.jsx("label", { htmlFor: v ?? b, className: P, ref: O, children: s }),
    /* @__PURE__ */ t.jsxs(
      "div",
      {
        className: M,
        style: {
          height: J
        },
        children: [
          p && /* @__PURE__ */ t.jsx(
            Z,
            {
              name: F.lock,
              size: X.xs,
              containerClassName: "flex items-center justify-center"
            }
          ),
          o && /* @__PURE__ */ t.jsx("span", { children: o })
        ]
      }
    ),
    (l == null ? void 0 : l.message) && typeof l.message == "string" && /* @__PURE__ */ t.jsx($e, { children: l.message })
  ] });
});
pt.displayName = "NumberInput";
const Ct = vt((e, n) => {
  const {
    name: r,
    options: a,
    label: s,
    value: o,
    onChange: l,
    onBlur: i,
    disabled: c,
    testId: d,
    error: u,
    errorId: x,
    direction: h = "downwards"
  } = e, f = ye(null), [g, y] = ce(0), p = G(
    () => a.find((v) => v.value === o) ?? {
      label: "",
      value: ""
    },
    [o, a]
  );
  ve(() => {
    const v = f.current;
    if (!v) return;
    const j = () => {
      y(v.clientHeight);
    }, _ = new ResizeObserver(() => {
      j();
    });
    return _.observe(v), j(), () => {
      _.disconnect();
    };
  }, []);
  const b = G(() => {
    const v = g > Se ? Math.ceil(g / Se) : 1;
    return `${g > Se ? (p != null && p.label ? v : v - 1) * Se + 40 : 60}px`;
  }, [g, p == null ? void 0 : p.label]);
  return /* @__PURE__ */ t.jsxs("div", { className: "relative w-full text-[--primary-default]", children: [
    /* @__PURE__ */ t.jsx(
      nn,
      {
        ref: n,
        name: r,
        defaultValue: p,
        value: p,
        onChange: (v) => l(v.value),
        disabled: c,
        "aria-label": s,
        children: ({ open: v }) => /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
          /* @__PURE__ */ t.jsxs(
            nn.Button,
            {
              style: {
                height: b
              },
              className: A(
                "bg-white border w-full text-left px-4 relative flex justify-between items-center focus:outline-none focus:ring-0",
                {
                  "!border-[--negative-default]": !!u,
                  "border-x-[--input-focus-border]": v,
                  "rounded-br-md rounded-bl-md border-t-[--primary-lighter] border-b-[--input-focus-border]": v && h === "upwards",
                  "rounded-tr-md rounded-tl-md border-b-[--primary-lighter] border-t-[--input-focus-border]": v && h === "downwards",
                  "border-[--primary-lighter] focus:border-[--input-focus-border] rounded-md transition-colors duration-75": !v
                }
              ),
              "data-cy": d ?? r,
              onBlur: () => !v && (i == null ? void 0 : i()),
              children: [
                /* @__PURE__ */ t.jsx(
                  "span",
                  {
                    ref: f,
                    className: A("", {
                      "absolute top-1.5 left-4 text-sm right-[28px]": !!(p != null && p.label),
                      "text-[17px]": !(p != null && p.label)
                    }),
                    children: s
                  }
                ),
                (p == null ? void 0 : p.label) && /* @__PURE__ */ t.jsx("span", { className: "flex flex-col justify-end h-full font-bold text-[17px] pb-2", children: p == null ? void 0 : p.label }),
                /* @__PURE__ */ t.jsxs("span", { className: "absolute flex items-center space-x-2 right-4", children: [
                  c && /* @__PURE__ */ t.jsx(Z, { name: F.lock, size: X.xs }),
                  /* @__PURE__ */ t.jsx(
                    Z,
                    {
                      className: A("transition-all transform", {
                        "rotate-180": v,
                        "rotate-0": !v
                      }),
                      name: F.chevronDown,
                      size: X.xs
                    }
                  )
                ] })
              ]
            }
          ),
          /* @__PURE__ */ t.jsx(
            nn.Options,
            {
              className: A(
                "absolute z-30 flex flex-col w-full bg-white max-h-60 overflow-auto border-x border-[--input-focus-border] text-sm focus:outline-none focus:ring-0",
                {
                  "transform -translate-y-full -top-0 border-t rounded-tr-md rounded-tl-md": h === "upwards",
                  "border-b rounded-br-md rounded-bl-md": h === "downwards"
                }
              ),
              children: a.map((j) => /* @__PURE__ */ t.jsx(
                nn.Option,
                {
                  value: j,
                  as: "li",
                  id: String(j.value),
                  children: ({ active: _, selected: I }) => /* @__PURE__ */ t.jsxs(
                    "div",
                    {
                      className: A(
                        "flex justify-between items-center max-w-full py-2 px-5 border-b border-[--primary-lighter] cursor-pointer transition-colors",
                        {
                          "first:rounded-tr-md first:rounded-tl-md last:border-b-0": h === "upwards",
                          "last:rounded-br-md last:rounded-bl-md": h === "downwards",
                          "bg-[--grey-20]": _,
                          "bg-white hover:bg-[--grey-20]": !_
                        }
                      ),
                      children: [
                        /* @__PURE__ */ t.jsx("span", { children: j.label }),
                        I && /* @__PURE__ */ t.jsx(
                          Z,
                          {
                            name: F.checkmark,
                            size: X.s
                          }
                        )
                      ]
                    }
                  )
                },
                j.label
              ))
            }
          )
        ] })
      }
    ),
    (u == null ? void 0 : u.message) && typeof u.message == "string" && /* @__PURE__ */ t.jsx($e, { id: x, children: u.message })
  ] });
});
var Gn = /* @__PURE__ */ ((e) => (e.primaryPhoneNumber = "primaryPhoneNumber", e.primaryPhoneCountryCode = "primaryPhoneCountryCode", e))(Gn || {});
const Wi = ({
  isLoading: e,
  countryCodeLabel: n,
  phoneLabel: r,
  t: a,
  onChange: s,
  errors: o,
  values: l,
  options: i
}) => /* @__PURE__ */ t.jsxs("div", { className: "grid grid-cols-1 gap-4 sm:grid-cols-2", children: [
  e ? /* @__PURE__ */ t.jsx(fe, { height: 16 }) : /* @__PURE__ */ t.jsx(
    Ct,
    {
      label: a(n || "field.country-phone-code"),
      onChange: s(
        "primaryPhoneCountryCode"
        /* primaryPhoneCountryCode */
      ),
      error: o == null ? void 0 : o.primaryPhoneCountryCode,
      value: l(
        "primaryPhoneCountryCode"
        /* primaryPhoneCountryCode */
      ),
      options: i,
      name: "primaryPhoneCountryCode"
      /* primaryPhoneCountryCode */
    }
  ),
  /* @__PURE__ */ t.jsx(
    pt,
    {
      onChange: s(
        "primaryPhoneNumber"
        /* primaryPhoneNumber */
      ),
      id: "phoneNumber",
      label: a(r || "field.phone-number"),
      name: "primaryPhoneNumber",
      error: o == null ? void 0 : o.primaryPhoneNumber,
      value: l(
        "primaryPhoneNumber"
        /* primaryPhoneNumber */
      ),
      decimalScale: 0,
      thousandSeparator: "",
      allowNegative: !1,
      maxLength: 13
    }
  )
] }), Ki = (e) => {
  var r, a, s;
  const n = (s = (a = (r = e == null ? void 0 : e.data) == null ? void 0 : r.items) == null ? void 0 : a.find(
    (o) => o.label === "Deutschland (+49)"
  )) == null ? void 0 : s.id;
  return n ? String(n) : void 0;
}, Pl = ({
  countryCodeLabel: e,
  phoneLabel: n,
  onChange: r,
  errors: a,
  values: s,
  setValue: o
}) => {
  const l = S.get(
    "getSchemaListByKeyQuery"
  ), i = S.get("useLanguage"), { t: c } = i(), { isLoading: d, data: u } = l({
    key: "supportedCountryPhoneCode"
  }), { options: x, germanCodeId: h } = G(() => {
    if (!(u != null && u.data))
      return {
        options: [],
        germanCodeId: void 0
      };
    const f = u.data.items.map((y) => ({
      label: y.label,
      value: String(y.id)
    })).sort((y, p) => new Intl.Collator("de").compare(y.label, p.label)), g = Ki(u);
    return {
      options: f,
      germanCodeId: g
    };
  }, [u]);
  return ve(() => {
    h && o && o(Gn.primaryPhoneCountryCode, h, {
      shouldValidate: !0
    });
  }, [h, o]), /* @__PURE__ */ t.jsx(
    Wi,
    {
      isLoading: d,
      t: c,
      countryCodeLabel: e,
      phoneLabel: n,
      onChange: r,
      errors: a,
      values: s,
      options: x
    }
  );
}, Tl = (e, n) => le().when(Gn.primaryPhoneCountryCode, {
  is: n,
  then: Je().test(
    "len",
    e("error.validation.phone-length"),
    (r) => r != null && r.length ? (r == null ? void 0 : r.length) > 8 : !1
  ),
  otherwise: Je().test(
    "len",
    e("error.validation.phone-length"),
    (r) => r != null && r.length ? (r == null ? void 0 : r.length) > 6 : !1
  )
}), wt = {
  "radio-control": "_radio-control_roe0g_1",
  "radio-error": "_radio-error_roe0g_61",
  "radio-disabled": "_radio-disabled_roe0g_69",
  "labels-container": "_labels-container_roe0g_143",
  "radio-label": "_radio-label_roe0g_149",
  "radio-sub-label": "_radio-sub-label_roe0g_159"
}, Gr = vt(
  ({ className: e, ...n }, r) => {
    const { label: a = "", error: s, subLabel: o = "", testId: l, ...i } = n, { id: c, name: d, disabled: u } = n, x = A(wt["radio-control"], e, {
      [wt["radio-disabled"]]: !!u
    }), h = A(
      "ring-0 focus:!ring-0",
      { [wt["radio-error"]]: !!s },
      { [wt["radio-disabled"]]: !!u },
      e
    ), f = c ?? d;
    return /* @__PURE__ */ t.jsxs("div", { children: [
      /* @__PURE__ */ t.jsxs("label", { htmlFor: f, className: x, children: [
        /* @__PURE__ */ t.jsx(
          "input",
          {
            ref: r,
            type: "radio",
            id: f,
            className: h,
            ...i,
            "data-cy": l ?? d,
            "aria-label": a
          }
        ),
        /* @__PURE__ */ t.jsxs("div", { className: wt["labels-container"], children: [
          a && /* @__PURE__ */ t.jsx("span", { className: wt["radio-label"], children: a }),
          o && /* @__PURE__ */ t.jsx("span", { className: wt["radio-sub-label"], children: o })
        ] })
      ] }),
      (s == null ? void 0 : s.message) && typeof s.message == "string" && /* @__PURE__ */ t.jsx($e, { children: s.message })
    ] });
  }
);
Gr.displayName = "RadioButton";
const Un = ({ htmlFor: e, label: n, ...r }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  /* @__PURE__ */ t.jsx("label", { htmlFor: e, ...r, children: n })
), Ji = "_vertical_15gpl_11", Xi = "_solid_15gpl_17", Qi = "_dashed_15gpl_25", e1 = "_dotted_15gpl_33", $n = {
  "radio-button-group-container": "_radio-button-group-container_15gpl_1",
  vertical: Ji,
  solid: Xi,
  dashed: Qi,
  dotted: e1
}, t1 = ({
  value: e,
  options: n,
  onChange: r,
  label: a,
  layout: s = "horizontal",
  name: o,
  error: l,
  separator: i,
  errorId: c
}) => {
  const [d, u] = ce(e), x = (g) => {
    r(g.currentTarget.value), u(g.currentTarget.value);
  }, h = G(
    () => A(
      $n["radio-button-group-container"],
      { [$n.vertical]: s === "vertical" },
      { [$n[i]]: !!i }
    ),
    [s, i]
  ), f = G(() => o || Cr(8), [o]);
  return ve(() => {
    u(e);
  }, [e]), /* @__PURE__ */ t.jsxs("div", { className: h, children: [
    a && /* @__PURE__ */ t.jsx(Un, { htmlFor: f, label: a }),
    n == null ? void 0 : n.map((g) => /* @__PURE__ */ t.jsx(
      Gr,
      {
        checked: d === g.value,
        onChange: x,
        error: l && { message: "" },
        ...g
      },
      g.value
    )),
    (l == null ? void 0 : l.message) && typeof l.message == "string" && /* @__PURE__ */ t.jsx($e, { id: c, children: l.message })
  ] });
}, n1 = "_shrink_1v9b6_85", $t = {
  "text-aria-container": "_text-aria-container_1v9b6_1",
  "text-aria-input": "_text-aria-input_1v9b6_9",
  "error-input": "_error-input_1v9b6_53",
  "text-aria-label": "_text-aria-label_1v9b6_63",
  shrink: n1
}, r1 = (e) => typeof e == "number" ? !!e : !!(e != null && e.length), Rl = vt(
  (e, n) => {
    const { label: r, error: a, testId: s, ...o } = e, { disabled: l, value: i, name: c } = e, d = A(
      $t["text-aria-input"],
      { [$t["disabled-input"]]: !!l },
      { [$t["error-input"]]: !!a }
    ), u = r1(i), x = A(
      { [$t.shrink]: u },
      $t["text-aria-label"]
    ), h = c || Cr(8);
    return /* @__PURE__ */ t.jsxs("div", { className: $t["text-aria-container"], children: [
      /* @__PURE__ */ t.jsx(
        "textarea",
        {
          id: h,
          className: d,
          disabled: l,
          "data-cy": s ?? c,
          ...o,
          ref: n
        }
      ),
      r && /* @__PURE__ */ t.jsx(Un, { htmlFor: c, label: r, className: x }),
      (a == null ? void 0 : a.message) && typeof a.message == "string" && /* @__PURE__ */ t.jsx($e, { children: a.message })
    ] });
  }
), s1 = (e) => typeof e == "number" ? !!e : !!(e != null && e.length), a1 = vt(
  ({
    className: e,
    testId: n,
    onPasswordVisibilityChange: r,
    isPasswordVisible: a = !1,
    ...s
  }, o) => {
    const { label: l, symbol: i, error: c, onFocus: d, onBlur: u, ...x } = s, { disabled: h, value: f, name: g, id: y } = s, p = ye(null), b = ye(null), [v, j] = ce(0), [_, I] = ce(!1), [k, O] = ce(a), C = S.get("useLanguage"), { t: R } = C(), P = s1(f), M = A(e, we.group), D = G(
      () => (x == null ? void 0 : x.type) === "password",
      [x == null ? void 0 : x.type]
    ), B = A(
      we["form-input"],
      { [we["error-input"]]: !!c },
      { [we["disabled-input"]]: !!h },
      { [we["password-input"]]: D }
    ), J = A(
      we["form-input-label"],
      { [we.shrink]: P || (x == null ? void 0 : x.type) === "date" },
      { [we["disabled-input-label"]]: !!h },
      {
        "!top-[9px]": v > Se && !(P || _)
      },
      { "right-[28px]": !!i }
    ), ee = A(we["form-info"]);
    _r(o, () => {
      if (p.current)
        return p.current;
      throw new Error("Ref is not assigned yet");
    }), ve(() => {
      const E = b.current;
      if (!E) return;
      const Y = () => {
        j(E.clientHeight);
      }, se = new ResizeObserver(() => {
        Y();
      });
      return se.observe(E), Y(), () => {
        se.disconnect();
      };
    }, []);
    const T = G(() => {
      const E = v > Se ? Math.ceil(v / Se) : 1;
      return `${v > Se ? (P || _ ? E : E - 1) * Se + 40 : 60}px`;
    }, [v, _, P]);
    return ve(() => {
      O(a);
    }, [a]), /* @__PURE__ */ t.jsxs("div", { className: M, children: [
      /* @__PURE__ */ t.jsx(
        "input",
        {
          id: y,
          ref: p,
          className: B,
          "data-cy": n ?? g,
          onFocus: (E) => {
            I(!0), d == null || d(E);
          },
          onBlur: (E) => {
            I(!1), u == null || u(E);
          },
          ...x,
          ...k ? { type: "text" } : {},
          style: {
            height: T,
            padding: v > Se ? `${v}px 18px 6px` : "24px 18px 6px"
          }
        }
      ),
      l && /* @__PURE__ */ t.jsx("label", { htmlFor: y ?? g, className: J, ref: b, children: l }),
      /* @__PURE__ */ t.jsxs(
        "div",
        {
          className: ee,
          style: {
            height: T
          },
          children: [
            h && /* @__PURE__ */ t.jsx(Z, { name: F.lock, size: X.xs }),
            i && /* @__PURE__ */ t.jsx("span", { children: i }),
            D && /* @__PURE__ */ t.jsx(
              "button",
              {
                type: "button",
                "aria-label": R(
                  `password-input.icon-button.arial-labels.${k ? "hide" : "show"}`
                ),
                "aria-pressed": k,
                onClick: () => {
                  const E = !k;
                  O(E), r == null || r(E), setTimeout(() => {
                    var Y;
                    (Y = p.current) == null || Y.focus();
                  }, 0);
                },
                children: /* @__PURE__ */ t.jsx(
                  Z,
                  {
                    name: k ? F.crossedOutEye : F.eye,
                    size: X.m
                  }
                )
              }
            )
          ]
        }
      ),
      (c == null ? void 0 : c.message) && typeof c.message == "string" && /* @__PURE__ */ t.jsx($e, { children: c.message })
    ] });
  }
);
a1.displayName = "TextInput";
const o1 = "_circle_p55wo_27", i1 = "_bubble_p55wo_1", an = {
  "loading-overlay": "_loading-overlay_p55wo_1",
  circle: o1,
  bubble: i1
}, l1 = ({ className: e }) => /* @__PURE__ */ t.jsxs("div", { className: A(an["loading-overlay"], e), children: [
  /* @__PURE__ */ t.jsx("div", { className: an.circle }),
  /* @__PURE__ */ t.jsx("div", { className: an.circle }),
  /* @__PURE__ */ t.jsx("div", { className: an.circle })
] }), Pe = {
  "modal-background": "_modal-background_1lvqu_1",
  "modal-wrapper": "_modal-wrapper_1lvqu_29",
  "modal-wrapper-large": "_modal-wrapper-large_1lvqu_45",
  "modal-content": "_modal-content_1lvqu_65",
  "multi-step-modal-content": "_multi-step-modal-content_1lvqu_81",
  "close-icon-wrapper": "_close-icon-wrapper_1lvqu_95",
  "close-icon": "_close-icon_1lvqu_95",
  "modal-title": "_modal-title_1lvqu_131",
  "buttons-container": "_buttons-container_1lvqu_139",
  "buttons-container-primary": "_buttons-container-primary_1lvqu_159",
  "buttons-container-secondary": "_buttons-container-secondary_1lvqu_169",
  "modal-progress-container": "_modal-progress-container_1lvqu_181",
  "modal-progress-container-empty-wizard": "_modal-progress-container-empty-wizard_1lvqu_191",
  "multistep-button-confirm": "_multistep-button-confirm_1lvqu_201",
  "multistep-button-return": "_multistep-button-return_1lvqu_211"
}, Ur = ({
  visible: e,
  children: n,
  confirmButton: r,
  closeButton: a,
  title: s,
  closeIcon: o = !1,
  onClose: l,
  className: i = "",
  ...c
}) => {
  if (!e)
    return null;
  const d = A(Pe["modal-wrapper"], {
    [i]: !!i
  });
  return hn(
    /* @__PURE__ */ t.jsx("div", { className: Pe["modal-background"], ...c, children: /* @__PURE__ */ t.jsx("div", { className: d, children: /* @__PURE__ */ t.jsxs(Ee, { children: [
      o && /* @__PURE__ */ t.jsx("div", { className: Pe["close-icon-wrapper"], onClick: l, children: /* @__PURE__ */ t.jsx(Z, { size: X.xs, name: F.close }) }),
      s && /* @__PURE__ */ t.jsx(Le, { size: 3, children: s }),
      /* @__PURE__ */ t.jsxs("div", { className: Pe["modal-content"], children: [
        n,
        /* @__PURE__ */ t.jsxs("div", { className: Pe["buttons-container"], children: [
          a && /* @__PURE__ */ t.jsx(
            _t,
            {
              onClick: a.onClose,
              buttonType: "secondary",
              testId: a.testId,
              children: a.closeTitle
            }
          ),
          r && /* @__PURE__ */ t.jsx(
            _t,
            {
              testId: r.testId,
              onClick: r.onClick,
              buttonType: r != null && r.type ? "secondary" : "primary",
              children: r.title
            }
          )
        ] })
      ] })
    ] }) }) }),
    document.body
  );
}, c1 = () => {
  const e = S.get("useLanguage"), { t: n } = e();
  return /* @__PURE__ */ t.jsx("div", { className: "px-6 py-0.5 mr-auto rounded bg-button-alternative-text text-white", children: n("joint-portfolio.tag") });
}, Yn = vt(
  (e, n) => {
    const {
      id: r,
      name: a,
      showSwitchLabel: s = !1,
      showIcons: o = !0,
      disabled: l = !1,
      value: i = !1,
      onChange: c,
      onBlur: d,
      error: u,
      label: x,
      testId: h
    } = e;
    return /* @__PURE__ */ t.jsxs("div", { className: "flex items-center gap-[6.25px]", children: [
      /* @__PURE__ */ t.jsxs(
        ws,
        {
          ref: n,
          id: r,
          name: a,
          "data-cy": h ?? a,
          checked: i,
          onChange: c,
          className: A(
            "relative !inline-flex !flex-shrink-0 h-6 !border-2 border-transparent !rounded-full !cursor-pointer transition-colors ease-in-out duration-200 !outline !outline-1 !outline-offset-1 !ring-0 disabled:!bg-[--grey-40] disabled:!text-[--primary-light] disabled:!cursor-not-allowed",
            {
              "!bg-[--positive-default] hover:!bg-[--positive-darker] !text-[--primary-lighter] hover:!text-[--primary-light]": i
            },
            {
              "!bg-[--primary-default] hover:!bg-[--primary-darker] !text-[--primary-light] hover:!text-[--primary-default]": !i
            },
            {
              "!outline-[--negative-default] focus:!outline-[--grey-80]": !!u
            },
            {
              "!outline-transparent focus:!outline-[--grey-80]": !u
            },
            { "!w-14": s },
            { "!w-12": !s }
          ),
          onBlur: d,
          disabled: l,
          "aria-label": x,
          children: [
            /* @__PURE__ */ t.jsxs(
              "span",
              {
                className: A(
                  "pointer-events-none relative inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200",
                  { "translate-x-8": i && s },
                  { "translate-x-6": i && !s },
                  { "translate-x-0": !i }
                ),
                children: [
                  /* @__PURE__ */ t.jsx(
                    "span",
                    {
                      className: A(
                        "absolute inset-0 h-full w-full flex items-center justify-center transition-opacity",
                        { "opacity-0 ease-out duration-100": i },
                        { "opacity-100 ease-in duration-200": !i }
                      ),
                      children: o && /* @__PURE__ */ t.jsx(
                        Z,
                        {
                          className: A(
                            {
                              "text-[--primary-default] hover:text-[--primary-default]": !l
                            },
                            {
                              "!text-[--grey-40] hover:!text-[--grey-40]": !!l
                            }
                          ),
                          name: F.close,
                          size: X.xs
                        }
                      )
                    }
                  ),
                  /* @__PURE__ */ t.jsx(
                    "span",
                    {
                      className: A(
                        "absolute inset-0 h-full w-full flex items-center justify-center transition-opacity",
                        { "opacity-0 ease-out duration-100": !i },
                        { "opacity-100 ease-in duration-200": i }
                      ),
                      children: o && /* @__PURE__ */ t.jsx(
                        Z,
                        {
                          className: A(
                            {
                              "text-[--positive-default] hover:text-[--positive-darker]": !l
                            },
                            {
                              "!text-[--grey-40] hover:!text-[--grey-40]": !!l
                            }
                          ),
                          name: F.checkmark,
                          size: X.xs
                        }
                      )
                    }
                  )
                ]
              }
            ),
            s && /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
              /* @__PURE__ */ t.jsx(
                "span",
                {
                  className: A(
                    "absolute right-1.5 h-full flex items-center justify-center transition-opacity text-xs",
                    { "opacity-0 ease-out duration-100": i },
                    { "opacity-100 ease-in duration-200": !i }
                  ),
                  children: "AUS"
                }
              ),
              /* @__PURE__ */ t.jsx(
                "span",
                {
                  className: A(
                    "absolute left-1.5 h-full flex items-center justify-center transition-opacity text-xs",
                    { "opacity-0 ease-out duration-100": !i },
                    { "opacity-100 ease-in duration-200": i }
                  ),
                  children: "AN"
                }
              )
            ] })
          ]
        }
      ),
      x && /* @__PURE__ */ t.jsx(Un, { htmlFor: r ?? a, label: x })
    ] });
  }
);
Yn.displayName = "ToggleCheckbox";
const d1 = {
  "text-class": "_text-class_1c5dy_1"
}, u1 = ({
  button: e,
  heading: n,
  message: r,
  buttonSecond: a,
  visible: s,
  onClose: o,
  ...l
}) => {
  const i = {
    ...e,
    type: "secondary"
  }, c = a ? {
    onClose: a.onClick,
    closeTitle: a.title
  } : void 0;
  return /* @__PURE__ */ t.jsxs(
    Ur,
    {
      ...l,
      onClose: o,
      visible: s,
      confirmButton: i,
      closeButton: c,
      children: [
        /* @__PURE__ */ t.jsx(
          Z,
          {
            size: X.xxl,
            name: F.error,
            color: "var(--secondary-dark)"
          }
        ),
        /* @__PURE__ */ t.jsx(w, { textClass: d1["text-class"], fontSize: "xl", textAlign: "center", children: n }),
        /* @__PURE__ */ t.jsx(w, { textAlign: "center", fontWeight: "bold", children: r })
      ]
    }
  );
}, m1 = ({ message: e }) => {
  const n = typeof e == "string" ? e : e.map((r) => `${r} </br>`).join();
  return /* @__PURE__ */ t.jsx(De, { text: n });
}, Nt = ({
  isLoading: e,
  error: n = null,
  children: r,
  modal: a
}) => {
  var c;
  const [s, o] = ce(0), l = ye(null);
  if (ve(() => {
    const d = window.pageYOffset;
    e || o(d);
  }, [r, e]), ve(() => {
    e || window.scrollTo(0, s);
  }, [e, s]), e)
    return /* @__PURE__ */ t.jsx("div", { style: { height: (c = l == null ? void 0 : l.current) == null ? void 0 : c.clientHeight }, children: /* @__PURE__ */ t.jsx(l1, {}) });
  const i = (n == null ? void 0 : n.message) || (n == null ? void 0 : n.Message);
  return n !== null ? a ? /* @__PURE__ */ t.jsx(
    u1,
    {
      visible: !0,
      button: a.button,
      buttonSecond: a.buttonSecond,
      heading: a.heading,
      message: a.message
    }
  ) : i ? /* @__PURE__ */ t.jsx(m1, { message: i }) : null : /* @__PURE__ */ t.jsx("div", { ref: l, children: r });
}, vn = ({
  portfolioOverviewError: e = null,
  portfolioName: n,
  ExternalId: r,
  t: a
}) => {
  const s = [
    { key: a("wizard.portfolio"), value: n },
    { key: a("wizard.depot-number"), value: r }
  ];
  return /* @__PURE__ */ t.jsx(Nt, { isLoading: !1, error: e, children: /* @__PURE__ */ t.jsx(Ee, { children: s.map((o) => /* @__PURE__ */ t.jsxs(w, { children: [
    o.key,
    " ",
    o.value
  ] }, o.key)) }) });
}, qt = {
  "buttons-container": "_buttons-container_10kfm_1",
  "buttons-container-primary": "_buttons-container-primary_10kfm_21",
  "buttons-container-secondary": "_buttons-container-secondary_10kfm_31",
  "multistep-button-confirm": "_multistep-button-confirm_10kfm_43"
}, Be = ({
  onPrev: e,
  onNext: n
}) => /* @__PURE__ */ t.jsxs("div", { className: qt["buttons-container"], children: [
  e && /* @__PURE__ */ t.jsx("div", { className: qt["buttons-container-secondary"], children: /* @__PURE__ */ t.jsx(
    _t,
    {
      className: qt["multistep-button-return"],
      onClick: e.action,
      buttonType: "secondary",
      disabled: e.disabled,
      children: e.title
    }
  ) }),
  /* @__PURE__ */ t.jsx("div", { className: qt["buttons-container-primary"], children: /* @__PURE__ */ t.jsx(
    _t,
    {
      className: qt["multistep-button-confirm"],
      onClick: n.action,
      buttonType: "primary",
      disabled: n.disabled,
      children: n.title
    }
  ) })
] }), hr = (e, n) => {
  if (n !== "")
    return Number.isNaN(e) ? 0 : Number(e);
}, ut = {
  amountTopUp: "amountTopUp",
  currentProperty: "currentProperty",
  isGepValid: "isGepValid",
  transactionDate: "transactionDate"
}, Al = (e, n, r) => (a) => ft().shape({
  [ut.amountTopUp]: Tt().transform(hr).required(
    de(e("error.validation.amount-between"), {
      $minValue$: ue(a.min),
      $maxValue$: ue(a.max)
    })
  ).min(
    a.min,
    de(e("error.validation.amount-between"), {
      $minValue$: ue(a.min),
      $maxValue$: ue(a.max)
    })
  ).max(
    a.max,
    de(e("error.validation.amount-between"), {
      $minValue$: ue(a.min),
      $maxValue$: ue(a.max)
    })
  ),
  [ut.isGepValid]: r ? xn().oneOf([!0], e("error.validation.cannot-be-empty")) : le().oneOf(
    [!0, !1, "true", "false"],
    e("error.validation.cannot-be-empty")
  ),
  [ut.currentProperty]: le().when(
    [ut.isGepValid, ut.amountTopUp],
    (s, o) => s === "true" || s === !0 ? Tt().transform(hr).required(e("error.validation.cannot-be-empty")).min(
      (o ? Number(o) : 0) + n,
      e("error.investment-requirements-exceed-available")
    ) : le().optional()
  )
}), ht = {
  under20000: "under20000",
  "20000to50000": "20000to50000",
  "50000to100000": "50000to100000",
  over100000: "over100000"
}, zl = (e) => e < 2e4 ? ht.under20000 : e >= 2e4 && e < 5e4 ? ht["20000to50000"] : e >= 5e4 && e < 1e5 ? ht["50000to100000"] : ht.over100000, Fl = (e, n) => {
  const r = [
    ht.under20000,
    ht["20000to50000"],
    ht["50000to100000"],
    ht.over100000
  ];
  return r.indexOf(e) <= r.indexOf(n);
}, Vl = ({
  isLoading: e,
  error: n,
  t: r,
  onClose: a,
  onNext: s,
  onEntryFeesDetails: o,
  transactionDateInput: l,
  gepRadioOrCheckbox: i,
  portfolioData: c,
  hintText: d,
  currentPropertyLabel: u
}) => {
  var O, C;
  const x = S.get("usePortfolioName"), h = S.get("useFormContext"), {
    isLoading: f,
    portfolioName: g,
    error: y
  } = x(
    (O = c == null ? void 0 : c.Product) == null ? void 0 : O.Name,
    (C = c == null ? void 0 : c.RiskCategory) == null ? void 0 : C.Id
  ), { control: p, watch: b } = h(), v = {
    heading: r("error.warning1"),
    message: r("error.technical-error1"),
    button: {
      onClick: a,
      title: r("button.interrupt")
    }
  }, j = {
    action: s,
    title: r("button.next")
  }, _ = {
    action: a,
    title: r("button.interrupt")
  }, I = b(ut.isGepValid), k = I === "false" || I === !1;
  return /* @__PURE__ */ t.jsx(
    Nt,
    {
      isLoading: e || f,
      error: n,
      modal: v,
      children: /* @__PURE__ */ t.jsxs("div", { className: "space-y-10", children: [
        /* @__PURE__ */ t.jsx(
          vn,
          {
            t: r,
            portfolioOverviewError: y,
            portfolioName: g,
            ExternalId: (c == null ? void 0 : c.ExternalId) ?? ""
          }
        ),
        /* @__PURE__ */ t.jsx(w, { children: r("wizard.pay-in.text1") }),
        /* @__PURE__ */ t.jsxs("div", { className: "flex flex-col space-y-1", children: [
          /* @__PURE__ */ t.jsx(
            ke,
            {
              control: p,
              name: ut.amountTopUp,
              render: ({ field: R, fieldState: { error: P } }) => /* @__PURE__ */ t.jsx(
                pt,
                {
                  ...R,
                  id: "pay-in-amount",
                  label: r("field.pay-in-amount"),
                  symbol: "€",
                  error: P,
                  decimalScale: 2
                }
              )
            }
          ),
          o && /* @__PURE__ */ t.jsx(
            zr,
            {
              text: r("button.entry-fee-details"),
              onClick: o,
              fontWeight: "regular",
              className: "self-end underline",
              disabled: I === "false"
            }
          ),
          /* @__PURE__ */ t.jsx(
            De,
            {
              text: r("hint.settlementDate-for-SDD-and-DVK-product-replacement")
            }
          )
        ] }),
        l && /* @__PURE__ */ t.jsx("div", { children: l }),
        i && /* @__PURE__ */ t.jsx("div", { className: "py-2", children: i }),
        /* @__PURE__ */ t.jsxs("div", { className: "space-y-4", children: [
          /* @__PURE__ */ t.jsx(
            ke,
            {
              control: p,
              name: ut.currentProperty,
              render: ({ field: R, fieldState: { error: P } }) => /* @__PURE__ */ t.jsx(
                pt,
                {
                  ...R,
                  id: "current-property-amount",
                  label: r(u ?? "field.liquid-assets-amount"),
                  symbol: "€",
                  error: P,
                  decimalScale: 2,
                  disabled: k
                }
              )
            }
          ),
          /* @__PURE__ */ t.jsx(De, { text: d })
        ] }),
        /* @__PURE__ */ t.jsx(Be, { onNext: j, onPrev: _ })
      ] })
    }
  );
}, h1 = "_container_1k3c6_1", x1 = "_circle_1k3c6_27", f1 = "_line_1k3c6_79", g1 = "_svgClassName_1k3c6_109", ct = {
  container: h1,
  "progress-bar": "_progress-bar_1k3c6_13",
  "circle-wrapper": "_circle-wrapper_1k3c6_27",
  circle: x1,
  "circle-answered": "_circle-answered_1k3c6_49",
  "circle-inner": "_circle-inner_1k3c6_59",
  line: f1,
  "line-answered": "_line-answered_1k3c6_93",
  svgClassName: g1
}, p1 = ({
  step: e,
  progressBarSteps: n,
  shownSteps: r,
  containerClassName: a = "",
  headingClassName: s = "",
  progressContainerClassName: o = ""
}) => {
  const l = n[e - 1], i = r.includes(String(e)), c = A(ct["progress-bar"], {
    [o]: !!o
  });
  return !l && !i ? null : /* @__PURE__ */ t.jsxs("div", { className: a, children: [
    /* @__PURE__ */ t.jsx(Le, { size: 2, className: s, children: l }),
    /* @__PURE__ */ t.jsx("div", { className: c, children: i && r.map((d) => {
      const u = Number(d) < e, x = Number(d) === e, h = A(ct.line, {
        [ct["line-answered"]]: u
      }), f = A(ct.circle, {
        [ct["circle-answered"]]: u
      });
      return /* @__PURE__ */ t.jsxs(vs, { children: [
        /* @__PURE__ */ t.jsxs("div", { className: ct["circle-wrapper"], children: [
          /* @__PURE__ */ t.jsx("div", { className: f }),
          x && /* @__PURE__ */ t.jsx("div", { className: ct["circle-inner"] }),
          u && /* @__PURE__ */ t.jsx(
            "svg",
            {
              className: ct.svgClassName,
              "aria-hidden": "true",
              viewBox: "0 0 15 11",
              fill: "none",
              children: /* @__PURE__ */ t.jsx("path", { d: "M1 4.5L5 9L14 1", strokeWidth: "2", stroke: "#fff" })
            }
          )
        ] }),
        /* @__PURE__ */ t.jsx("div", { className: h })
      ] }, d);
    }) })
  ] });
}, v1 = ({
  visible: e,
  onClose: n,
  steps: r,
  closeIcon: a = !0,
  closeLabel: s = "Schließen"
}) => {
  const [o, l] = ce(1), [i, c] = ce(!1), d = G(() => r.map((j) => j.title), [r]), { renderContent: u } = r[o - 1] || {}, x = r.reduce(
    (j, _, I) => _ != null && _.hideStepBar ? j : [...j, String(I + 1)],
    []
  ), h = pe(
    (j) => {
      o !== 1 && l(
        (_) => typeof j == "number" ? j : _ - 1
      );
    },
    [o]
  ), f = pe(async (j) => {
    l(
      (_) => typeof j == "number" ? j : _ + 1
    );
  }, []), g = G(() => n, [n]), y = G(
    () => ({
      onPrev: h,
      onNext: f,
      onClose: g,
      setIsProgressBarHidden: c,
      isProgressBarHidden: i
    }),
    [h, f, g, i]
  ), b = ((j) => (_) => (
    // eslint-disable-next-line react/jsx-props-no-spreading
    /* @__PURE__ */ t.jsx(j, { ...y, ..._ })
  ))(u), v = (j) => {
    (j.code === "Enter" || j.code === "NumpadEnter") && n();
  };
  return e ? i ? /* @__PURE__ */ t.jsx(b, {}) : hn(
    /* @__PURE__ */ t.jsx("div", { className: Pe["modal-background"], children: /* @__PURE__ */ t.jsxs(Ee, { className: Pe["modal-wrapper"], children: [
      a && /* @__PURE__ */ t.jsx(
        "div",
        {
          role: "button",
          tabIndex: 0,
          onKeyDown: v,
          className: Pe["close-icon-wrapper"],
          onClick: n,
          "aria-label": s,
          children: /* @__PURE__ */ t.jsx(Z, { size: X.xs, name: F.close })
        }
      ),
      /* @__PURE__ */ t.jsx("div", { className: Pe["modal-progress-container"], children: /* @__PURE__ */ t.jsx(
        p1,
        {
          step: o,
          progressBarSteps: d,
          shownSteps: x
        }
      ) }),
      /* @__PURE__ */ t.jsx("div", { className: Pe["multi-step-modal-content"], children: /* @__PURE__ */ t.jsx(b, {}) })
    ] }) }),
    document.body
  ) : null;
}, Dl = zn(v1), Bl = ({
  visible: e,
  onClose: n,
  steps: r,
  setParentVisible: a,
  closeIcon: s = !0,
  defaultStep: o
}) => {
  const [l, i] = ce(o), { renderContent: c, title: d, isLarge: u = !1 } = r[l], x = pe((v) => {
    i(v);
  }, []), h = G(() => n, [n]), f = G(
    () => ({
      setStep: x,
      onClose: h,
      setParentVisible: a
    }),
    [x, h, a]
  ), y = ((v) => (j) => /* @__PURE__ */ t.jsx(v, { ...f, ...j }))(c), p = (v) => {
    (v.code === "Enter" || v.code === "NumpadEnter") && n();
  }, b = G(
    () => A(Pe["modal-wrapper"], {
      [Pe["modal-wrapper-large"]]: u
    }),
    [u]
  );
  return e ? hn(
    /* @__PURE__ */ t.jsx("div", { className: Pe["modal-background"], children: /* @__PURE__ */ t.jsxs(Ee, { className: b, children: [
      s && /* @__PURE__ */ t.jsx(
        "div",
        {
          role: "button",
          tabIndex: 0,
          onKeyDown: p,
          className: Pe["close-icon-wrapper"],
          onClick: n,
          "aria-label": "Close modal",
          children: /* @__PURE__ */ t.jsx(Z, { size: X.xs, name: F.close })
        }
      ),
      d && /* @__PURE__ */ t.jsx(Le, { size: 2, children: d }),
      /* @__PURE__ */ t.jsx("div", { className: Pe["multi-step-modal-content"], children: /* @__PURE__ */ t.jsx(y, {}) })
    ] }) }),
    document.body
  ) : null;
}, Yr = (e = 0, n, r = 0) => {
  const s = Number(e) / (100 + n.Platform) * n.Platform * (Number(100 - r) / 100), o = Number(e) - s, l = o ? s / o : 0;
  return {
    discountedEntryFeeAmount: un(s),
    newNetPayInAmount: un(o),
    discountedEntryFeeFormatted: un(
      l * 100
    ),
    discountedEntryFee: l * 100
  };
}, b1 = {
  "allocation-td": "_allocation-td_1e0w3_1"
}, Zl = ({
  portfolioOverview: e,
  allocations: n,
  exAnte: r,
  amount: a,
  transactionDate: s,
  hint: o,
  t: l,
  onNext: i,
  onPrev: c,
  phoneNumber: d
}) => {
  const { portfolioOverviewError: u, portfolioName: x, ExternalId: h } = e, {
    discountedEntryFeeAmount: f,
    newNetPayInAmount: g,
    discountedEntryFeeFormatted: y
  } = Yr(
    o.amountTopUp,
    o.fees,
    o.discountEntryFee
  ), p = `${l("hint.fee1")} ${g} €`, b = de(l("hint.fee2.top-up"), {
    $amount$: ue(o.amountTopUp),
    $entryFeeAmount$: f,
    $entryFee$: y,
    $investmentAmount$: g
  }), v = {
    action: i,
    title: l("button.next")
  }, j = {
    action: c,
    title: l("button.back")
  };
  return /* @__PURE__ */ t.jsxs("div", { className: "space-y-10", children: [
    /* @__PURE__ */ t.jsx(
      vn,
      {
        t: l,
        portfolioOverviewError: u,
        portfolioName: x,
        ExternalId: h
      }
    ),
    /* @__PURE__ */ t.jsxs("div", { className: "space-y-2", children: [
      /* @__PURE__ */ t.jsx(w, { children: l("wizard.pay-in-amount") }),
      /* @__PURE__ */ t.jsx(Le, { size: 3, children: a }),
      /* @__PURE__ */ t.jsx(w, { children: l("field.execution-date") }),
      /* @__PURE__ */ t.jsx(Le, { size: 3, children: s ? Re(s) : l("field.execution-date.value.as-soon-as-possible") })
    ] }),
    /* @__PURE__ */ t.jsxs("div", { className: "space-y-4", children: [
      /* @__PURE__ */ t.jsx(me, { children: l("wizard.pay-in.text2") }),
      /* @__PURE__ */ t.jsx(Yo, { title: l("wizard.subheader.target-funds"), children: /* @__PURE__ */ t.jsx("table", { children: /* @__PURE__ */ t.jsx("tbody", { children: n.map((_) => /* @__PURE__ */ t.jsxs("tr", { children: [
        /* @__PURE__ */ t.jsx("td", { className: b1["allocation-td"], children: _.value }),
        /* @__PURE__ */ t.jsx("td", { children: _.name })
      ] }, _.name)) }) }) })
    ] }),
    /* @__PURE__ */ t.jsxs("div", { className: "space-y-4", children: [
      /* @__PURE__ */ t.jsx(Le, { size: 3, children: l("wizard.pay-in.costs") }),
      /* @__PURE__ */ t.jsx(De, { text: p, description: b, textSize: "sm" })
    ] }),
    /* @__PURE__ */ t.jsx(gn, { name: l("filename.ex-ante"), exAnteFile: r }),
    d && /* @__PURE__ */ t.jsx(
      De,
      {
        text: de(l("wizard.hint.mtan1"), {
          $phoneNumber$: d
        }),
        colored: !0
      }
    ),
    /* @__PURE__ */ t.jsx(Be, { onNext: v, onPrev: j })
  ] });
}, j1 = {
  "step-layout": "_step-layout_1vo6k_1"
}, Xe = ({ children: e, className: n }) => {
  const r = A(j1["step-layout"], n);
  return /* @__PURE__ */ t.jsx("div", { className: r, children: e });
}, on = "amountPayOut", Hl = (e) => (n) => ft().shape({
  amountPayOut: Tt().transform(
    (r) => Number.isNaN(r) ? 0 : Number(r)
  ).required(
    de(e("error.validation.amount-between"), {
      $minValue$: ue(n.min),
      $maxValue$: ue(n.max)
    })
  ).min(
    n.min,
    de(e("error.validation.amount-between"), {
      $minValue$: ue(n.min),
      $maxValue$: ue(n.max)
    })
  ).max(
    n.max,
    de(e("error.validation.amount-between"), {
      $minValue$: ue(n.min),
      $maxValue$: ue(n.max)
    })
  )
}), ql = ({
  amount: e,
  formProps: n,
  portfolioOverview: r,
  isLoading: a,
  error: s,
  modalErrorMessage: o,
  onClose: l,
  onNext: i,
  t: c,
  pendingOrdersAmount: d,
  headingError: u
}) => {
  const { portfolioOverviewError: x, portfolioName: h, ExternalId: f } = r, { onChange: g, errors: y, values: p } = n, b = {
    action: i,
    title: c("button.next")
  }, v = {
    action: l,
    title: c("button.interrupt")
  }, j = {
    button: {
      title: c("button.interrupt"),
      onClick: l
    },
    heading: u ?? c("error.warning1"),
    message: o
  };
  return /* @__PURE__ */ t.jsx(Nt, { isLoading: a, error: s, modal: j, children: /* @__PURE__ */ t.jsxs(Xe, { children: [
    /* @__PURE__ */ t.jsx(
      vn,
      {
        portfolioOverviewError: x,
        portfolioName: h,
        ExternalId: f,
        t: c
      }
    ),
    /* @__PURE__ */ t.jsxs(w, { children: [
      c("wizard.deposit-value"),
      " ",
      e
    ] }),
    d && /* @__PURE__ */ t.jsxs(w, { children: [
      c("wizard.pendingSellOrdersAmount"),
      " ",
      d
    ] }),
    /* @__PURE__ */ t.jsx(me, { children: c("wizard.pay-out.text1") }),
    /* @__PURE__ */ t.jsx(
      pt,
      {
        id: "pay-out-amount-input",
        name: on,
        label: c("field.pay-out-amount"),
        symbol: "€",
        onChange: g(on),
        error: y == null ? void 0 : y[on],
        value: p(on),
        decimalScale: 2
      }
    ),
    /* @__PURE__ */ t.jsx(Be, { onNext: b, onPrev: v })
  ] }) });
}, Gl = ({
  amount: e,
  iban: n,
  portfolioOverview: r,
  exAnte: a,
  t: s,
  onPrev: o,
  onNext: l,
  // Only for ClientHub required
  phoneNumber: i
}) => {
  const { portfolioOverviewError: c, portfolioName: d, ExternalId: u } = r, x = {
    action: l,
    title: s("button.next")
  }, h = {
    action: o,
    title: s("button.back")
  };
  return /* @__PURE__ */ t.jsxs(Xe, { children: [
    /* @__PURE__ */ t.jsx(
      vn,
      {
        portfolioOverviewError: c,
        portfolioName: d,
        ExternalId: u,
        t: s
      }
    ),
    /* @__PURE__ */ t.jsxs(w, { children: [
      s("wizard.pay-out-amount"),
      " ",
      e
    ] }),
    /* @__PURE__ */ t.jsxs("div", { children: [
      /* @__PURE__ */ t.jsx(w, { children: s("wizard.reference-account") }),
      /* @__PURE__ */ t.jsxs(w, { children: [
        s("wizard.iban"),
        " ",
        Sr(n)
      ] })
    ] }),
    /* @__PURE__ */ t.jsx(me, { children: s("wizard.pay-out.text2") }),
    /* @__PURE__ */ t.jsx(me, { children: s("wizard.pay-out.text3") }),
    a.zeroCostStatement ? /* @__PURE__ */ t.jsx(w, { fontWeight: "bold", children: s("wizard.pay-out.text4") }) : /* @__PURE__ */ t.jsx(
      gn,
      {
        name: s("filename.ex-ante"),
        exAnteFile: a.exAnteCostStatement
      }
    ),
    i && /* @__PURE__ */ t.jsx(
      De,
      {
        text: de(s("wizard.hint.mtan1"), {
          $phoneNumber$: i
        }),
        colored: !0
      }
    ),
    /* @__PURE__ */ t.jsx(Be, { onNext: x, onPrev: h })
  ] });
}, w1 = (e) => e ? e.reduce(
  (n, r) => ({
    ...n,
    [String(r.Id)]: r.Name
  }),
  {}
) : {}, y1 = ({
  dataPortfolio: e,
  t: n,
  isLoading: r,
  dataRiskCategories: a,
  isShowAmount: s = !1
}) => {
  const o = (e == null ? void 0 : e.ExternalId) ?? "", l = (e == null ? void 0 : e.Product.Name) ?? "", i = (e == null ? void 0 : e.RiskCategory.Id) ?? "", c = w1(a), d = i && c[String(i)], u = _e(e == null ? void 0 : e.CurrentValue);
  return /* @__PURE__ */ t.jsx(Ee, { children: r ? /* @__PURE__ */ t.jsxs("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ t.jsx(fe, {}),
    /* @__PURE__ */ t.jsx(fe, {})
  ] }) : /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
    /* @__PURE__ */ t.jsxs("div", { className: "flex justify-between", children: [
      /* @__PURE__ */ t.jsxs(w, { children: [
        n("wizard.portfolio"),
        " ",
        l,
        " ",
        d
      ] }),
      s && /* @__PURE__ */ t.jsx(w, { fontWeight: "bold", children: u })
    ] }),
    /* @__PURE__ */ t.jsxs(w, { children: [
      n("wizard.depot-number"),
      " ",
      o
    ] })
  ] }) });
}, bn = ({
  clientId: e,
  portfolioId: n,
  isShowAmount: r = !1
}) => {
  const a = S.get("useLanguage"), s = S.get("useGetPortfolioDetails"), { t: o } = a(), { isLoading: l, data: i } = s({
    clientId: String(e),
    portfolioId: n,
    refetchOnMount: !1
  }), c = S.get("useGetRiskCategories"), { isLoading: d, data: u } = c({
    refetchOnMount: !1
  });
  return /* @__PURE__ */ t.jsx(
    y1,
    {
      t: o,
      isLoading: l || d,
      dataPortfolio: i,
      dataRiskCategories: u,
      isShowAmount: r
    }
  );
}, Qt = (e, n) => n.reduce((a, s) => {
  if (typeof e == "function") {
    if (e(s))
      return [...a, s];
  } else if (e[s])
    return [...a, s];
  return a;
}, []), _1 = ({ isSecond: e = !1 }) => {
  const n = S.get("useLanguage"), r = S.get("useFormContext"), a = S.get("useFormValues"), { t: s } = n(), { trigger: o, setValue: l, control: i } = r(), c = a(), d = G(
    () => bt(e),
    [e]
  ), u = pe(
    (h, f) => {
      l(h, f, {
        shouldValidate: !0
      });
      const y = Qt(c, [
        d.startIncreaseMonth,
        d.startIncreaseYear
      ]).filter(
        (p) => p !== h
      );
      o(y);
    },
    [
      l,
      o,
      c,
      d.startIncreaseMonth,
      d.startIncreaseYear
    ]
  ), x = c[d.dynamicSavingsPlan];
  return /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
    /* @__PURE__ */ t.jsx(
      ke,
      {
        control: i,
        name: d.dynamicSavingsPlan,
        render: ({
          field: { onChange: h, value: f, name: g },
          fieldState: { error: y }
        }) => /* @__PURE__ */ t.jsx(
          Yn,
          {
            id: `dynamic-savings-plan-toggle-${e ? "second" : "first"}`,
            name: g,
            value: f,
            onChange: h,
            label: s("toggle.dynamic-savings-plan"),
            error: y
          }
        )
      }
    ),
    x && /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
      /* @__PURE__ */ t.jsx(me, { fontSize: "sm", children: s("wizard.saving-plan.text2") }),
      /* @__PURE__ */ t.jsx(
        ke,
        {
          control: i,
          name: d.annualIncrease,
          render: ({ field: { name: h, value: f }, fieldState: { error: g } }) => /* @__PURE__ */ t.jsx(
            pt,
            {
              id: `annual-increase-input-${e ? "second" : "first"}`,
              name: h,
              value: f,
              onChange: (y) => l(h, y, { shouldValidate: !0 }),
              error: g,
              label: s("field.dynamic-savings-plan-rate"),
              symbol: "%",
              decimalScale: 0,
              thousandSeparator: ""
            }
          )
        }
      ),
      /* @__PURE__ */ t.jsxs("div", { className: "grid gap-4 sm:grid-cols-2", children: [
        /* @__PURE__ */ t.jsx(
          ke,
          {
            control: i,
            name: d.startIncreaseYear,
            render: ({ field: { name: h, value: f }, fieldState: { error: g } }) => /* @__PURE__ */ t.jsx(
              Ct,
              {
                name: h,
                error: g,
                onChange: (y) => u(h, y),
                value: f,
                label: s("field.dynamic-saving-plan-start-year"),
                options: Co,
                direction: "upwards"
              }
            )
          }
        ),
        /* @__PURE__ */ t.jsx(
          ke,
          {
            control: i,
            name: d.startIncreaseMonth,
            render: ({ field: { name: h, value: f }, fieldState: { error: g } }) => /* @__PURE__ */ t.jsx(
              Ct,
              {
                name: h,
                value: f,
                onChange: (y) => u(h, y),
                label: s("field.dynamic-saving-plan-start-month"),
                options: _o,
                error: g,
                direction: "upwards"
              }
            )
          }
        )
      ] })
    ] })
  ] });
}, Wr = ({ t: e, isSecond: n = !1 }) => {
  const r = S.get("useFormContext"), a = S.get("useFormValues"), { control: s, setValue: o, trigger: l } = r(), i = a(), c = G(
    () => bt(n),
    [n]
  ), d = i[c.timeLimitToggle], u = i[c.executionDay], x = i[c.transactionDate], h = i[c.timeLimitMonth], f = i[c.timeLimitYear], g = G(
    () => Bn({
      timeLimitMonth: h,
      timeLimitYear: f,
      executionDay: u,
      transactionDate: x
    }),
    [h, f, u, x]
  ), y = G(
    () => Zn({
      timeLimitMonth: h,
      timeLimitYear: f
    }),
    [h, f]
  ), p = G(
    () => u && f && h && g && y,
    [
      u,
      f,
      h,
      g,
      y
    ]
  ), b = G(() => u && h && f ? de(e("hint.savings-plan-limit"), {
    $month$: Ke == null ? void 0 : Ke[h],
    $year$: f,
    $day$: u
  }) : "", [u, e, h, f]), v = pe(
    (_, I) => {
      o(_, I, {
        shouldValidate: !0
      });
      const k = Qt(i, [
        c.timeLimitYear,
        c.timeLimitMonth,
        c.startIncreaseMonth,
        c.startIncreaseYear
      ]);
      l(k);
    },
    [
      o,
      l,
      i,
      c.timeLimitYear,
      c.timeLimitMonth,
      c.startIncreaseMonth,
      c.startIncreaseYear
    ]
  ), j = pe(
    (_, I) => {
      o(_, I, {
        shouldValidate: !0
      });
      const k = Qt(i, [
        c.startIncreaseMonth,
        c.startIncreaseYear
      ]);
      l(k);
    },
    [
      o,
      l,
      i,
      c.startIncreaseMonth,
      c.startIncreaseYear
    ]
  );
  return /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
    /* @__PURE__ */ t.jsx(
      ke,
      {
        control: s,
        name: c.timeLimitToggle,
        render: ({ field: { name: _, value: I }, fieldState: { error: k } }) => /* @__PURE__ */ t.jsx(
          Yn,
          {
            id: `time-limit-toggle-${n ? "second" : "first"}`,
            name: _,
            label: e("toggle.savings-plan-limit"),
            onChange: (O) => j(_, O),
            error: k,
            value: I
          }
        )
      }
    ),
    d && /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
      /* @__PURE__ */ t.jsxs("div", { className: "grid gap-4 sm:grid-cols-2", children: [
        /* @__PURE__ */ t.jsx(
          ke,
          {
            name: c.timeLimitYear,
            control: s,
            render: ({ field: { name: _, value: I }, fieldState: { error: k } }) => /* @__PURE__ */ t.jsx(
              Ct,
              {
                name: _,
                value: I,
                options: fo,
                onChange: (O) => v(_, O),
                label: e("field.savings-plan-limit-year"),
                error: k,
                direction: "upwards"
              }
            )
          }
        ),
        /* @__PURE__ */ t.jsx(
          ke,
          {
            control: s,
            name: c.timeLimitMonth,
            render: ({ field: { name: _, value: I }, fieldState: { error: k } }) => /* @__PURE__ */ t.jsx(
              Ct,
              {
                name: _,
                value: I,
                onChange: (O) => v(_, O),
                options: go,
                label: e("field.savings-plan-limit-month"),
                error: k,
                direction: "upwards"
              }
            )
          }
        )
      ] }),
      p && /* @__PURE__ */ t.jsx(De, { text: b })
    ] })
  ] });
}, C1 = "_container_3bvje_1", N1 = "_date_3bvje_17", S1 = "_info_3bvje_39", Mn = {
  container: C1,
  "date-hint": "_date-hint_3bvje_17",
  date: N1,
  info: S1
}, I1 = ({
  executionDay: e,
  t: n,
  transactionDate: r = null
}) => {
  if (!e)
    return null;
  const { renderExecutionDay: a } = Dn(
    Number(e),
    r
  );
  return /* @__PURE__ */ t.jsxs("div", { className: Mn.container, children: [
    /* @__PURE__ */ t.jsxs("div", { className: Mn["date-hint"], children: [
      /* @__PURE__ */ t.jsx(Z, { name: F.hintCircle }),
      /* @__PURE__ */ t.jsxs(w, { children: [
        n("hint.savings-plan-execution-date1"),
        " ",
        /* @__PURE__ */ t.jsx("b", { children: a })
      ] })
    ] }),
    /* @__PURE__ */ t.jsx("div", { className: Mn.info, children: /* @__PURE__ */ t.jsx(me, { children: n("hint.savings-plan-execution-date2") }) })
  ] });
}, k1 = ({
  isSecond: e = !1,
  translations: n,
  showBudgetarySurplusTooltip: r = !0,
  isBudgetarySurplusDisabled: a = !1,
  isBudgetarySurplusHidden: s = !1
}) => {
  const o = S.get("useLanguage"), l = S.get("useFormContext"), i = S.get("useFormValues"), { t: c } = o(), { setValue: d, trigger: u, control: x } = l(), h = i(), f = bt(e), g = pe(
    (p, b) => {
      d(p, b, {
        shouldValidate: !0
      });
      const _ = [
        ...[
          f.budgetarySurplus,
          f.monthlySavingsRate
        ],
        e ? gt.monthlySavingsRate : $r.monthlySavingsRate
      ].filter(
        (k) => k !== p
      ), I = Qt(
        h,
        _
      );
      u(I);
    },
    [
      d,
      f.budgetarySurplus,
      f.monthlySavingsRate,
      e,
      u,
      h
    ]
  ), y = pe(
    (p, b) => {
      d(p, b, {
        shouldValidate: !0
      });
      const v = Qt(h, [
        f.startIncreaseMonth,
        f.startIncreaseYear,
        f.timeLimitMonth,
        f.timeLimitYear
      ]);
      u(v);
    },
    [
      d,
      u,
      h,
      f.startIncreaseMonth,
      f.startIncreaseYear,
      f.timeLimitMonth,
      f.timeLimitYear
    ]
  );
  return /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
    /* @__PURE__ */ t.jsx(
      ke,
      {
        control: x,
        name: f.monthlySavingsRate,
        render: ({ field: { value: p, name: b }, fieldState: { error: v } }) => /* @__PURE__ */ t.jsx(
          pt,
          {
            id: "monthly-savings-rate-input",
            name: b,
            value: p,
            onChange: (j) => {
              g(b, j);
            },
            error: v,
            symbol: "€",
            label: n != null && n.monthlySavingsRate ? c(n.monthlySavingsRate) : c("field.saving-plan-amount"),
            decimalScale: 2
          }
        )
      }
    ),
    !e && !s && /* @__PURE__ */ t.jsxs("div", { className: "flex items-center space-x-3", children: [
      /* @__PURE__ */ t.jsx("div", { className: "w-full", children: /* @__PURE__ */ t.jsx("div", { children: /* @__PURE__ */ t.jsx(
        ke,
        {
          control: x,
          name: f.budgetarySurplus,
          render: ({ field: { name: p, value: b }, fieldState: { error: v } }) => /* @__PURE__ */ t.jsx(
            pt,
            {
              id: "budgetary-surplus-input",
              name: p,
              value: b,
              onChange: (j) => {
                g(p, j);
              },
              error: v,
              label: n != null && n.budgetarySurplus ? c(n.budgetarySurplus) : c("field.monthly-household-surplus"),
              symbol: "€",
              decimalScale: 2,
              disabled: a
            }
          )
        }
      ) }) }),
      r && /* @__PURE__ */ t.jsx("div", { children: /* @__PURE__ */ t.jsx(
        At,
        {
          placement: Rt.RIGHT,
          content: c("infotext.field.budgetary-surplus"),
          size: Kt.SMALL,
          children: /* @__PURE__ */ t.jsx(
            Z,
            {
              name: F.informationFilled,
              size: X.m,
              color: "var(--black)"
            }
          )
        }
      ) })
    ] }),
    /* @__PURE__ */ t.jsxs("div", { className: "grid gap-4 sm:grid-cols-2", children: [
      /* @__PURE__ */ t.jsx(
        ke,
        {
          control: x,
          name: f.executionDay,
          render: ({ field: { name: p, value: b }, fieldState: { error: v } }) => /* @__PURE__ */ t.jsx(
            Ct,
            {
              name: p,
              value: b,
              onChange: (j) => {
                y(p, j);
              },
              label: n != null && n.executionDay ? c(n.executionDay) : c("field.execution-day"),
              options: vo,
              error: v
            }
          )
        }
      ),
      /* @__PURE__ */ t.jsx(
        ke,
        {
          control: x,
          name: f.quarterSavingsPlan,
          render: ({ field: { name: p, value: b }, fieldState: { error: v } }) => /* @__PURE__ */ t.jsx(
            Ct,
            {
              name: p,
              value: b,
              onChange: (j) => {
                g(p, j);
              },
              label: n != null && n.quarterSavingsPlan ? c(n.quarterSavingsPlan) : c("field.saving-plan-frequency"),
              options: bo,
              error: v
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ t.jsx(
      I1,
      {
        transactionDate: h[f.transactionDate],
        executionDay: h[f.executionDay],
        t: c
      }
    )
  ] });
}, L1 = ({
  t: e,
  showBudgetarySurplusTooltip: n = !0,
  translations: r
}) => {
  const s = S.get("useFormValues")();
  return G(
    () => s[gt.savingAction] === Oe.CREATE_MODIFY,
    [s]
  ) ? /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
    /* @__PURE__ */ t.jsx(w, { children: e("wizard.saving-plan.text1") }),
    /* @__PURE__ */ t.jsx(
      k1,
      {
        showBudgetarySurplusTooltip: n,
        translations: r
      }
    ),
    /* @__PURE__ */ t.jsx(Wr, { t: e }),
    /* @__PURE__ */ t.jsx(_1, {})
  ] }) : null;
}, E1 = {
  "overview-table-td": "_overview-table-td_1mrcj_1"
}, Kr = ({ tableData: e }) => /* @__PURE__ */ t.jsx("table", { children: /* @__PURE__ */ t.jsx("tbody", { children: e.map((n) => /* @__PURE__ */ t.jsxs("tr", { children: [
  /* @__PURE__ */ t.jsx("td", { className: E1["overview-table-td"], children: n.key }),
  /* @__PURE__ */ t.jsx("td", { children: n.value })
] }, n.key)) }) }), $1 = ({
  savings: e,
  t: n,
  phoneNumber: r
  // Only for ClientHub required
}) => {
  const a = S.get("useFormContext"), s = S.get("useFormValues"), { control: o } = a(), l = s();
  return G(
    () => l[gt.savingAction] === Oe.CREATE_MODIFY,
    [l]
  ) ? null : /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
    /* @__PURE__ */ t.jsx(w, { children: n("wizard.saving-plan.text3") }),
    /* @__PURE__ */ t.jsx(Kr, { tableData: e }),
    /* @__PURE__ */ t.jsx(
      ke,
      {
        control: o,
        name: gt.deleteCheckbox,
        render: ({
          field: { name: c, onChange: d, value: u },
          fieldState: { error: x }
        }) => /* @__PURE__ */ t.jsx(
          en,
          {
            id: "saving-plan-delete-checkbox",
            name: c,
            onChange: d,
            checked: u,
            label: n("wizard.saving-plan-delete-checkbox"),
            error: x
          }
        )
      }
    ),
    r && /* @__PURE__ */ t.jsx(
      De,
      {
        text: de(n("wizard.hint.mtan1"), {
          $phoneNumber$: r
        }),
        colored: !0
      }
    )
  ] });
}, Ul = ({
  isLoading: e,
  savingData: n,
  error: r,
  phoneNumber: a,
  onPrev: s,
  onNext: o,
  onClose: l,
  showBudgetarySurplusTooltip: i = !0,
  translations: c,
  transactionDate: d = null
}) => {
  const u = S.get("useLanguage"), x = S.get("useFormContext"), { t: h } = u(), f = S.get(
    "useClientPortfolioIds"
  ), { clientId: g, portfolioId: y } = f(), { control: p, setValue: b } = x(), v = G(
    () => ({
      heading: h("error.warning1"),
      message: h("error.technical-error1"),
      button: {
        onClick: l,
        title: h("button.interrupt")
      }
    }),
    [h, l]
  ), j = G(
    () => ({
      action: o,
      title: h("button.next")
    }),
    [o, h]
  ), _ = G(
    () => ({
      action: s,
      title: h("button.back")
    }),
    [s, h]
  ), I = G(
    () => Ro(n, h),
    [n, h]
  );
  return ve(() => {
    b(gt.transactionDate, d);
  }, [d, b]), /* @__PURE__ */ t.jsx(Nt, { isLoading: e, error: r, modal: v, children: /* @__PURE__ */ t.jsxs(Xe, { children: [
    /* @__PURE__ */ t.jsx(
      bn,
      {
        clientId: g,
        portfolioId: y
      }
    ),
    n && /* @__PURE__ */ t.jsx(
      ke,
      {
        control: p,
        name: gt.savingAction,
        render: ({
          field: { name: k, value: O },
          fieldState: { error: C }
        }) => /* @__PURE__ */ t.jsx(
          t1,
          {
            name: k,
            options: po(h),
            onChange: (R) => b(k, R, {
              shouldValidate: !0
            }),
            error: C,
            value: O
          }
        )
      }
    ),
    /* @__PURE__ */ t.jsx(
      L1,
      {
        t: h,
        showBudgetarySurplusTooltip: i,
        translations: c
      }
    ),
    /* @__PURE__ */ t.jsx($1, { t: h, savings: I, phoneNumber: a }),
    /* @__PURE__ */ t.jsx(Be, { onNext: j, onPrev: _ })
  ] }) });
}, Yl = ({
  savingData: e,
  exAnte: n,
  onPrev: r,
  onNext: a,
  phoneNumber: s,
  hint: o
}) => {
  const l = S.get("useLanguage"), { t: i } = l(), c = S.get(
    "useClientPortfolioIds"
  ), { clientId: d, portfolioId: u } = c(), x = S.get("useGetPortfolioDetails"), {
    isLoading: h,
    data: f,
    error: g
  } = x({
    clientId: String(d),
    portfolioId: u,
    refetchOnMount: !1
  }), y = (f == null ? void 0 : f.CustomAttributes) && JSON.parse(f.CustomAttributes), p = (y == null ? void 0 : y.DiscountRate) ?? 0, b = {
    action: a,
    title: i("button.next")
  }, v = {
    action: r,
    title: i("button.back")
  }, {
    discountedEntryFeeAmount: j,
    newNetPayInAmount: _,
    discountedEntryFeeFormatted: I
  } = Yr(
    Number(e.monthlySavingsRate),
    o.fees,
    p
  ), k = `${i(
    "hint.fee2.savings-plan.header"
  )} ${_} €`, O = de(i("hint.fee2.savings-plan"), {
    $amount$: ue(e.monthlySavingsRate),
    $entryFeeAmount$: j,
    $entryFee$: I,
    $investmentAmount$: _
  }), C = Er(e, i), R = {
    heading: i("error.warning1"),
    message: i("error.technical-error1"),
    button: {
      onClick: r,
      title: i("button.interrupt")
    }
  };
  return /* @__PURE__ */ t.jsx(
    Nt,
    {
      isLoading: h,
      error: g,
      modal: R,
      children: /* @__PURE__ */ t.jsxs(Xe, { children: [
        /* @__PURE__ */ t.jsx(
          bn,
          {
            clientId: d,
            portfolioId: u
          }
        ),
        /* @__PURE__ */ t.jsx(Kr, { tableData: C }),
        /* @__PURE__ */ t.jsx(De, { text: k, description: O }),
        /* @__PURE__ */ t.jsx(gn, { name: i("filename.ex-ante"), exAnteFile: n }),
        s && /* @__PURE__ */ t.jsx(
          De,
          {
            colored: !0,
            text: de(i("wizard.hint.mtan1"), {
              $phoneNumber$: s
            })
          }
        ),
        /* @__PURE__ */ t.jsx(Be, { onNext: b, onPrev: v })
      ] })
    }
  );
}, M1 = ({
  contactData: e,
  dataCountry: n,
  countryPhoneCodeData: r,
  dataContactAccounts: a,
  isClientCockpit: s,
  handleEmailChange: o,
  handlePhoneNumberChange: l,
  handlePasswordChange: i
}) => {
  var ee, T, E, Y, se, W, ae, ie, Ae, Ue, Qe, at, ot, qe, it, et, St, jt, It, kt, Ye, tt, $, z, H, re, ge;
  const c = ((T = (ee = e == null ? void 0 : e.details) == null ? void 0 : ee.personalInformation) == null ? void 0 : T.dateOfBirth) && Re(e.details.personalInformation.dateOfBirth), d = {
    heading: "contact.personalInformation.personalinformationtitle",
    items: [
      {
        key: "personalInformationFirstLine",
        values: [
          {
            title: "crm.personalInformation.salutation",
            value: (Y = (E = e == null ? void 0 : e.details) == null ? void 0 : E.personalInformation) == null ? void 0 : Y.salutation
          },
          {
            title: "contact.personalIinformation.title",
            value: (W = (se = e == null ? void 0 : e.details) == null ? void 0 : se.personalInformation) == null ? void 0 : W.title
          },
          {
            title: "crm.personalInformation.dateOfBirth",
            value: c
          }
        ]
      },
      {
        key: "personalInformationSecondLine",
        values: [
          {
            title: "crm.personalInformation.firstName",
            value: (ie = (ae = e == null ? void 0 : e.details) == null ? void 0 : ae.personalInformation) == null ? void 0 : ie.firstName
          },
          {
            title: "crm.personalInformation.lastName",
            value: (Ue = (Ae = e == null ? void 0 : e.details) == null ? void 0 : Ae.personalInformation) == null ? void 0 : Ue.lastName
          }
        ]
      }
    ]
  }, u = ((Qe = e == null ? void 0 : e.details) == null ? void 0 : Qe.personalInformation.primaryAddressStreet) || "", x = ((ot = (at = e == null ? void 0 : e.details) == null ? void 0 : at.personalInformation) == null ? void 0 : ot.primaryAddressStreetNumber) || "", h = `${u} ${x}`, f = (qe = e == null ? void 0 : e.details) == null ? void 0 : qe.personalInformation.primaryAddressPostalCode, g = (it = e == null ? void 0 : e.details) == null ? void 0 : it.personalInformation.primaryAddressCity, y = f && g && `${f} ${g}`, p = (St = (et = e == null ? void 0 : e.details) == null ? void 0 : et.personalInformation) == null ? void 0 : St.primaryAddressCountry, b = (jt = n == null ? void 0 : n.data) == null ? void 0 : jt.items, v = (It = b == null ? void 0 : b.find(
    (K) => K.id === Number(p)
  )) == null ? void 0 : It.label, j = {
    heading: "contact.personalInformation.addresstitle",
    items: [
      {
        key: "address",
        values: [
          {
            title: "contact.personalInformation.streetandhousenumber",
            value: h
          },
          {
            title: "contact.personalInformation.plzandcity",
            value: y
          },
          {
            title: "crm.personalInformation.primaryAddressCountry",
            value: v
          }
        ]
      }
    ]
  }, _ = (a == null ? void 0 : a.filter((K) => {
    var U;
    return ((U = K.Type) == null ? void 0 : U.Name) === "Cash";
  })) || [], O = {
    heading: "contact.personalInformation.accounttitle",
    items: Array.from(
      new Set((_ == null ? void 0 : _.map((K) => {
        var U, Ce;
        return (Ce = (U = K.Iban) == null ? void 0 : U.split("_")) == null ? void 0 : Ce[1];
      })) || [])
    ).map((K) => {
      var Te, Ze;
      const U = _.filter(
        (Ft) => {
          var lt, Vt;
          return ((Vt = (lt = Ft.Iban) == null ? void 0 : lt.split("_")) == null ? void 0 : Vt[1]) === K;
        }
      ), Ce = (Ze = JSON.parse(((Te = U == null ? void 0 : U[0]) == null ? void 0 : Te.Attributes) || "{}")) == null ? void 0 : Ze.Bic, ze = Array.from(
        new Set(U == null ? void 0 : U.map((Ft) => {
          var lt;
          return (lt = Ft.InternalId.split("_")) == null ? void 0 : lt[1];
        }))
      );
      return {
        key: "ibanBic",
        values: [
          {
            title: "common.iban",
            value: K
          },
          {
            title: "common.bic",
            value: Ce
          },
          {
            title: "common.portfolioExternalId",
            value: ze.join(", ")
          }
        ]
      };
    }) || []
  }, C = (Ye = (kt = e == null ? void 0 : e.details) == null ? void 0 : kt.personalInformation) == null ? void 0 : Ye.primaryPhoneCountryCode, R = ($ = (tt = e == null ? void 0 : e.details) == null ? void 0 : tt.personalInformation) == null ? void 0 : $.primaryPhoneNumber, P = (z = r == null ? void 0 : r.data) == null ? void 0 : z.items, M = (H = P == null ? void 0 : P.find(
    (K) => K.id === Number(C)
  )) == null ? void 0 : H.label, D = M == null ? void 0 : M.substring(
    M.indexOf("(") + 1,
    M.lastIndexOf(")")
  ), B = R && D && `${D}-${R}`, J = {
    heading: "contact.personalInformation.logindetailstitle",
    items: [
      {
        key: "login-details",
        values: [
          {
            title: "crm.personalInformation.primaryEmail",
            value: (ge = (re = e == null ? void 0 : e.details) == null ? void 0 : re.personalInformation) == null ? void 0 : ge.primaryEmail,
            onClick: o
          },
          {
            title: "crm.personalInformation.primaryPhoneNumber",
            value: B,
            onClick: l
          },
          {
            title: s && "crm.personalInformation.primaryPassword",
            value: "*********",
            onClick: i
          }
        ]
      }
    ]
  };
  return [d, j, O, J];
}, Wl = ({
  isClientCockpit: e = !1,
  handleEmailChange: n,
  handlePhoneNumberChange: r,
  handlePasswordChange: a,
  headSize: s = 4,
  headClassNames: o = "mb-4"
}) => {
  const l = S.get("useLanguage"), { t: i } = l(), c = S.get(
    "useClientPortfolioIds"
  ), { clientId: d } = c(), u = S.get(
    "getSchemaListByKeyQuery"
  ), { isLoading: x, data: h } = u({
    key: "country",
    refetchOnMount: !1
  }), { isLoading: f, data: g } = u({
    key: "supportedCountryPhoneCode",
    refetchOnMount: !1
  }), y = S.get("getContactDetails"), { isLoading: p, data: b } = y({ clientId: d }), v = S.get(
    "useGetContactAccounts"
  ), { isLoading: j, data: _ } = v({ clientId: d }), I = M1({
    contactData: b,
    dataCountry: h,
    handleEmailChange: n,
    handlePasswordChange: a,
    handlePhoneNumberChange: r,
    countryPhoneCodeData: g,
    isClientCockpit: e,
    dataContactAccounts: _
  }), k = p || f || x || j;
  return /* @__PURE__ */ t.jsx("div", { className: "flex flex-col gap-8", children: I.map((O) => /* @__PURE__ */ t.jsxs("div", { children: [
    /* @__PURE__ */ t.jsx(Le, { size: s, className: o, children: i(O.heading) }),
    O.items.map((C) => {
      var R;
      return /* @__PURE__ */ t.jsx(
        "div",
        {
          className: "flex gap-6 mb-2",
          children: C.values.map((P) => P.title ? /* @__PURE__ */ t.jsxs("div", { children: [
            /* @__PURE__ */ t.jsxs("div", { className: "flex gap-4 mb-1", children: [
              /* @__PURE__ */ t.jsx(w, { fontWeight: "bold", children: i(P.title) }),
              (P == null ? void 0 : P.onClick) && /* @__PURE__ */ t.jsx(
                zr,
                {
                  icon: F.edit,
                  text: "Bearbeiten",
                  fontWeight: "regular",
                  size: X.s,
                  colored: !0,
                  onClick: P.onClick
                }
              )
            ] }),
            /* @__PURE__ */ t.jsx(w, { fontSize: "sm", children: k ? /* @__PURE__ */ t.jsx(fe, { width: 32 }) : P.value })
          ] }, P.title) : null)
        },
        `${C.key}-${(R = C == null ? void 0 : C.values) == null ? void 0 : R[0].value}`
      );
    })
  ] }, O.heading)) });
}, O1 = {
  2: F.donut30,
  3: F.donut60,
  4: F.donut80,
  5: F.donut100
}, Wn = ({ riskCategory: e }) => {
  const n = O1[e];
  return /* @__PURE__ */ t.jsx(Z, { name: n, size: X.xxl });
}, be = {
  PORTFOLIO_CREATED: 1,
  PORTFOLIO_CUSTOMIZED: 2,
  MTAN_CONFIRMED: 3,
  BLOCK_90: 4,
  TERMINATION: 6,
  DEKA_DELETED: 7,
  PORTFOLIO_DISCARDED: 99
}, xr = {
  NOT_IMPLEMENTED: 1,
  IN_EXECUTION: 2,
  IMPLEMENTED: 3,
  BLOCKED: 4,
  CLOSED: 5
}, P1 = (e) => e === be.PORTFOLIO_CREATED || e === be.PORTFOLIO_CUSTOMIZED ? "client-dashboard.overview.portfolio.onboarding" : e === be.MTAN_CONFIRMED || e === be.BLOCK_90 ? "client-dashboard.overview.portfolio.in-execution" : e === be.TERMINATION ? "client-dashboard.overview.portfolio.TerminationStarted" : e === be.DEKA_DELETED ? "client-dashboard.overview.portfolio.terminated" : "client-dashboard.overview.portfolio.active", T1 = (e) => e === be.PORTFOLIO_CREATED || e === be.PORTFOLIO_CUSTOMIZED || e === be.MTAN_CONFIRMED || e === be.BLOCK_90 ? "bg-danger-200" : e === be.TERMINATION || e === be.DEKA_DELETED ? "bg-warn-200" : "bg-success-200", fr = {
  "card-bg-color": "_card-bg-color_akvkv_1",
  "disabled-bg-color": "_disabled-bg-color_akvkv_9"
}, R1 = ({
  data: e,
  linkTo: n,
  t: r,
  navigate: a
}) => {
  var u;
  const [s, o] = ce(!1), l = (e == null ? void 0 : e.CustomAttributes) && ((u = JSON.parse(e.CustomAttributes)) == null ? void 0 : u.PortfolioWorkflowStatus), i = l === be.PORTFOLIO_CREATED || l === be.PORTFOLIO_CUSTOMIZED, c = () => {
    i || a(n);
  }, d = (x) => {
    (x.code === "Enter" || x.code === "NumpadEnter") && c();
  };
  return /* @__PURE__ */ t.jsx(
    "div",
    {
      role: "button",
      tabIndex: 0,
      className: "relative",
      onClick: c,
      onKeyDown: d,
      onMouseEnter: () => {
        l === be.DEKA_DELETED && o(!0);
      },
      onMouseLeave: () => {
        l === be.DEKA_DELETED && o(!1);
      },
      children: /* @__PURE__ */ t.jsxs(
        Ee,
        {
          className: A(
            { [fr["card-bg-color"]]: !i },
            { [fr["disabled-bg-color"]]: i }
          ),
          children: [
            /* @__PURE__ */ t.jsxs("div", { className: "flex items-center justify-between w-full gap-4 sm:gap-10", children: [
              /* @__PURE__ */ t.jsxs("div", { className: "flex flex-wrap items-center justify-center w-full gap-4 sm:flex-nowrap sm:justify-between", children: [
                /* @__PURE__ */ t.jsxs("div", { className: "flex items-center gap-4", children: [
                  /* @__PURE__ */ t.jsx(
                    Wn,
                    {
                      riskCategory: e.RiskCategory.Id
                    }
                  ),
                  /* @__PURE__ */ t.jsxs("div", { className: "flex flex-col space-y-0.5", children: [
                    e.isGroupPortfolio && /* @__PURE__ */ t.jsx("div", { className: "px-6 py-0.5 mr-auto rounded bg-button-alternative-text text-white", children: r("joint-portfolio.tag") }),
                    /* @__PURE__ */ t.jsxs(w, { fontWeight: "bold", fontSize: "xl", children: [
                      e.Product.Name,
                      " ",
                      e.RiskCategory.Name
                    ] }),
                    /* @__PURE__ */ t.jsxs(w, { children: [
                      r("common.portfolioExternalId"),
                      ": ",
                      e.ExternalId
                    ] })
                  ] })
                ] }),
                /* @__PURE__ */ t.jsx(w, { fontWeight: "bold", fontSize: "lg", children: _e((e == null ? void 0 : e.CurrentValue) ?? 0) }),
                /* @__PURE__ */ t.jsx(
                  "div",
                  {
                    className: `mr-2 px-6 py-0.5 rounded-badge ${T1(
                      l
                    )}`,
                    children: /* @__PURE__ */ t.jsx(w, { children: r(P1(l)) })
                  }
                )
              ] }),
              /* @__PURE__ */ t.jsx(Z, { name: F.nextCircle })
            ] }),
            s && l === be.DEKA_DELETED && /* @__PURE__ */ t.jsx("div", { className: "absolute left-0 right-0 z-50 w-40 p-2 mx-auto mt-2 bg-white border rounded bottom", children: r("client-dashboard.overview.portfolio.terminated-tooltip") })
          ]
        }
      )
    }
  );
}, gr = ({
  headerText: e,
  portfolios: n,
  linkTo: r,
  navigate: a
}) => {
  const s = S.get("useLanguage"), { t: o } = s();
  return /* @__PURE__ */ t.jsx("div", { className: "flex flex-col gap-4", children: n.length > 0 && /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
    /* @__PURE__ */ t.jsx("h2", { className: "text-lg text-primary-500 sm:text-xl font-header", children: o(e) }),
    /* @__PURE__ */ t.jsx("div", { className: "flex flex-col gap-6", children: n.map((l) => /* @__PURE__ */ t.jsx(
      R1,
      {
        data: l,
        linkTo: r(l.Id),
        t: o,
        navigate: a
      },
      l.Id
    )) })
  ] }) });
}, pr = () => /* @__PURE__ */ t.jsx(Ee, { children: /* @__PURE__ */ t.jsxs("div", { className: "flex justify-between items-center w-full", children: [
  /* @__PURE__ */ t.jsxs("div", { className: "flex items-center gap-4", children: [
    /* @__PURE__ */ t.jsx(fe, { height: 16, width: 16 }),
    /* @__PURE__ */ t.jsx(fe, { height: 6, width: 52 })
  ] }),
  /* @__PURE__ */ t.jsx(fe, { height: 6, width: 32 }),
  /* @__PURE__ */ t.jsx(fe, { height: 6, width: 20 }),
  /* @__PURE__ */ t.jsx(Z, { name: F.nextCircle })
] }) }), Kl = ({ linkTo: e, navigate: n }) => {
  const r = S.get(
    "useClientPortfolioIds"
  ), { clientId: a } = r(), s = S.get("useLanguage"), o = S.get("getContactGroupsById"), { t: l } = s(), [i, c] = Ie.useState(!1), [d, u] = Ie.useState(!1), [x, h] = Ie.useState([]), [f, g] = Ie.useState([]), y = S.get("useGetAllPortfolios"), {
    isLoading: p,
    data: b,
    isError: v
  } = y({
    contactId: a,
    refetchOnMount: !0,
    refetchOnWindowFocus: !1
  });
  ve(() => {
    if (!b) return;
    (async () => {
      try {
        c(!0);
        const k = b == null ? void 0 : b.filter(
          (M) => {
            var D;
            return (M == null ? void 0 : M.CustomAttributes) && ((D = JSON.parse(M.CustomAttributes)) == null ? void 0 : D.PortfolioWorkflowStatus) !== be.PORTFOLIO_DISCARDED;
          }
        ), O = k != null && k.length ? k.sort(
          (M, D) => new Date(M.CreateDate).getTime() - new Date(D.CreateDate).getTime()
        ) : [], C = O.map(
          (M) => `${M.ContactGroupId}`
        ), R = await Promise.all(
          C.map(async (M) => {
            const { data: D } = await o({
              contactGroupId: M
            });
            return D;
          })
        ), P = O.map((M) => {
          var D, B;
          return {
            ...M,
            isGroupPortfolio: ((B = (D = R.find(
              (J) => (J == null ? void 0 : J.groupId) === M.ContactGroupId
            )) == null ? void 0 : D.contacts) == null ? void 0 : B.length) === 2
          };
        });
        h(
          P.filter((M) => !M.isGroupPortfolio)
        ), g(
          P.filter((M) => M.isGroupPortfolio)
        );
      } catch {
        u(!0);
      } finally {
        c(!1);
      }
    })();
  }, [b, o]);
  const j = p || i, _ = v || d;
  return /* @__PURE__ */ t.jsxs("div", { className: "space-y-8", children: [
    _ && !j && /* @__PURE__ */ t.jsx(Ee, { children: /* @__PURE__ */ t.jsx($e, { children: l("error.technical-error1") }) }),
    j ? /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
      /* @__PURE__ */ t.jsx(pr, {}),
      /* @__PURE__ */ t.jsx(pr, {})
    ] }) : /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
      /* @__PURE__ */ t.jsx(
        gr,
        {
          headerText: "common.portfolioType.single",
          portfolios: x,
          linkTo: e,
          navigate: n
        }
      ),
      /* @__PURE__ */ t.jsx(
        gr,
        {
          headerText: "common.portfolioType.joint",
          portfolios: f,
          linkTo: e,
          navigate: n
        }
      )
    ] })
  ] });
}, A1 = ({
  portfolioData: e,
  t: n,
  foundingsSearchData: r,
  handleSavingClick: a
}) => {
  var I, k, O, C, R, P, M, D;
  const s = e == null ? void 0 : e.CurrentValue, o = s && ((I = e == null ? void 0 : e.Currency) != null && I.Symbol) ? _e(s) : n("common.n-a"), l = ((O = (k = e == null ? void 0 : e.HistoricalPerformance) == null ? void 0 : k[0]) == null ? void 0 : O.Values) || [], i = !!l.length && new Date(
    Math.max(
      ...l.map(
        (B) => new Date(B.Date).getTime()
      )
    )
  ).toISOString(), c = i ? Re(i) : n("common.n-a"), d = e == null ? void 0 : e.CurrentMwrPerformance, u = d ? `${d > 0 ? "+" : ""}${zt(
    d,
    { multiplier: 100 }
  )}` : "", x = e == null ? void 0 : e.CurrentPerformanceAmount, h = x ? `${x > 0 ? "+" : ""}${_e(
    x
  )}` : "", f = (C = e == null ? void 0 : e.Product) != null && C.Name && ((R = e == null ? void 0 : e.RiskCategory) != null && R.Name) ? `${(P = e == null ? void 0 : e.Product) == null ? void 0 : P.Name} ${(M = e == null ? void 0 : e.RiskCategory) == null ? void 0 : M.Name}` : n("common.n-a"), g = (e == null ? void 0 : e.ExternalId) ?? n("common.n-a"), y = e == null ? void 0 : e.FirstInvestmentDate, p = y ? Re(y) : n("common.n-a"), b = (D = r == null ? void 0 : r.fundings) == null ? void 0 : D.length, j = b === 0 ? n("wizard.current-savings-plans.no") : de(n("wizard.current-savings-plans"), {
    $count$: String(b)
  });
  return {
    currentValue: s,
    currentValueDisplay: o,
    currentValueDate: c,
    performancePercent: d,
    performancePercentDisplay: u,
    performanceCurrency: x,
    performanceCurrencyDisplay: h,
    savingDescription: j,
    product: f,
    depotNumber: g,
    firstInvestmentDate: p,
    savingAction: !!b && a
  };
}, Jl = ({ handleSavingClick: e }) => {
  const n = S.get("useLanguage"), { t: r } = n(), a = S.get(
    "useClientPortfolioIds"
  ), { clientId: s, portfolioId: o } = a(), l = S.get("useGetPortfolioDetails"), {
    isLoading: i,
    data: c,
    isError: d
  } = l({
    clientId: String(s),
    portfolioId: o,
    refetchOnMount: !0,
    refetchOnWindowFocus: !1
  }), u = S.get(
    "useGetPortfolioAccounts"
  ), {
    isLoading: x,
    data: h,
    isError: f
  } = u({
    clientId: String(s),
    portfolioId: o,
    refetchOnMount: !0,
    refetchOnWindowFocus: !1
  }), g = G(
    () => {
      var R, P;
      return (P = (R = h == null ? void 0 : h.find(
        (M) => M.IsDefaultCustodyAccount
      )) == null ? void 0 : R.Account) == null ? void 0 : P.Id;
    },
    [h]
  ), y = S.get(
    "usePostFoundingsSearch"
  ), {
    isLoading: p,
    data: b,
    isError: v
  } = y({
    clientId: String(s),
    refetchOnMount: !0,
    refetchOnWindowFocus: !1,
    enabled: !!g,
    body: {
      page: 1,
      pageSize: 5,
      // We have up to 5 saving plans
      typeIds: [
        2
        // only monthly investment
      ],
      targetAccountIds: [g],
      isActive: !0
    }
  }), j = S.get(
    "useGetContactGroupsById"
  ), {
    isLoading: _,
    data: I,
    isError: k
  } = j({
    contactGroupId: c == null ? void 0 : c.ContactGroupId,
    enabled: !!(c != null && c.ContactGroupId),
    refetchOnMount: !0,
    refetchOnWindowFocus: !1
  }), O = G(
    () => {
      var R;
      return ((R = I == null ? void 0 : I.contacts) == null ? void 0 : R.length) === 2;
    },
    [I]
  ), C = A1({
    portfolioData: c,
    foundingsSearchData: b,
    t: r,
    handleSavingClick: e
  });
  return (v || k || f || d) && !p && !_ && !x && !i ? /* @__PURE__ */ t.jsx(Ee, { children: /* @__PURE__ */ t.jsx($e, { children: r("error.technical-error1") }) }) : /* @__PURE__ */ t.jsx("div", { className: "grid grid-cols-1 gap-6 p-4 sm:grid-cols-2 lg:grid-cols-3 sm:p-6", children: i || x || p || _ ? /* @__PURE__ */ t.jsx(t.Fragment, { children: Array.from(Array(6).keys()).map((R) => /* @__PURE__ */ t.jsxs("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ t.jsx("div", { className: "w-32 h-4 rounded bg-misc-200 animate-pulse" }),
    /* @__PURE__ */ t.jsx("div", { className: "w-48 h-6 rounded bg-misc-200 animate-pulse" })
  ] }, R)) }) : /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
    /* @__PURE__ */ t.jsxs("div", { children: [
      /* @__PURE__ */ t.jsx(w, { fontWeight: "bold", children: r("common.total-value") }),
      /* @__PURE__ */ t.jsx(w, { fontSize: "xl", className: "mt-2 mb-1.5", children: C.currentValueDisplay }),
      /* @__PURE__ */ t.jsxs(w, { fontSize: "xs", children: [
        r("common.value-date"),
        " ",
        C.currentValueDate
      ] })
    ] }),
    /* @__PURE__ */ t.jsxs("div", { children: [
      /* @__PURE__ */ t.jsx(w, { fontWeight: "bold", children: r("client-dashboard.overview.total-return") }),
      /* @__PURE__ */ t.jsx(w, { fontSize: "xl", className: "mt-2 mb-1.5", children: C.performanceCurrency ? /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
        " ",
        /* @__PURE__ */ t.jsxs(
          "span",
          {
            className: `mt-2 mb-1.5 ${Number(C.performancePercent) < 0 ? "text-danger-500" : "text-success-500"}`,
            children: [
              C.performancePercentDisplay,
              " ",
              C.performancePercentDisplay && "|"
            ]
          }
        ),
        " ",
        /* @__PURE__ */ t.jsx(
          "span",
          {
            className: C.performanceCurrency < 0 ? "text-danger-500" : "text-success-500",
            children: C.performanceCurrencyDisplay
          }
        )
      ] }) : r("common.n-a") })
    ] }),
    /* @__PURE__ */ t.jsxs("div", { children: [
      /* @__PURE__ */ t.jsx(w, { fontWeight: "bold", children: r("wizard.header.saving-plan") }),
      /* @__PURE__ */ t.jsxs("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ t.jsx(w, { fontSize: "xl", className: "mt-2 mb-1.5", children: C.savingDescription }),
        C.savingAction && /* @__PURE__ */ t.jsx(
          Z,
          {
            name: F.chevronRight,
            size: X.xs,
            onClick: C.savingAction,
            className: "cursor-pointer mt-2 mb-1.5"
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ t.jsxs("div", { className: "flex flex-col", children: [
      /* @__PURE__ */ t.jsx(w, { fontWeight: "bold", children: r("common.product") }),
      /* @__PURE__ */ t.jsx(w, { fontSize: "xl", className: "mt-2 mb-1.5", children: C.product }),
      O && /* @__PURE__ */ t.jsx(c1, {})
    ] }),
    /* @__PURE__ */ t.jsxs("div", { children: [
      /* @__PURE__ */ t.jsx(w, { fontWeight: "bold", children: r("common.depot-number") }),
      /* @__PURE__ */ t.jsx(w, { fontSize: "xl", className: "mt-2 mb-1.5", children: C.depotNumber })
    ] }),
    /* @__PURE__ */ t.jsxs("div", { children: [
      /* @__PURE__ */ t.jsx(w, { fontWeight: "bold", children: r("common.fallback-first-investment") }),
      /* @__PURE__ */ t.jsx(w, { fontSize: "xl", className: "mt-2 mb-1.5", children: C.firstInvestmentDate })
    ] })
  ] }) });
}, z1 = ({
  children: e,
  className: n
}) => /* @__PURE__ */ t.jsx("ul", { className: `list-disc ${n}`, children: e }), Jr = ({ children: e }) => /* @__PURE__ */ t.jsx("b", { children: e }), F1 = () => /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
  /* @__PURE__ */ t.jsx("br", {}),
  /* @__PURE__ */ t.jsx("br", {})
] }), Xl = ({ children: e }) => /* @__PURE__ */ t.jsx("ul", { className: "bullet-list", children: e }), V1 = ({ children: e }) => /* @__PURE__ */ t.jsx("li", { children: e }), vr = {
  "button-container": "_button-container_stujq_1",
  "word-wrap-text": "_word-wrap-text_stujq_45"
}, D1 = ({
  onClick: e,
  title: n,
  iconName: r,
  disabled: a = !1
}) => /* @__PURE__ */ t.jsx(
  "button",
  {
    type: "button",
    disabled: a,
    onClick: e,
    className: vr["button-container"],
    children: /* @__PURE__ */ t.jsxs("div", { className: "flex flex-col items-center gap-2", children: [
      /* @__PURE__ */ t.jsx(Z, { size: X.xl, name: r }),
      /* @__PURE__ */ t.jsx(
        Le,
        {
          size: 4,
          className: vr["word-wrap-text"],
          textAlign: "center",
          children: n
        }
      )
    ] })
  }
), Ql = ({
  visible: e,
  onClose: n,
  t: r,
  config: a
}) => {
  const s = {
    onClick: n,
    title: r("button.close")
  };
  return /* @__PURE__ */ t.jsxs(
    Ur,
    {
      visible: e,
      closeIcon: !0,
      onClose: n,
      title: r("wizard.portfolio-administration.header"),
      confirmButton: s,
      children: [
        /* @__PURE__ */ t.jsx("div", { children: /* @__PURE__ */ t.jsx(me, { children: /* @__PURE__ */ t.jsx(
          Fn,
          {
            i18nKey: "wizard.portfolio-administration.text",
            components: {
              b: /* @__PURE__ */ t.jsx(Jr, {})
            }
          }
        ) }) }),
        /* @__PURE__ */ t.jsx("div", { className: "flex flex-wrap justify-center w-full gap-8 px-10 sm:justify-between", children: a.map((o) => /* @__PURE__ */ t.jsx(
          D1,
          {
            disabled: o == null ? void 0 : o.disabled,
            onClick: o.onClick,
            title: o.title,
            iconName: o.iconName
          },
          `${o.title} + ${o.iconName}`
        )) })
      ]
    }
  );
}, B1 = ({
  portfolioData: e,
  isGeneralError: n,
  postOrderBookData: r,
  scheduledOrdersData: a,
  settingsData: s
}) => {
  var l, i, c, d;
  if (n)
    return { message: "error.technical-error1" };
  if (!e || !r || !a || !s)
    return {
      message: ""
    };
  if ((l = a == null ? void 0 : a.results) != null && l.length && (s != null && s.Value)) {
    const u = (i = s == null ? void 0 : s.Value) != null && i.length ? parseInt(s == null ? void 0 : s.Value, 10) : 0, x = /* @__PURE__ */ new Date(), h = new Date(x.getFullYear(), x.getMonth(), x.getDate()), f = (c = a == null ? void 0 : a.results) == null ? void 0 : c[0], g = new Date(f == null ? void 0 : f.transactionDate), y = h.setDate(
      h.getDate() + u
    );
    return g.getTime() >= y ? {
      heading: "wizard.portfolio.termination.error.active-scheduled-orders.header",
      message: "wizard.portfolio.termination.error.active-scheduled-orders.text"
    } : {
      message: "error.validation.termination-open-orders"
    };
  }
  return e != null && e.HasPendingOrders || r != null && r.order.length ? { message: "error.validation.termination-open-orders" } : ((d = JSON.parse(
    (e == null ? void 0 : e.CustomAttributes) ?? "{}"
  )) == null ? void 0 : d.PendingSwap) ? {
    heading: "error.validation.open-swap-termination.header",
    message: "error.validation.open-swap-termination.text"
  } : null;
}, Z1 = ({
  portfolioAccountsData: e,
  body: n
}) => {
  if (!e)
    return {
      commonDataIn: {
        personId: "",
        custodyAccountNumber: "",
        procurerId: "",
        wayOfOrder: ""
      },
      custodyAccountNumber: ""
    };
  const r = (() => {
    var l;
    return ((l = e.find(
      (i) => i.IsDefaultCustodyAccount === !0
    )) == null ? void 0 : l.Account.AccountNumber) || "";
  })(), a = "advisorNumber" in n ? "70" : "71";
  return {
    commonDataIn: {
      ...n,
      wayOfOrder: a,
      custodyAccountNumber: r
      // added because of the validation, not requied for Advisor
    },
    custodyAccountNumber: r
  };
}, H1 = {
  subheader1: "wizard.portfolio.termination.subheader1",
  text1: "wizard.portfolio.termination.text1",
  terminationPortfolio: "wizard.portfolio.termination.portfolio",
  portfolioValue: "wizard.portfolio.termination.portfolio-value",
  referenceAccount: "wizard.reference-account",
  wizardIban: "wizard.iban",
  hint: "wizard.portfolio.termination.hint"
}, ec = ({
  onClose: e,
  onNext: n,
  body: r,
  setIsProgressBarHidden: a,
  isProgressBarHidden: s,
  translations: o = H1
}) => {
  const l = S.get("useLanguage"), { t: i } = l(), c = S.get(
    "useClientPortfolioIds"
  ), { clientId: d, portfolioId: u } = c(), x = S.get(
    "useSearchScheduledOrders"
  ), h = S.get(
    "useGetGlobalSettingByGroupAndKey"
  ), {
    data: f,
    isLoading: g,
    error: y
  } = h({
    group: "InvestmentCalendar",
    key: "MinimumDays"
  }), p = S.get(
    "useGetPortfolioAccounts"
  ), {
    isLoading: b,
    data: v,
    error: j
  } = p({
    clientId: String(d),
    portfolioId: u,
    enabled: !s,
    refetchOnMount: !0,
    refetchOnWindowFocus: !1
  }), _ = G(() => {
    var ie;
    return v ? (ie = v.find(
      (Ue) => Ue.IsPayoutAccount === !0
    )) == null ? void 0 : ie.Account.Iban : "";
  }, [v]), I = S.get("useGetPortfolioDetails"), {
    isLoading: k,
    data: O,
    error: C
  } = I({
    clientId: String(d),
    portfolioId: u,
    keys: "termination",
    enabled: !s,
    refetchOnMount: !0,
    refetchOnWindowFocus: !1
  }), {
    isLoading: R,
    data: P,
    error: M
  } = x({
    contactGroupId: Number(O == null ? void 0 : O.ContactGroupId),
    contactId: Number(d),
    enabled: !!(O != null && O.ContactGroupId),
    body: {
      portfolioId: [Number(u)],
      page: 1,
      pageSize: 100,
      transactionDateFrom: Ir(/* @__PURE__ */ new Date())
    }
  }), D = S.get("usePostOrderBook"), B = Z1({
    portfolioAccountsData: v,
    body: r
  }), {
    isLoading: J,
    data: ee,
    error: T
  } = D({
    body: B,
    enabled: !!v && !s
  }), E = {
    action: n,
    title: i("button.next")
  }, Y = {
    action: e,
    title: i("button.interrupt")
  }, W = B1({
    portfolioData: O,
    isGeneralError: !!C || !!j || !!T || !!M || !!y,
    postOrderBookData: ee,
    scheduledOrdersData: P,
    settingsData: f
  }), ae = {
    button: {
      title: i("button.interrupt"),
      onClick: e
    },
    heading: W != null && W.heading ? i(W == null ? void 0 : W.heading) : i("error.warning1"),
    message: W != null && W.message ? i(W.message) : ""
  };
  return ve(() => {
    W != null && W.message ? a(!0) : a(!1);
  }, [W == null ? void 0 : W.message]), /* @__PURE__ */ t.jsx(
    Nt,
    {
      isLoading: k || b || J || R || g,
      error: W,
      modal: ae,
      children: /* @__PURE__ */ t.jsxs(Xe, { children: [
        /* @__PURE__ */ t.jsx(me, { fontWeight: "bold", children: i(o.subheader1) }),
        /* @__PURE__ */ t.jsx(me, { children: /* @__PURE__ */ t.jsx(
          Fn,
          {
            i18nKey: i(o.text1),
            components: {
              li: /* @__PURE__ */ t.jsx(V1, {}),
              ul: /* @__PURE__ */ t.jsx(z1, { className: "list-outside pl-8" })
            }
          }
        ) }),
        /* @__PURE__ */ t.jsxs("div", { children: [
          /* @__PURE__ */ t.jsxs("div", { className: "flex justify-between px-5 pb-3", children: [
            /* @__PURE__ */ t.jsx(w, { fontWeight: "bold", children: i(o.terminationPortfolio) }),
            /* @__PURE__ */ t.jsx(w, { fontWeight: "bold", children: i(o.portfolioValue) })
          ] }),
          /* @__PURE__ */ t.jsx(
            bn,
            {
              portfolioId: u,
              clientId: d,
              isShowAmount: !0
            }
          )
        ] }),
        /* @__PURE__ */ t.jsxs("div", { className: "space-y-2", children: [
          /* @__PURE__ */ t.jsx(Le, { size: 3, children: i(o.referenceAccount) }),
          /* @__PURE__ */ t.jsxs(me, { children: [
            i(o.wizardIban),
            " ",
            Sr(_)
          ] })
        ] }),
        /* @__PURE__ */ t.jsx(De, { text: i(o.hint) }),
        /* @__PURE__ */ t.jsx(Be, { onNext: E, onPrev: Y })
      ] })
    }
  );
}, q1 = "_labels_1q8h5_37", Gt = {
  "bar-chart-component": "_bar-chart-component_1q8h5_1",
  "bar-chart-fill": "_bar-chart-fill_1q8h5_17",
  "middle-separator": "_middle-separator_1q8h5_25",
  labels: q1,
  "exposure-body": "_exposure-body_1q8h5_65"
}, On = 300, tc = ({
  upperBoundary: e,
  middleBoundary: n,
  lowerBoundary: r,
  exposure: a,
  exposureDate: s,
  fillColor: o,
  t: l
}) => {
  const i = On / (e - r), c = On - (n - r) * i, d = On - (a - r) * i;
  return /* @__PURE__ */ t.jsx(Ee, { children: /* @__PURE__ */ t.jsxs("div", { className: Gt["exposure-body"], children: [
    /* @__PURE__ */ t.jsx(Le, { size: 3, className: "mb-4", children: l("exposure.title") }),
    /* @__PURE__ */ t.jsx(w, { fontSize: "sm", children: de(l("exposure.date"), {
      $exposureDate$: s
    }) }),
    /* @__PURE__ */ t.jsxs("div", { className: "flex mt-8", children: [
      /* @__PURE__ */ t.jsx(
        "span",
        {
          style: {
            marginTop: d - 12,
            marginRight: "12px"
          },
          children: /* @__PURE__ */ t.jsx(Z, { name: F.arrowRight, size: X.m })
        }
      ),
      /* @__PURE__ */ t.jsxs(
        "div",
        {
          className: Gt["bar-chart-component"],
          style: { backgroundColor: o },
          children: [
            /* @__PURE__ */ t.jsx(
              "div",
              {
                className: Gt["bar-chart-fill"],
                style: { height: d }
              }
            ),
            /* @__PURE__ */ t.jsx(
              "div",
              {
                className: Gt["middle-separator"],
                style: {
                  borderColor: d > c ? "#000" : "#fff",
                  top: c
                }
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ t.jsxs("div", { className: Gt.labels, children: [
        /* @__PURE__ */ t.jsx("span", { children: l("exposure.offensive") }),
        /* @__PURE__ */ t.jsx("span", { style: { top: c - 10 }, children: l("exposure.neutral") }),
        /* @__PURE__ */ t.jsx("span", { children: l("exposure.defensive") })
      ] })
    ] })
  ] }) });
}, V = {
  "first-col": "_first-col_bd4za_1",
  "rest-col": "_rest-col_bd4za_17",
  "last-col": "_last-col_bd4za_25",
  "border-bottom-dashed": "_border-bottom-dashed_bd4za_33",
  "border-left-dashed": "_border-left-dashed_bd4za_43",
  "margin-top-expanded": "_margin-top-expanded_bd4za_53",
  "second-col-padding": "_second-col-padding_bd4za_61",
  "margin-bottom-expanded": "_margin-bottom-expanded_bd4za_69",
  "transaction-header-padding": "_transaction-header-padding_bd4za_77"
}, Fe = {
  payIn: "PayIn",
  payOut: "PayOut",
  swap: "Swap",
  savingPlan: "SavingPlan",
  dividendBuy: "DividendBuy",
  managementFee: "ManagementFee",
  other: "Other"
}, Ge = {
  inProgress: "InProgress",
  executed: "Executed",
  canceled: "Canceled",
  failed: "Failed"
}, ln = {
  verificationPending: "VerificationPending",
  released: "Released",
  cancelled: "Cancelled",
  executed: "Executed"
}, rt = {
  enabled: "enabled",
  disabled: "disabled",
  blocked: "blocked",
  hidden: "hidden"
}, G1 = (e) => e === Fe.payIn ? {
  text: "orderbook.order-type.top-up",
  iconName: F.banknoteIn
} : e === Fe.payOut ? {
  text: "orderbook.order-type.payout",
  iconName: F.banknoteOut
} : e === Fe.swap ? {
  text: "orderbook.order-type.swap",
  iconName: F.exchange
} : e === Fe.savingPlan ? {
  text: "orderbook.order-type.saving-plan",
  iconName: F.piggyBankUnite
} : e === Fe.dividendBuy ? {
  text: "orderbook.order-type.dividend-buy",
  iconName: F.exchange
} : e === Fe.managementFee ? {
  text: "orderbook.order-type.management-fee",
  iconName: F.exchange
} : {
  text: "orderbook.order-type.other",
  iconName: F.chartArrowUp
}, mn = ({
  status: e,
  completeDate: n,
  transactionDate: r
}) => {
  const a = S.get("useLanguage"), { t: s } = a();
  return r ? /* @__PURE__ */ t.jsxs("div", { className: "flex flex-col items-center gap-2", children: [
    /* @__PURE__ */ t.jsx(Z, { name: F.calendar }),
    /* @__PURE__ */ t.jsx(w, { fontSize: "sm", children: Re(r) })
  ] }) : e === Ge.inProgress ? /* @__PURE__ */ t.jsxs("div", { className: "flex flex-col items-center gap-2", children: [
    /* @__PURE__ */ t.jsx(Z, { name: F.standardStopwatch }),
    /* @__PURE__ */ t.jsx(w, { fontSize: "sm", children: s("orderbook.order-status.pending") })
  ] }) : e === Ge.executed ? /* @__PURE__ */ t.jsxs("div", { className: "flex flex-col items-center gap-2", children: [
    /* @__PURE__ */ t.jsx(
      Z,
      {
        name: F.progressCircleFull,
        color: "var(--positive-default)"
      }
    ),
    /* @__PURE__ */ t.jsx(w, { fontSize: "sm", children: typeof n == "string" ? Re(n) : s("orderbook.order-status.pending") })
  ] }) : e === Ge.canceled ? /* @__PURE__ */ t.jsxs("div", { className: "flex flex-col items-center gap-2", children: [
    /* @__PURE__ */ t.jsx(Z, { name: F.cancelCircle, color: "var(--secondary-default)" }),
    /* @__PURE__ */ t.jsx(w, { fontSize: "sm", children: typeof n == "string" ? Re(n) : s("orderbook.attribute-name.status.cancelled") })
  ] }) : e === Ge.failed ? /* @__PURE__ */ t.jsxs("div", { className: "flex flex-col items-center gap-2", children: [
    /* @__PURE__ */ t.jsx(Z, { name: F.error, color: "var(--secondary-default)" }),
    /* @__PURE__ */ t.jsx(w, { fontSize: "sm", children: typeof n == "string" ? Re(n) : s("orderbook.attribute-name.status.failed") })
  ] }) : null;
}, U1 = ({
  orderType: e,
  transactions: n,
  isShowExternalId: r,
  transactionDate: a
}) => {
  const s = S.get("useLanguage"), { t: o } = s(), l = (() => {
    if (e !== "Swap")
      return n.map((d) => ({
        info: {
          isin: d.isin,
          securityName: d.securityName,
          completeDate: d.status === Ge.executed && `${o("orderbook.attribute-name.executed-on")}: ${Re(
            d.completeDate
          )}`,
          price: d.status === Ge.executed && `${o("orderbook.attribute-name.pieces")}: ${d.quantity} ${o("orderbook.attribute-name.price")}: ${d.price}`,
          feeTax: d.status === Ge.executed && e === "PayIn" && `${o("orderbook.attribute-name.fee")}: ${zt(
            d == null ? void 0 : d.fee,
            {
              multiplier: 1
            }
          )}`,
          externalId: (d == null ? void 0 : d.externalId) && `${o("orderbook.attribute-name.external-order-id")}: ${d.externalId}`
          // This logic will be used in next iterations
          // DSL-30 do not delivered tax for Release 1
          // feeTax:
          //   transaction.status === ORDER_STATUSES.executed &&
          //   (orderType === "PayIn" || orderType === "PayOut") &&
          //   (orderType === "PayIn"
          //     ? `${t("orderbook.attribute-name.fee")}: ${formatPercentage(
          //         transaction?.fee,
          //         {
          //           multiplier: 1,
          //         }
          //       )}`
          //     : `${t("orderbook.attribute-name.tax")}: ${formatGermanCurrency(
          //         transaction?.tax
          //       )}`),
        },
        status: {
          orderStatus: d.status,
          completeDate: d.completeDate
        },
        amount: (d == null ? void 0 : d.amount) && `${d.type === "Buy" ? "+" : "-"}${_e(
          d.amount
        )}`
      }));
    const i = n.reduce(
      (d, u) => d != null && d[u.externalId] ? {
        ...d,
        [u.externalId]: [
          ...d[u.externalId],
          u
        ]
      } : {
        ...d,
        [u.externalId]: [u]
      },
      {}
    );
    return Object.values(i).map(
      (d) => {
        const u = d.find(
          (h) => h.type === "Buy"
        ), x = d.find(
          (h) => h.type === "Sell"
        );
        return !x || !u ? {
          info: {
            isin: "",
            securityName: "",
            price: ""
          },
          status: {
            orderStatus: "",
            completeDate: ""
          },
          amount: null
        } : {
          info: {
            isin: x.isin,
            securityName: x.securityName,
            completeDate: x.status === Ge.executed && `${o("orderbook.attribute-name.executed-on")}: ${Re(
              x.completeDate
            )}`,
            price: x.status === Ge.executed && `${o("orderbook.attribute-name.pieces")}: ${x.quantity} ${o("orderbook.attribute-name.price")}: ${x.price}`,
            externalId: (x == null ? void 0 : x.externalId) && `${o("orderbook.attribute-name.external-order-id")}: ${x.externalId}`
          },
          status: {
            orderStatus: x.status,
            completeDate: x.completeDate
          },
          amount: (x == null ? void 0 : x.amount) && `-${_e(x.amount)}`,
          buyTransaction: {
            info: {
              isin: u.isin,
              securityName: u.securityName,
              completeDate: u.status === Ge.executed && `${o("orderbook.attribute-name.executed-on")}: ${Re(
                u.completeDate
              )}`,
              price: u.status === Ge.executed && `${o("orderbook.attribute-name.pieces")}: ${u.quantity} ${o("orderbook.attribute-name.price")}: ${u.price}`,
              externalId: (u == null ? void 0 : u.externalId) && `${o("orderbook.attribute-name.external-order-id")}: ${u.externalId}`
            },
            status: {
              orderStatus: u.status,
              completeDate: u.completeDate
            },
            amount: (u == null ? void 0 : u.amount) && `+${_e(u.amount)}`
          }
        };
      }
    );
  })();
  return /* @__PURE__ */ t.jsxs("tr", { children: [
    /* @__PURE__ */ t.jsx("td", { className: `p-2 ${V["first-col"]}` }),
    /* @__PURE__ */ t.jsx("td", { colSpan: 3, children: /* @__PURE__ */ t.jsxs("table", { className: "w-full table-fixed", children: [
      /* @__PURE__ */ t.jsx("thead", { className: `${V["border-bottom-dashed"]}`, children: /* @__PURE__ */ t.jsxs("tr", { children: [
        /* @__PURE__ */ t.jsx(
          "td",
          {
            className: `${e !== "Swap" ? V["rest-col"] : ""}`,
            children: /* @__PURE__ */ t.jsx(
              w,
              {
                fontWeight: "bold",
                className: `${V["second-col-padding"]} ${V["margin-top-expanded"]}`,
                children: o("orderbook.attribute-name.isin")
              }
            )
          }
        ),
        /* @__PURE__ */ t.jsx(
          "td",
          {
            className: `${e !== "Swap" ? V["rest-col"] : ""}`,
            children: /* @__PURE__ */ t.jsx(
              w,
              {
                fontWeight: "bold",
                textAlign: "center",
                className: `${V["transaction-header-padding"]} ${V["margin-top-expanded"]}`,
                children: o("orderbook.attribute-name.status")
              }
            )
          }
        ),
        /* @__PURE__ */ t.jsx(
          "td",
          {
            className: `${e !== "Swap" ? V["rest-col"] : ""}`,
            children: /* @__PURE__ */ t.jsx(
              w,
              {
                fontWeight: "bold",
                textAlign: "center",
                className: V["margin-top-expanded"],
                children: o("orderbook.attribute-name.amount")
              }
            )
          }
        ),
        e === "Swap" && /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
          /* @__PURE__ */ t.jsx(
            "td",
            {
              className: `${V["border-left-dashed"]} hidden lg:table-cell`,
              children: /* @__PURE__ */ t.jsx(
                w,
                {
                  fontWeight: "bold",
                  className: `${V["second-col-padding"]} ${V["margin-top-expanded"]}`,
                  children: o("orderbook.attribute-name.isin")
                }
              )
            }
          ),
          /* @__PURE__ */ t.jsx("td", { className: "hidden lg:table-cell", children: /* @__PURE__ */ t.jsx(
            w,
            {
              fontWeight: "bold",
              textAlign: "center",
              className: V["margin-top-expanded"],
              children: o("orderbook.attribute-name.status")
            }
          ) }),
          /* @__PURE__ */ t.jsx("td", { className: "hidden lg:table-cell", children: /* @__PURE__ */ t.jsx(
            w,
            {
              fontWeight: "bold",
              textAlign: "center",
              className: V["margin-top-expanded"],
              children: o("orderbook.attribute-name.amount")
            }
          ) })
        ] })
      ] }) }),
      /* @__PURE__ */ t.jsx("tbody", { children: !!(l != null && l.length) && l.map((i, c) => {
        var d, u, x, h, f, g, y;
        return /* @__PURE__ */ t.jsxs(Ie.Fragment, { children: [
          /* @__PURE__ */ t.jsxs("tr", { children: [
            /* @__PURE__ */ t.jsxs("td", { children: [
              /* @__PURE__ */ t.jsx(
                w,
                {
                  fontSize: "sm",
                  fontWeight: "bold",
                  className: `${V["second-col-padding"]} ${V["margin-top-expanded"]}`,
                  children: i.info.isin
                }
              ),
              /* @__PURE__ */ t.jsx(
                w,
                {
                  className: `${V["second-col-padding"]} ${V["margin-bottom-expanded"]}`,
                  fontSize: "sm",
                  children: i.info.securityName
                }
              ),
              /* @__PURE__ */ t.jsx(
                w,
                {
                  fontSize: "sm",
                  className: `${V["second-col-padding"]}`,
                  children: i.info.completeDate
                }
              ),
              ((d = i.info) == null ? void 0 : d.price) && /* @__PURE__ */ t.jsx(
                w,
                {
                  fontSize: "sm",
                  className: `${V["second-col-padding"]}`,
                  children: i.info.price
                }
              ),
              ((u = i.info) == null ? void 0 : u.feeTax) && /* @__PURE__ */ t.jsx(
                w,
                {
                  fontSize: "sm",
                  className: `${V["second-col-padding"]} ${V["margin-bottom-expanded"]}`,
                  children: i.info.feeTax
                }
              ),
              ((x = i.info) == null ? void 0 : x.externalId) && r && /* @__PURE__ */ t.jsx(
                w,
                {
                  fontSize: "sm",
                  className: `${V["second-col-padding"]} ${V["margin-bottom-expanded"]}`,
                  children: i.info.externalId
                }
              )
            ] }),
            /* @__PURE__ */ t.jsx("td", { children: /* @__PURE__ */ t.jsx(
              mn,
              {
                status: i.status.orderStatus,
                completeDate: i.status.completeDate,
                transactionDate: a
              }
            ) }),
            /* @__PURE__ */ t.jsx("td", { children: !!i.amount && /* @__PURE__ */ t.jsx(w, { fontSize: "sm", textAlign: "center", children: i.amount }) }),
            i.buyTransaction && /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
              /* @__PURE__ */ t.jsxs(
                "td",
                {
                  className: `${V["border-left-dashed"]} hidden lg:table-cell`,
                  children: [
                    /* @__PURE__ */ t.jsx(
                      w,
                      {
                        fontSize: "sm",
                        className: `${V["second-col-padding"]} ${V["margin-top-expanded"]}`,
                        fontWeight: "bold",
                        children: i.buyTransaction.info.isin
                      }
                    ),
                    /* @__PURE__ */ t.jsx(
                      w,
                      {
                        className: `${V["second-col-padding"]} ${V["margin-bottom-expanded"]}`,
                        fontSize: "sm",
                        children: i.buyTransaction.info.securityName
                      }
                    ),
                    /* @__PURE__ */ t.jsx(
                      w,
                      {
                        fontSize: "sm",
                        className: `${V["second-col-padding"]}`,
                        children: i.buyTransaction.info.completeDate
                      }
                    ),
                    ((h = i.buyTransaction.info) == null ? void 0 : h.price) && /* @__PURE__ */ t.jsx(
                      w,
                      {
                        fontSize: "sm",
                        className: `${V["second-col-padding"]}`,
                        children: i.buyTransaction.info.price
                      }
                    ),
                    ((f = i.buyTransaction.info) == null ? void 0 : f.externalId) && r && /* @__PURE__ */ t.jsx(
                      w,
                      {
                        fontSize: "sm",
                        className: `${V["second-col-padding"]} ${V["margin-bottom-expanded"]}`,
                        children: i.info.externalId
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ t.jsx("td", { className: "hidden lg:table-cell", children: /* @__PURE__ */ t.jsx(
                mn,
                {
                  status: i.buyTransaction.status.orderStatus,
                  completeDate: i.buyTransaction.status.completeDate,
                  transactionDate: a
                }
              ) }),
              /* @__PURE__ */ t.jsx("td", { className: "hidden lg:table-cell", children: !!i.buyTransaction.amount && /* @__PURE__ */ t.jsx(w, { fontSize: "sm", textAlign: "center", children: i.buyTransaction.amount }) })
            ] })
          ] }),
          i.buyTransaction && /* @__PURE__ */ t.jsxs("tr", { className: "table-row lg:hidden", children: [
            /* @__PURE__ */ t.jsxs("td", { className: `${V["border-left-dashed"]}`, children: [
              /* @__PURE__ */ t.jsx(
                w,
                {
                  fontSize: "sm",
                  className: `${V["second-col-padding"]} ${V["margin-top-expanded"]}`,
                  fontWeight: "bold",
                  children: i.buyTransaction.info.isin
                }
              ),
              /* @__PURE__ */ t.jsx(
                w,
                {
                  className: `${V["second-col-padding"]} ${V["margin-bottom-expanded"]}`,
                  fontSize: "sm",
                  children: i.buyTransaction.info.securityName
                }
              ),
              /* @__PURE__ */ t.jsx(
                w,
                {
                  fontSize: "sm",
                  className: `${V["second-col-padding"]}`,
                  children: i.buyTransaction.info.completeDate
                }
              ),
              ((g = i.buyTransaction.info) == null ? void 0 : g.price) && /* @__PURE__ */ t.jsx(
                w,
                {
                  fontSize: "sm",
                  className: `${V["second-col-padding"]}`,
                  children: i.buyTransaction.info.price
                }
              ),
              ((y = i.buyTransaction.info) == null ? void 0 : y.externalId) && r && /* @__PURE__ */ t.jsx(
                w,
                {
                  fontSize: "sm",
                  className: `${V["second-col-padding"]} ${V["margin-bottom-expanded"]}`,
                  children: i.info.externalId
                }
              )
            ] }),
            /* @__PURE__ */ t.jsx("td", { children: /* @__PURE__ */ t.jsx(
              mn,
              {
                status: i.buyTransaction.status.orderStatus,
                completeDate: i.buyTransaction.status.completeDate,
                transactionDate: a
              }
            ) }),
            /* @__PURE__ */ t.jsx("td", { children: !!i.buyTransaction.amount && /* @__PURE__ */ t.jsx(w, { fontSize: "sm", textAlign: "center", children: i.buyTransaction.amount }) })
          ] })
        ] }, c);
      }) })
    ] }) })
  ] });
}, Y1 = ({
  order: e,
  isShowExternalId: n,
  minimumDeleteDaysSetting: r,
  setDeletingOrder: a
}) => {
  const [s, o] = ce(!1), l = S.get("useLanguage"), { t: i } = l(), c = G1(e.orderType), d = G(() => {
    if (!r || !e.scheduledOrder)
      return rt.hidden;
    const { orderStatus: h, transactionDate: f } = e.scheduledOrder, g = new Date(f), y = Number(r.Value), p = /* @__PURE__ */ new Date();
    p.setHours(0, 0, 0, 0);
    const b = new Date(p);
    b.setDate(p.getDate() + y);
    const v = g >= b;
    return h === ln.released && v ? rt.enabled : h === ln.verificationPending && v ? rt.disabled : (h === ln.released || h === ln.verificationPending) && !v ? rt.blocked : rt.hidden;
  }, [r, e.scheduledOrder]), u = e.createDate ? Re(e.createDate) : Re(e.completeDate), x = (() => {
    if (!e.amount && e.orderType === Fe.swap)
      return null;
    if (e.orderType === Fe.payIn || e.orderType === Fe.dividendBuy || e.orderType === Fe.savingPlan)
      return `+${_e(e.amount)}`;
    if (e.orderType === Fe.payOut || e.orderType === Fe.managementFee)
      return `-${_e(e.amount)}`;
    if (e.orderType === Fe.other) {
      const h = e.transactions.reduce((f, g) => g.type === "Sell" ? f - g.amount : f + g.amount, 0);
      return `${h > 0 ? "+" : ""}${_e(h)}`;
    }
    return null;
  })();
  return /* @__PURE__ */ t.jsx("table", { className: "w-full border table-fixed", children: /* @__PURE__ */ t.jsxs("tbody", { children: [
    /* @__PURE__ */ t.jsxs("tr", { children: [
      /* @__PURE__ */ t.jsx("td", { className: `p-2 ${V["first-col"]}`, children: /* @__PURE__ */ t.jsx(w, { textAlign: "center", fontWeight: "bold", fontSize: "sm", children: u }) }),
      /* @__PURE__ */ t.jsx("td", { className: `${V["rest-col"]}`, children: /* @__PURE__ */ t.jsxs(
        "div",
        {
          className: `${V["second-col-padding"]} flex gap-2 items-center`,
          children: [
            /* @__PURE__ */ t.jsx(Z, { name: c.iconName }),
            /* @__PURE__ */ t.jsx(w, { fontWeight: "bold", children: i(c.text) })
          ]
        }
      ) }),
      /* @__PURE__ */ t.jsx("td", { className: `p-2 ${V["rest-col"]}`, children: /* @__PURE__ */ t.jsx(
        mn,
        {
          status: e.orderStatus,
          completeDate: e.completeDate,
          transactionDate: e.scheduledOrder ? e.scheduledOrder.transactionDate : void 0
        }
      ) }),
      /* @__PURE__ */ t.jsx("td", { className: `sm:p-2 ${V["rest-col"]}`, children: !!e.amount && e.orderType !== "Swap" && /* @__PURE__ */ t.jsx(w, { textAlign: "center", fontWeight: "bold", children: x }) }),
      a && /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
        d === rt.hidden && /* @__PURE__ */ t.jsx("td", { className: `${V["last-col"]}` }),
        d === rt.disabled && /* @__PURE__ */ t.jsx("td", { className: `${V["last-col"]}`, children: /* @__PURE__ */ t.jsxs("div", { className: "flex space-x-2", children: [
          /* @__PURE__ */ t.jsx(
            Z,
            {
              name: F.delete,
              size: X.m,
              color: "var(--grey-40)"
            }
          ),
          /* @__PURE__ */ t.jsx("div", { children: /* @__PURE__ */ t.jsx(
            At,
            {
              placement: Rt.RIGHT,
              content: i("tooltip.orderbook.delete-scheduled-order"),
              size: Kt.SMALL,
              children: /* @__PURE__ */ t.jsx(
                Z,
                {
                  name: F.informationFilled,
                  size: X.m
                }
              )
            }
          ) })
        ] }) }),
        d === rt.blocked && /* @__PURE__ */ t.jsx("td", { className: `${V["last-col"]}`, children: /* @__PURE__ */ t.jsxs("div", { className: "flex space-x-2", children: [
          /* @__PURE__ */ t.jsx(
            Z,
            {
              name: F.delete,
              size: X.m,
              color: "var(--grey-40)"
            }
          ),
          /* @__PURE__ */ t.jsx("div", { children: /* @__PURE__ */ t.jsx(
            At,
            {
              placement: Rt.RIGHT,
              content: i(
                "tooltip.orderbook.delete-scheduled-order.blocked-for-execution"
              ),
              size: Kt.SMALL,
              children: /* @__PURE__ */ t.jsx(
                Z,
                {
                  name: F.informationFilled,
                  size: X.m
                }
              )
            }
          ) })
        ] }) }),
        d === rt.enabled && /* @__PURE__ */ t.jsx("td", { className: `${V["last-col"]}`, children: /* @__PURE__ */ t.jsx(
          "button",
          {
            type: "button",
            className: "flex",
            onClick: () => a(e),
            "aria-label": "Delete Order",
            children: /* @__PURE__ */ t.jsx(Z, { name: F.delete, size: X.m })
          }
        ) })
      ] })
    ] }),
    s && /* @__PURE__ */ t.jsx(
      U1,
      {
        orderType: e.orderType,
        transactions: e.transactions,
        isShowExternalId: n,
        transactionDate: e.scheduledOrder ? e.scheduledOrder.transactionDate : void 0
      }
    ),
    /* @__PURE__ */ t.jsxs("tr", { children: [
      /* @__PURE__ */ t.jsx("td", { className: `${V["first-col"]}` }),
      /* @__PURE__ */ t.jsx("td", { children: /* @__PURE__ */ t.jsx(
        _t,
        {
          onClick: () => o(!s),
          size: "small",
          buttonType: "link",
          children: i(s ? "button.show-less" : "button.more-info")
        }
      ) })
    ] })
  ] }) });
}, Pn = 5, nc = ({
  isShowExternalId: e = !1,
  setDeletingOrder: n
}) => {
  const r = S.get("useLanguage"), a = S.get(
    "useClientPortfolioIds"
  ), s = S.get("useGetGlobalSettingByGroupAndKey"), { t: o } = r(), { clientId: l, portfolioId: i } = a(), [c, d] = ce([]), u = S.get(
    "useGetContactPortfolioOrderbook"
  ), { isLoading: x, data: h } = s({
    group: "Orders.Scheduled",
    key: "MinimumDeleteDays",
    refetchOnMount: !1
  }), f = S.get(
    "useSearchScheduledOrders"
  ), g = S.get("useGetPortfolioDetails"), {
    isLoading: y,
    data: p,
    isError: b
  } = g({
    clientId: String(l),
    portfolioId: i
  }), {
    isLoading: v,
    data: j,
    isError: _
  } = u({
    clientId: l,
    portfolioId: i
  }), {
    isLoading: I,
    data: k,
    isError: O
  } = f({
    contactGroupId: Number(p == null ? void 0 : p.ContactGroupId),
    contactId: Number(l),
    enabled: !!(p != null && p.ContactGroupId),
    body: {
      portfolioId: [Number(i)],
      page: 1,
      pageSize: 100,
      transactionDateFrom: Ir(/* @__PURE__ */ new Date())
    }
  }), C = G(() => k != null && k.results && (j != null && j.orders) ? j.orders.sort(
    (D, B) => new Date(B != null && B.createDate ? B.createDate : B.completeDate).getTime() - new Date(D != null && D.createDate ? D.createDate : D.completeDate).getTime()
  ).map((D) => {
    const B = k.results.find(
      (J) => J.portfolioChangeId === D.portfolioChangeId
    );
    return { ...D, scheduledOrder: B || null };
  }) : [], [j, k == null ? void 0 : k.results]);
  ve(() => {
    d(C.slice(0, Pn));
  }, [C]);
  const R = v || y || I || x, P = _ || b || O;
  return R ? /* @__PURE__ */ t.jsxs("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ t.jsx(fe, { height: 20 }),
    /* @__PURE__ */ t.jsx(fe, { height: 20 }),
    /* @__PURE__ */ t.jsx(fe, { height: 20 }),
    /* @__PURE__ */ t.jsx(fe, { height: 20 })
  ] }) : P ? /* @__PURE__ */ t.jsx($e, { children: o("error.technical-error1") }) : !R && !P && (C == null ? void 0 : C.length) === 0 ? /* @__PURE__ */ t.jsx(w, { children: o("error.positions.no-data-found") }) : /* @__PURE__ */ t.jsxs("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ t.jsx("table", { className: "w-full table-fixed", children: /* @__PURE__ */ t.jsx("thead", { children: /* @__PURE__ */ t.jsxs("tr", { children: [
      /* @__PURE__ */ t.jsx("td", { className: `${V["first-col"]} border-0`, children: /* @__PURE__ */ t.jsx(w, { textAlign: "center", children: o("orderbook.attribute-name.commissioned-on") }) }),
      /* @__PURE__ */ t.jsx("td", { className: `${V["rest-col"]}`, children: /* @__PURE__ */ t.jsx(w, { className: `${V["second-col-padding"]}`, children: o("orderbook.attribute-name.category") }) }),
      /* @__PURE__ */ t.jsx("td", { className: `${V["rest-col"]}`, children: /* @__PURE__ */ t.jsx(w, { textAlign: "center", children: o("orderbook.attribute-name.status") }) }),
      /* @__PURE__ */ t.jsx("td", { className: `${V["rest-col"]}`, children: /* @__PURE__ */ t.jsx(w, { textAlign: "center", children: o("orderbook.attribute-name.amount") }) }),
      n && /* @__PURE__ */ t.jsx("td", { className: `${V["last-col"]}` })
    ] }) }) }),
    c.map((M, D) => /* @__PURE__ */ t.jsx(
      Y1,
      {
        order: M,
        minimumDeleteDaysSetting: h,
        isShowExternalId: e,
        setDeletingOrder: n
      },
      D
    )),
    !!(C != null && C.length) && c.length < C.length && /* @__PURE__ */ t.jsx(
      _t,
      {
        onClick: () => {
          C != null && C.length && d((M) => {
            const D = M.length + Pn < C.length ? M.length + Pn : C.length, B = (C == null ? void 0 : C.slice(M == null ? void 0 : M.length, D)) || [];
            return [...M, ...B];
          });
        },
        size: "small",
        buttonType: "link",
        children: o("button.show-more-transactions")
      }
    )
  ] });
}, Yt = {
  "positive-text-invest-card": "_positive-text-invest-card_pj865_1",
  "negative-text-invest-card": "_negative-text-invest-card_pj865_9",
  "icon-heading": "_icon-heading_pj865_17"
}, br = ({
  isLoading: e,
  heading: n,
  value: r,
  coloredValue: a,
  valueFormatter: s,
  subValue: o,
  isShowSubValSkeleton: l,
  t: i
}) => /* @__PURE__ */ t.jsx(Ee, { className: "h-[120px]", children: /* @__PURE__ */ t.jsxs("div", { className: "flex flex-col gap-2", children: [
  /* @__PURE__ */ t.jsx(w, { fontWeight: "bold", children: n }),
  e ? /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
    /* @__PURE__ */ t.jsx("div", { className: "w-24 h-6 rounded bg-misc-200 animate-pulse" }),
    l && /* @__PURE__ */ t.jsx("div", { className: "w-24 h-4 rounded bg-misc-200 animate-pulse" })
  ] }) : /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
    typeof r == "number" ? /* @__PURE__ */ t.jsx(
      w,
      {
        className: a ? `${r < 0 ? Yt["negative-text-invest-card"] : Yt["positive-text-invest-card"]}` : "",
        fontSize: "xl",
        children: s(r)
      }
    ) : r === void 0 && /* @__PURE__ */ t.jsx(w, { fontSize: "xl", children: i("common.n-a") }),
    o && /* @__PURE__ */ t.jsx(
      w,
      {
        className: a ? `${parseInt(o, 10) < 0 ? Yt["negative-text-invest-card"] : Yt["positive-text-invest-card"]}` : "",
        fontSize: "xl",
        children: o
      }
    ),
    typeof r != "number" && r === !1 && !o && /* @__PURE__ */ t.jsx(w, { fontSize: "xl", children: i("common.n-a") })
  ] })
] }) }), rc = ({
  data: e,
  isLoading: n,
  isError: r,
  t: a
}) => {
  var d, u, x, h;
  const s = S.get(
    "useClientPortfolioIds"
  ), o = S.get("useGetAllPortfolios"), { clientId: l } = s(), { data: i } = o({
    contactId: l,
    refetchOnMount: !1,
    refetchOnWindowFocus: !1
  }), c = G(() => {
    if (!i)
      return !1;
    const f = Object.values(xr).filter(
      (y) => y !== xr.NOT_IMPLEMENTED
    );
    return i.filter(
      (y) => f.includes(y.PortfolioStatusId)
    ).length <= 1;
  }, [i]);
  return /* @__PURE__ */ t.jsxs("div", { className: "flex flex-col gap-4", children: [
    /* @__PURE__ */ t.jsxs("div", { className: "flex items-center gap-4", children: [
      /* @__PURE__ */ t.jsx("h2", { className: "text-lg text-primary-500 sm:text-xl font-header", children: a("client-dashboard.overview.investment-rundown") }),
      /* @__PURE__ */ t.jsx(
        At,
        {
          content: a("client-dashboard.overview.investment-rundown.text"),
          ariaLabel: a("client-dashboard.overview.investment-rundown.label"),
          children: /* @__PURE__ */ t.jsxs("div", { className: Yt["icon-heading"], children: [
            /* @__PURE__ */ t.jsx(
              Z,
              {
                name: F.informationFilled,
                color: "var(--primary-darker)"
              }
            ),
            /* @__PURE__ */ t.jsx(w, { className: "mt-1", fontWeight: "bold", children: a("client-dashboard.overview.investment-rundown.label") })
          ] })
        }
      )
    ] }),
    r && !n ? /* @__PURE__ */ t.jsx(Ee, { children: /* @__PURE__ */ t.jsx($e, { children: a("error.technical-error1") }) }) : /* @__PURE__ */ t.jsxs(
      "div",
      {
        className: `grid gap-6 ${c ? "sm:grid-cols-2" : ""}`,
        children: [
          /* @__PURE__ */ t.jsx(
            br,
            {
              isLoading: n,
              heading: a("common.total-aum"),
              value: (d = e == null ? void 0 : e.data) == null ? void 0 : d.CurrentValue,
              coloredValue: !1,
              valueFormatter: (f) => _e(f),
              subValue: !1,
              t: a
            }
          ),
          c && /* @__PURE__ */ t.jsx(
            br,
            {
              isLoading: n,
              heading: a("client-dashboard.overview.total-return"),
              value: c ? (u = e == null ? void 0 : e.data) == null ? void 0 : u.CurrentMwrPerformance : !1,
              coloredValue: !0,
              valueFormatter: (f) => zt(f, {
                multiplier: 100
              }),
              subValue: !!((x = e == null ? void 0 : e.data) != null && x.CurrentPerformanceAmount) && _e((h = e == null ? void 0 : e.data) == null ? void 0 : h.CurrentPerformanceAmount),
              isShowSubValSkeleton: !0,
              t: a
            }
          )
        ]
      }
    )
  ] });
}, Ut = {
  "icon-radio-container": "_icon-radio-container_7vz3z_1",
  "is-checked": "_is-checked_7vz3z_39",
  "icon-radio-disabled": "_icon-radio-disabled_7vz3z_47",
  "checkmark-container": "_checkmark-container_7vz3z_57",
  "checkmark-wrapper": "_checkmark-wrapper_7vz3z_65"
}, W1 = ({
  label: e,
  icon: n,
  isChecked: r,
  onChange: a,
  value: s,
  disabled: o
}) => {
  const l = A(Ut["icon-radio-container"], {
    [Ut["is-checked"]]: r,
    [Ut["icon-radio-disabled"]]: !!o
  }), i = () => {
    o || a(s);
  }, c = (d) => {
    d.key === "Enter" && i();
  };
  return /* @__PURE__ */ t.jsxs(
    "div",
    {
      className: l,
      onClick: i,
      role: "button",
      tabIndex: 0,
      onKeyDown: c,
      children: [
        /* @__PURE__ */ t.jsx("div", { className: Ut["checkmark-container"], children: r && /* @__PURE__ */ t.jsx("div", { className: Ut["checkmark-wrapper"], children: /* @__PURE__ */ t.jsx(Z, { name: F.checkmark, size: X.xs }) }) }),
        /* @__PURE__ */ t.jsx(Z, { name: n, size: X.xxl }),
        /* @__PURE__ */ t.jsx(w, { fontSize: "lg", textAlign: "center", fontWeight: "bold", children: e })
      ]
    }
  );
}, Xr = ({ formProps: e, name: n, options: r }) => {
  const { onChange: a, values: s, errors: o } = e, l = s(n), i = G(() => o == null ? void 0 : o[n], [o, n]);
  return /* @__PURE__ */ t.jsxs("div", { className: "flex flex-col gap-4", children: [
    /* @__PURE__ */ t.jsx("div", { className: "mx-auto grid grid-cols-1 gap-6 sm:grid-cols-2", children: r.map((c) => {
      const d = c.value === l;
      return /* @__PURE__ */ t.jsx(
        W1,
        {
          isChecked: d,
          onChange: a(n),
          label: c.label,
          icon: c.icon,
          value: c.value,
          disabled: !!c.disabled
        },
        c.value
      );
    }) }),
    (i == null ? void 0 : i.message) && /* @__PURE__ */ t.jsx($e, { children: i.message })
  ] });
};
var We = /* @__PURE__ */ ((e) => (e.COMFORT = "1", e.INDIVIDUAL = "2", e))(We || {}), st = /* @__PURE__ */ ((e) => (e.INVESTMENT_FOCUS = "1", e.TOPICS = "2", e.PORTFOLIO_CHANGE = "3", e))(st || {}), Qr = /* @__PURE__ */ ((e) => (e.selectionSwap = "selectionSwap", e.overview = "overview", e.swapTopics = "swapTopics", e.mtan = "mtan", e.success = "success", e.summery = "summery", e.changePortfolio = "changePortfolio", e))(Qr || {}), Ne = /* @__PURE__ */ ((e) => (e.selectionSwap = "selectionSwap", e.selectionSwapCheckbox = "selectionSwapCheckbox", e.topicsComfort = "topicsComfort", e.topicsIndividual = "topicsIndividual", e.portfolioTypeRadio = "portfolioTypeRadio", e.overviewCheckBox = "overviewCheckBox", e.newPortfolio = "newPortfolio", e.mtan = "mtan", e))(Ne || {});
const sc = (e) => ft().shape({
  selectionSwap: Je().required(
    e("error.validation.dropdown-cannot-be-empty")
  )
}), K1 = ({
  selectionSwapAnswer: e,
  initialPortfolioRadio: n,
  t: r
}) => e === "2" ? {
  heading: r("wizard.topicswap.swaptopics.error-notification.header"),
  message: r("wizard.topicswap.swaptopics.error-notification.text")
} : n === "1" ? {
  heading: r(
    "wizard.topicswap.changeinvestmentfocus.error-notification.header2"
  ),
  message: r(
    "wizard.topicswap.changeinvestmentfocus.error-notification.text2"
  )
} : {
  heading: r(
    "wizard.topicswap.changeinvestmentfocus.error-notification.header1"
  ),
  message: r(
    "wizard.topicswap.changeinvestmentfocus.error-notification.text1"
  )
}, J1 = (e) => ({
  "Technologie-Innovationen": /* @__PURE__ */ t.jsxs("div", { children: [
    /* @__PURE__ */ t.jsx("b", { children: e("depot-onboarding.topics.technology.tooltip.header") }),
    /* @__PURE__ */ t.jsx("br", {}),
    /* @__PURE__ */ t.jsx("br", {}),
    /* @__PURE__ */ t.jsx("span", { children: e("depot-onboarding.topics.technology.tooltip.text1") }),
    /* @__PURE__ */ t.jsx("br", {}),
    /* @__PURE__ */ t.jsx("br", {}),
    /* @__PURE__ */ t.jsx("span", { children: e("depot-onboarding.topics.technology.tooltip.text2") })
  ] }),
  "Gesundheits-Innovationen": /* @__PURE__ */ t.jsxs("div", { children: [
    /* @__PURE__ */ t.jsx("b", { children: e("depot-onboarding.topics.healthcare.tooltip.header") }),
    /* @__PURE__ */ t.jsx("br", {}),
    /* @__PURE__ */ t.jsx("br", {}),
    /* @__PURE__ */ t.jsx("span", { children: e("depot-onboarding.topics.healthcare.tooltip.text1") }),
    /* @__PURE__ */ t.jsx("br", {}),
    /* @__PURE__ */ t.jsx("br", {}),
    /* @__PURE__ */ t.jsx("span", { children: e("depot-onboarding.topics.healthcare.tooltip.text2") })
  ] }),
  "Gesellschaftlicher Wandel": /* @__PURE__ */ t.jsxs("div", { children: [
    /* @__PURE__ */ t.jsx("b", { children: e("depot-onboarding.topics.societal-change.tooltip.header") }),
    /* @__PURE__ */ t.jsx("br", {}),
    /* @__PURE__ */ t.jsx("br", {}),
    /* @__PURE__ */ t.jsx("span", { children: e("depot-onboarding.topics.societal-change.tooltip.text1") }),
    /* @__PURE__ */ t.jsx("br", {}),
    /* @__PURE__ */ t.jsx("br", {}),
    /* @__PURE__ */ t.jsx("span", { children: e("depot-onboarding.topics.societal-change.tooltip.text2") })
  ] })
}), X1 = (e, n, r, a) => {
  const s = n == null ? void 0 : n.map((i) => ({
    Id: i.id,
    Name: i.story,
    isin: i.isin,
    productId: i.products[0].productId
  })), o = s == null ? void 0 : s.filter(
    (i) => i.productId === r
  ), l = o == null ? void 0 : o.map((i) => ({
    name: i.Name,
    label: i.Name,
    id: i.Id.toString(),
    info: {
      placement: Rt.RIGHT,
      size: Kt.MEDIUM_SMALL,
      text: J1(a)[i.Name]
    }
  }));
  return {
    name: e,
    options: l
  };
}, Q1 = (e, n) => [
  {
    value: We.COMFORT,
    label: e("depot-onboarding.topics.icon.comfort"),
    icon: F.comfort,
    disabled: n === We.COMFORT
  },
  {
    value: We.INDIVIDUAL,
    label: e("depot-onboarding.topics.icon.individual"),
    icon: F.individual,
    disabled: n === We.INDIVIDUAL
  }
], ac = ({
  isLoading: e,
  error: n,
  onNext: r,
  onClose: a,
  t: s,
  formProps: o,
  portfolio: l,
  securities: i,
  selectionSwapAnswer: c,
  onPrev: d,
  initialPortfolioRadio: u,
  initialTopicsIndividual: x
}) => {
  var R;
  const [h, f] = ce(!1), { onChange: g, errors: y, values: p } = o, b = p(Ne.portfolioTypeRadio), v = G(
    () => b === We.INDIVIDUAL,
    [b]
  ), j = G(
    () => Q1(s, u),
    [u, s]
  ), _ = X1(
    Ne.topicsIndividual,
    i.securitiesIndividual,
    (R = l.Product) == null ? void 0 : R.Id,
    s
  ), k = {
    action: async () => {
      if (c === st.TOPICS) {
        const P = p("topicsIndividual");
        if (x.length === (P == null ? void 0 : P.length) && (/* @__PURE__ */ new Set([
          ...P,
          ...x
        ])).size === x.length) {
          f(!0);
          return;
        }
      }
      await r();
    },
    title: s("button.next")
  }, O = {
    action: d,
    title: s("button.back")
  }, C = G(() => ({
    ...K1({
      selectionSwapAnswer: c,
      initialPortfolioRadio: u,
      t: s
    }),
    button: {
      title: s("button.close"),
      onClick: a
    }
  }), [u, a, c, s]);
  return /* @__PURE__ */ t.jsx(Nt, { isLoading: e, error: n, modal: C, children: /* @__PURE__ */ t.jsxs(Xe, { className: "min-h-[600px]", children: [
    /* @__PURE__ */ t.jsx(me, { textAlign: "left", children: u === We.INDIVIDUAL && c === st.INVESTMENT_FOCUS ? s("wizard.topicswap.changeinvestmentfocus") : s("wizard.topicswap.swaptopics") }),
    c === st.INVESTMENT_FOCUS && /* @__PURE__ */ t.jsx(
      Xr,
      {
        formProps: o,
        name: Ne.portfolioTypeRadio,
        options: j
      }
    ),
    v && /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
      /* @__PURE__ */ t.jsx(Le, { size: 3, children: s("depot-onboarding.topics.choice-header") }),
      /* @__PURE__ */ t.jsx(
        wi,
        {
          options: _.options,
          onChange: (P) => {
            f(!1), g(_.name)(P);
          },
          error: y == null ? void 0 : y[_.name],
          value: p(_.name)
        }
      )
    ] }),
    h && /* @__PURE__ */ t.jsx($e, { children: s("error.validation.topics-not-changed") }),
    /* @__PURE__ */ t.jsx("div", { className: "mt-auto", children: /* @__PURE__ */ t.jsx(Be, { onNext: k, onPrev: O }) })
  ] }) });
}, el = (e, n, r) => {
  const a = n === We.COMFORT;
  return [
    {
      value: st.INVESTMENT_FOCUS,
      label: e("wizard.topicswap.changeinvestmentfocus.header"),
      icon: F.filter
    },
    {
      value: st.TOPICS,
      label: e("wizard.topicswap.swaptopic.header"),
      icon: F.quarterCircleArrow,
      disabled: a
    },
    ...r ? [
      {
        value: st.PORTFOLIO_CHANGE,
        label: e("wizard.topicswap.portfolioswap.header"),
        icon: F.compareArrows
      }
    ] : []
  ];
}, oc = ({
  t: e,
  formProps: n,
  onNext: r,
  onClose: a,
  initialSwapValues: s,
  isShowPortfolioChange: o = !1
}) => {
  var d;
  const l = G(
    () => el(
      e,
      s[Qr.swapTopics][Ne.portfolioTypeRadio],
      o
    ),
    [s, o, e]
  ), i = {
    action: r,
    title: e("button.next")
  }, c = {
    action: a,
    title: e("button.interrupt")
  };
  return /* @__PURE__ */ t.jsxs(Xe, { children: [
    /* @__PURE__ */ t.jsx(me, { children: /* @__PURE__ */ t.jsx(
      Fn,
      {
        i18nKey: "wizard.topicswap.productchange",
        components: {
          b: /* @__PURE__ */ t.jsx(Jr, {}),
          br: /* @__PURE__ */ t.jsx(F1, {})
        }
      }
    ) }),
    /* @__PURE__ */ t.jsx(
      Xr,
      {
        formProps: n,
        name: Ne.selectionSwap,
        options: l
      }
    ),
    o && n.values(Ne.selectionSwap) === st.PORTFOLIO_CHANGE && /* @__PURE__ */ t.jsx(
      en,
      {
        name: Ne.selectionSwapCheckbox,
        onChange: n.onChange(
          Ne.selectionSwapCheckbox
        ),
        error: (d = n.errors) == null ? void 0 : d[Ne.selectionSwapCheckbox],
        label: e(
          "checkbox.financial-circumstances-and-risk appetite-has-not-changed"
        ),
        checked: n.values(
          Ne.selectionSwapCheckbox
        )
      }
    ),
    /* @__PURE__ */ t.jsx(Be, { onNext: i, onPrev: c })
  ] });
}, cn = {
  "bg-topic-heading-color": "_bg-topic-heading-color_13kki_1",
  "bg-topic-list-color": "_bg-topic-list-color_13kki_11"
}, ic = (e) => ft().shape({
  [Ne.overviewCheckBox]: xn().oneOf(
    [!0],
    e("error.validation.cannot-be-empty")
  )
}), lc = ({
  t: e,
  selectionSwapAnswer: n,
  portfolioTypeRadio: r,
  riskCategory: a,
  onNext: s,
  onPrev: o,
  portfolioName: l,
  externalId: i,
  phoneNumber: c,
  formProps: d,
  securitiesIndividual: u,
  topicsIndividual: x,
  initialTopicsIndividual: h,
  exAnte: f,
  newAllocations: g
}) => {
  const y = G(() => n === st.TOPICS ? "wizard.topicswap.swaptopics.overview" : r === We.COMFORT ? "wizard.topicswap.changeinvestmentfocus.comfort.overview" : "wizard.topicswap.changeinvestmentfocus.individual.overview", [r, n]), { values: p, errors: b, onChange: v } = d, j = G(
    () => r === We.INDIVIDUAL,
    [r]
  ), _ = x.map((C) => {
    var D, B;
    const R = (D = u.find(
      (J) => String(J.id) === C
    )) == null ? void 0 : D.name, P = (B = g.find(
      (J) => String(J.securityId) === C
    )) == null ? void 0 : B.allocation, M = zt(P, {
      multiplier: 100
    });
    return `${R} (${M})`;
  }), I = h.map(
    (C) => {
      var R;
      return (R = u.find((P) => String(P.id) === C)) == null ? void 0 : R.name;
    }
  ), k = {
    action: s,
    title: e("button.next")
  }, O = {
    action: o,
    title: e("button.back")
  };
  return /* @__PURE__ */ t.jsxs(Xe, { children: [
    /* @__PURE__ */ t.jsx(me, { children: e(y) }),
    /* @__PURE__ */ t.jsxs("div", { className: "flex items-center gap-6", children: [
      /* @__PURE__ */ t.jsx(Wn, { riskCategory: a }),
      /* @__PURE__ */ t.jsxs(Le, { size: 2, className: "mt-4", children: [
        l,
        " ",
        e(j ? "depot-onboarding.topics.icon.individual" : "depot-onboarding.topics.icon.comfort")
      ] })
    ] }),
    /* @__PURE__ */ t.jsxs("div", { children: [
      /* @__PURE__ */ t.jsx(Le, { size: 3, children: e("wizard.depot-number") }),
      /* @__PURE__ */ t.jsx(w, { children: i })
    ] }),
    j && /* @__PURE__ */ t.jsxs("div", { className: "sm:grid-cols-2 grid gap-4", children: [
      /* @__PURE__ */ t.jsxs("div", { className: "flex flex-col gap-2", children: [
        /* @__PURE__ */ t.jsx("div", { className: cn["bg-topic-heading-color"], children: /* @__PURE__ */ t.jsx(w, { fontWeight: "bold", children: e("wizard.topicswap.oldtopics") }) }),
        I.map((C) => /* @__PURE__ */ t.jsx("div", { className: cn["bg-topic-list-color"], children: /* @__PURE__ */ t.jsx(w, { children: C }) }, C))
      ] }),
      /* @__PURE__ */ t.jsxs("div", { className: "flex flex-col gap-2", children: [
        /* @__PURE__ */ t.jsx("div", { className: cn["bg-topic-heading-color"], children: /* @__PURE__ */ t.jsx(w, { fontWeight: "bold", children: e("wizard.topicswap.newtopics") }) }),
        _.map((C) => /* @__PURE__ */ t.jsx("div", { className: cn["bg-topic-list-color"], children: /* @__PURE__ */ t.jsx(w, { children: C }) }, C))
      ] })
    ] }),
    /* @__PURE__ */ t.jsx(gn, { name: e("filename.ex-ante"), exAnteFile: f }),
    /* @__PURE__ */ t.jsx(
      en,
      {
        name: Ne.overviewCheckBox,
        label: e("wizard.checkbox.ex-ante-cost"),
        onChange: v(Ne.overviewCheckBox),
        error: b == null ? void 0 : b[Ne.overviewCheckBox],
        checked: p(Ne.overviewCheckBox)
      }
    ),
    /* @__PURE__ */ t.jsx(De, { text: e("wizard.topicswap.reallocation.infobox") }),
    c && /* @__PURE__ */ t.jsx(
      De,
      {
        text: de(e("wizard.hint.mtan1"), {
          $phoneNumber$: c
        }),
        colored: !0
      }
    ),
    /* @__PURE__ */ t.jsx(Be, { onNext: k, onPrev: O })
  ] });
}, tl = (e) => {
  var n, r;
  if (e != null && e.CustomAttributes) {
    const s = (((n = JSON.parse(e == null ? void 0 : e.CustomAttributes)) == null ? void 0 : n.PortfolioSwaps) || []).sort(
      (i, c) => new Date(c.ProcessedDate).getTime() - new Date(i.ProcessedDate).getTime()
    ), o = (r = s == null ? void 0 : s[0]) == null ? void 0 : r.ProcessedDate;
    return o ? (/* @__PURE__ */ new Date()).getTime() <= new Date(o).getTime() : !1;
  }
  return !0;
}, cc = (e, n) => {
  var i, c;
  if (!e) return !1;
  if (e.CurrentValue <= 0)
    return {
      heading: "error.warning1",
      message: "error.validation.portfolio-value-cannot-be-null"
    };
  const a = tl(e), s = JSON.parse((e == null ? void 0 : e.CustomAttributes) ?? ""), o = (i = n == null ? void 0 : n.Swaps) == null ? void 0 : i.some((d) => d.isPending), l = (c = s == null ? void 0 : s.PortfolioSwaps) == null ? void 0 : c.PendingSwap;
  return o || a || l ? {
    heading: "error.validation.open-swap-swap.header",
    message: "error.validation.open-swap-swap.text"
  } : !1;
}, nl = {
  "heading-title": "_heading-title_g1l4w_1"
}, dc = () => {
  var i, c, d, u;
  const e = S.get("getContactDetails"), n = S.get(
    "useClientPortfolioIds"
  ), { clientId: r } = n(), { isLoading: a, data: s } = e({ clientId: r });
  if (a)
    return /* @__PURE__ */ t.jsx(fe, { height: 8, width: 60 });
  const o = (c = (i = s == null ? void 0 : s.details) == null ? void 0 : i.personalInformation) == null ? void 0 : c.firstName, l = (u = (d = s == null ? void 0 : s.details) == null ? void 0 : d.personalInformation) == null ? void 0 : u.lastName;
  return /* @__PURE__ */ t.jsxs(Le, { size: 2, className: nl["heading-title"], children: [
    o,
    " ",
    l
  ] });
};
var rl = Object.defineProperty, sl = Object.getOwnPropertyDescriptor, al = (e, n, r, a) => {
  for (var s = a > 1 ? void 0 : a ? sl(n, r) : n, o = e.length - 1, l; o >= 0; o--)
    (l = e[o]) && (s = (a ? l(n, r, s) : l(s)) || s);
  return a && s && rl(n, r, s), s;
};
let jr = class {
  constructor() {
    tn(this, "clientId", "");
  }
  setClientId(e) {
    this.clientId = e;
  }
};
jr = al([
  js()
], jr);
const uc = ({ isSecond: e }) => {
  const n = S.get("useLanguage"), { t: r } = n();
  return /* @__PURE__ */ t.jsx(Wr, { t: r, isSecond: e });
}, mc = ({
  onNext: e,
  onPrev: n,
  fundings: r,
  gepRadioOrCheckbox: a,
  onSubmit: s
}) => {
  const o = S.get("useLanguage"), l = S.get(
    "useClientPortfolioIds"
  ), { t: i } = o(), { clientId: c, portfolioId: d } = l();
  return /* @__PURE__ */ t.jsxs(Xe, { className: A({ "!gap-10": !!s }), children: [
    /* @__PURE__ */ t.jsx(bn, { clientId: c, portfolioId: d }),
    /* @__PURE__ */ t.jsx(zo, { fundings: r, onNext: e }),
    a && s && r.length < 5 && /* @__PURE__ */ t.jsxs("div", { className: "space-y-4", children: [
      r.length > 0 && /* @__PURE__ */ t.jsx(Le, { size: 3, children: i("button.new-saving-plan") }),
      a
    ] }),
    s && n && /* @__PURE__ */ t.jsx(
      Be,
      {
        onNext: {
          action: s,
          disabled: r.length >= 5,
          title: i("button.new-saving-plan")
        },
        onPrev: {
          action: n,
          title: i("button.interrupt")
        }
      }
    )
  ] });
}, wr = {
  isGepValid: "isGepValid"
}, hc = (e, n, r) => n ? ft().shape({
  [wr.isGepValid]: le().optional()
}) : ft().shape({
  [wr.isGepValid]: r ? xn().oneOf([!0], e("error.validation.cannot-be-empty")) : le().oneOf(
    [!0, !1, "true", "false"],
    e("error.validation.cannot-be-empty")
  )
}), je = {
  "first-col": "_first-col_ityit_1",
  "col-width": "_col-width_ityit_13",
  "last-col-width": "_last-col-width_ityit_23",
  "rotate-arrow": "_rotate-arrow_ityit_35",
  "positive-text": "_positive-text_ityit_45",
  "negative-text": "_negative-text_ityit_53",
  "column-header-padding": "_column-header-padding_ityit_61"
}, ol = (e) => {
  var a;
  const n = (a = e == null ? void 0 : e.Positions) == null ? void 0 : a.filter(
    (s) => s.Quantity !== 0
  );
  return n == null ? void 0 : n.map((s) => {
    var o, l, i, c;
    return {
      name: (o = s == null ? void 0 : s.Security) == null ? void 0 : o.Name,
      isin: (l = s == null ? void 0 : s.Security) == null ? void 0 : l.Isin,
      quantity: s == null ? void 0 : s.Quantity,
      tradingPrice: (i = s == null ? void 0 : s.Security) == null ? void 0 : i.TradingPrice,
      performance: s == null ? void 0 : s.Performance,
      investmentValuePortfolioCurrency: s == null ? void 0 : s.InvestmentValuePortfolioCurrency,
      allocation: s == null ? void 0 : s.Allocation,
      securityId: (c = s == null ? void 0 : s.Security) == null ? void 0 : c.Id,
      monetaryPerformance: s == null ? void 0 : s.MonetaryPerformance
    };
  });
}, Mt = () => /* @__PURE__ */ t.jsxs("tr", { children: [
  /* @__PURE__ */ t.jsx("td", {}),
  /* @__PURE__ */ t.jsx("td", { className: "py-2", colSpan: 4, children: /* @__PURE__ */ t.jsx(fe, {}) })
] }), il = ({ securityId: e }) => {
  const n = S.get("useLanguage"), { t: r } = n(), a = S.get(
    "useGetSecuritiesComponentsById"
  ), {
    isLoading: s,
    data: o
  } = a({
    securityId: String(e)
  }), l = G(() => {
    const d = o == null ? void 0 : o.components;
    return d ? d.sort(
      (h, f) => f.allocation - h.allocation
    ).slice(0, 5).map((h) => h.id) : [];
  }, [o]), c = S.get(
    "useGetSecuritiesById"
  )({ securitiesComponents: l });
  return /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
    /* @__PURE__ */ t.jsxs("tr", { className: "border-t border-solid", children: [
      /* @__PURE__ */ t.jsx("td", {}),
      /* @__PURE__ */ t.jsx("td", { colSpan: 2, className: "border-t border-solid", children: /* @__PURE__ */ t.jsx(w, { className: "my-2", fontWeight: "bold", fontSize: "sm", children: r("positions.target-investment") }) }),
      /* @__PURE__ */ t.jsx("td", { colSpan: 2, className: "border-t border-solid", children: /* @__PURE__ */ t.jsx(w, { className: "my-2", fontWeight: "bold", fontSize: "sm", children: r("positions.sector") }) })
    ] }),
    s ? /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
      /* @__PURE__ */ t.jsx(Mt, {}),
      /* @__PURE__ */ t.jsx(Mt, {}),
      /* @__PURE__ */ t.jsx(Mt, {}),
      /* @__PURE__ */ t.jsx(Mt, {}),
      /* @__PURE__ */ t.jsx(Mt, {})
    ] }) : /* @__PURE__ */ t.jsx(t.Fragment, { children: c.map((d, u) => {
      var x, h, f, g;
      return d != null && d.data ? /* @__PURE__ */ t.jsxs("tr", { children: [
        /* @__PURE__ */ t.jsx("td", {}),
        /* @__PURE__ */ t.jsx("td", { colSpan: 2, children: /* @__PURE__ */ t.jsx(w, { className: "mb-2 pr-2", fontSize: "sm", children: (x = d == null ? void 0 : d.data) == null ? void 0 : x.Name }) }),
        /* @__PURE__ */ t.jsx("td", { colSpan: 3, children: /* @__PURE__ */ t.jsx(w, { className: "mb-2", fontSize: "sm", children: (f = (h = d == null ? void 0 : d.data) == null ? void 0 : h.Focus) == null ? void 0 : f.Name }) })
      ] }, (g = d == null ? void 0 : d.data) == null ? void 0 : g.Name) : /* @__PURE__ */ t.jsx(Mt, {}, u);
    }) })
  ] });
}, ll = ({ position: e }) => {
  const [n, r] = ce(!1), a = S.get("useLanguage"), { t: s } = a();
  return /* @__PURE__ */ t.jsx("table", { className: "w-full table-fixed", children: /* @__PURE__ */ t.jsxs("tbody", { className: "border", children: [
    /* @__PURE__ */ t.jsxs("tr", { children: [
      /* @__PURE__ */ t.jsx("td", { className: `py-2 ${je["first-col"]}`, children: /* @__PURE__ */ t.jsx(w, { fontWeight: "bold", children: e.name }) }),
      /* @__PURE__ */ t.jsx("td", { className: `pb-2 ${je["col-width"]}`, children: /* @__PURE__ */ t.jsx(w, { fontWeight: "bold", fontSize: "sm", children: _e(e.tradingPrice) }) }),
      /* @__PURE__ */ t.jsx("td", { className: `pb-2 ${je["col-width"]}`, children: /* @__PURE__ */ t.jsx(w, { fontWeight: "bold", fontSize: "sm", children: (e == null ? void 0 : e.investmentValuePortfolioCurrency) && _e(e.investmentValuePortfolioCurrency) }) }),
      /* @__PURE__ */ t.jsx("td", { className: `pb-2 ${je["col-width"]}`, children: /* @__PURE__ */ t.jsx(
        w,
        {
          fontSize: "sm",
          fontWeight: "bold",
          className: `${e != null && e.monetaryPerformance && (e == null ? void 0 : e.monetaryPerformance) < 0 ? je["negative-text"] : je["positive-text"]}`,
          children: (e == null ? void 0 : e.monetaryPerformance) && _e(e.monetaryPerformance)
        }
      ) }),
      /* @__PURE__ */ t.jsx("td", { className: "pb-2", children: /* @__PURE__ */ t.jsx(w, { fontWeight: "bold", fontSize: "sm", children: zt(e.allocation, {
        multiplier: 100
      }) }) }),
      /* @__PURE__ */ t.jsx(
        "td",
        {
          rowSpan: 2,
          onClick: () => r(!n),
          className: `p-2 cursor-pointer ${je["last-col-width"]} ${n ? je["rotate-arrow"] : ""}`,
          children: /* @__PURE__ */ t.jsx(Z, { name: F.chevronDown, size: X.s })
        }
      )
    ] }),
    /* @__PURE__ */ t.jsxs("tr", { children: [
      /* @__PURE__ */ t.jsx("td", { className: `pb-2 ${je["first-col"]}`, children: /* @__PURE__ */ t.jsxs(w, { fontWeight: "bold", fontSize: "sm", children: [
        s("positions.isin"),
        " ",
        e.isin
      ] }) }),
      /* @__PURE__ */ t.jsx("td", {}),
      /* @__PURE__ */ t.jsx("td", { className: `pb-2 ${je["col-width"]}`, children: /* @__PURE__ */ t.jsxs(w, { fontWeight: "bold", fontSize: "sm", children: [
        ue(e.quantity),
        " ",
        s("positions.items")
      ] }) })
    ] }),
    n && /* @__PURE__ */ t.jsx(il, { securityId: e.securityId })
  ] }) });
}, xc = () => {
  const e = S.get("useLanguage"), { t: n } = e(), r = S.get(
    "useClientPortfolioIds"
  ), { clientId: a, portfolioId: s } = r(), o = S.get("useGetPortfolioDetails"), {
    isLoading: l,
    data: i,
    error: c
  } = o({
    clientId: String(a),
    portfolioId: s
  }), d = G(() => i != null && i.Positions ? ol(i) : [], [i]);
  return l ? /* @__PURE__ */ t.jsxs("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ t.jsx(fe, { height: 12 }),
    /* @__PURE__ */ t.jsx(fe, { height: 12 }),
    /* @__PURE__ */ t.jsx(fe, { height: 12 }),
    /* @__PURE__ */ t.jsx(fe, { height: 12 })
  ] }) : c ? /* @__PURE__ */ t.jsx($e, { children: n("error.technical-error1") }) : !l && d.length === 0 ? /* @__PURE__ */ t.jsx(w, { children: n("error.positions.no-data-found") }) : /* @__PURE__ */ t.jsxs("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ t.jsx("table", { className: "w-full table-fixed", children: /* @__PURE__ */ t.jsx("thead", { children: /* @__PURE__ */ t.jsxs("tr", { children: [
      /* @__PURE__ */ t.jsx("td", { className: `${je["first-col"]}`, children: /* @__PURE__ */ t.jsx(w, { fontWeight: "bold", children: n("positions.fund") }) }),
      /* @__PURE__ */ t.jsx("td", { className: `${je["col-width"]}`, children: /* @__PURE__ */ t.jsx(w, { fontWeight: "bold", children: n("positions.price-per-item") }) }),
      /* @__PURE__ */ t.jsx("td", { className: `${je["col-width"]}`, children: /* @__PURE__ */ t.jsx(w, { fontWeight: "bold", children: n("positions.value") }) }),
      /* @__PURE__ */ t.jsx("td", { className: `${je["col-width"]}`, children: /* @__PURE__ */ t.jsx(w, { fontWeight: "bold", className: "truncate", children: n("positions.value-development") }) }),
      /* @__PURE__ */ t.jsx("td", { className: `${je["col-width"]}`, children: /* @__PURE__ */ t.jsx(w, { className: je["last-col-header"], fontWeight: "bold", children: n("positions.portfolio-share") }) }),
      /* @__PURE__ */ t.jsx("td", { className: `${je["last-col-width"]}` })
    ] }) }) }),
    d.map((u) => /* @__PURE__ */ t.jsx(ll, { position: u }, u.name))
  ] });
}, fc = ({
  riskCategoryId: e,
  productName: n,
  externalId: r,
  t: a,
  className: s = ""
}) => /* @__PURE__ */ t.jsx("div", { className: s, children: /* @__PURE__ */ t.jsx(Ee, { children: /* @__PURE__ */ t.jsx("div", { className: "flex items-center justify-between w-full gap-4 sm:gap-10", children: /* @__PURE__ */ t.jsxs("div", { className: "flex flex-wrap items-center justify-center w-full gap-4 sm:flex-nowrap sm:justify-between", children: [
  /* @__PURE__ */ t.jsxs("div", { className: "flex items-center gap-4", children: [
    e && /* @__PURE__ */ t.jsx(
      Wn,
      {
        riskCategory: e
      }
    ),
    /* @__PURE__ */ t.jsx("div", { className: "flex flex-col space-y-0.5", children: /* @__PURE__ */ t.jsx(w, { fontWeight: "bold", fontSize: "xl", children: n }) })
  ] }),
  r && /* @__PURE__ */ t.jsxs("div", { className: "flex flex-col items-end gap-2", children: [
    /* @__PURE__ */ t.jsx(w, { children: a("common.portfolioExternalId") }),
    /* @__PURE__ */ t.jsx(w, { children: r })
  ] })
] }) }) }) }), gc = ({
  text: e,
  onClose: n,
  onPrev: r
}) => {
  const a = S.get("useLanguage"), { t: s } = a();
  return /* @__PURE__ */ t.jsxs("div", { className: "flex flex-col space-y-8", children: [
    /* @__PURE__ */ t.jsx(
      Z,
      {
        name: F.informationFilled,
        size: X.xl,
        className: "mx-auto mt-8",
        color: "var(--blue-90)"
      }
    ),
    /* @__PURE__ */ t.jsx(me, { textAlign: "center", children: e || s("warning.saving-plan.note-new-gep-check-is-required.text") }),
    /* @__PURE__ */ t.jsx("div", { className: "pt-8", children: /* @__PURE__ */ t.jsx(Be, { onNext: n, onPrev: r }) })
  ] });
}, pc = ({
  text: e,
  onClose: n,
  onPrev: r
}) => {
  const a = S.get("useLanguage"), { t: s } = a();
  return /* @__PURE__ */ t.jsxs("div", { className: "flex flex-col space-y-8", children: [
    /* @__PURE__ */ t.jsx(
      Z,
      {
        name: F.informationFilled,
        size: X.xl,
        className: "mx-auto mt-8",
        color: "var(--blue-90)"
      }
    ),
    /* @__PURE__ */ t.jsx(me, { textAlign: "center", children: e || s("warning.note-new-gep-check-is-required.text") }),
    /* @__PURE__ */ t.jsx("div", { className: "pt-8", children: /* @__PURE__ */ t.jsx(Be, { onNext: n, onPrev: r }) })
  ] });
};
class Wt {
  static start(n, r) {
    const a = new Blob([this.workerScript], {
      type: "application/javascript"
    }), s = new Worker(URL.createObjectURL(a));
    s.onmessage = () => n(), s.postMessage({ command: "start", delay: r });
    const o = Date.now() + Math.random();
    return this.workerIntervals.set(o, s), o;
  }
  static stop(n) {
    if (this.workerIntervals.has(n)) {
      const r = this.workerIntervals.get(n);
      r.postMessage({ command: "stop" }), r.terminate(), this.workerIntervals.delete(n);
    }
  }
}
tn(Wt, "workerIntervals", /* @__PURE__ */ new Map()), tn(Wt, "workerScript", `
        let intervalId;
        self.onmessage = (event) => {
            const { command, delay } = event.data;
            if (command === "start" && delay !== undefined) {
                if (intervalId) clearInterval(intervalId);
                intervalId = setInterval(() => {
                    postMessage("tick");
                }, delay);
            } else if (command === "stop") {
                if (intervalId) clearInterval(intervalId);
                intervalId = null;
            }
        };
    `);
const dn = (e) => {
  if (!e)
    return {
      min: 0,
      sec: 0
    };
  const { Value: n } = e, r = Number(n) % 60;
  return { min: (Number(n) - r) / 60, sec: r };
}, cl = vt(
  ({ timerValue: e, setExpiredError: n }, r) => {
    const a = S.get("useLanguage"), { t: s } = a(), [o, l] = ce(() => dn(e).min), [i, c] = ce(() => dn(e).sec), [d, u] = ce(!1), x = ye(null);
    return _r(r, () => ({
      runTimer() {
        l(dn(e).min), c(dn(e).sec), u(!0);
      }
    })), ve(() => {
      if (d) {
        const h = Wt.start(() => {
          if (i > 0) {
            c(i - 1);
            return;
          }
          if (o === 0) {
            n(), Wt.stop(h);
            return;
          }
          l(o - 1), c(59);
        }, 1e3);
        x.current = h;
      }
      return () => {
        Wt.stop(x.current);
      };
    }, [d, o, i, n]), /* @__PURE__ */ t.jsxs(w, { fontSize: "xs", children: [
      s("mtan.text2"),
      " ",
      /* @__PURE__ */ t.jsx("b", { children: `${o} Minuten, ${i} Sekunden` })
    ] });
  }
), Ot = "mtanInput", vc = ({
  isLoading: e,
  translations: n,
  setGeneratedSessionId: r,
  name: a,
  className: s = "",
  contactId: o,
  mtanQueryWBody: l,
  handleOnSuccess: i,
  handleOnError: c,
  length: d = 6,
  children: u,
  type: x = "number"
}) => {
  const h = S.get("useLanguage"), f = S.get("useFormContext"), g = S.get("useGetGlobalSettingByGroupAndKey"), y = S.get("useSendMtan"), { t: p } = h(), b = ye(null), { control: v, setError: j, clearErrors: _, setValue: I } = f(), { isLoading: k, data: O } = g({
    group: "ContactVerificationKey",
    key: "SmsKeyDuration"
  }), C = G(
    () => (l == null ? void 0 : l.query) ?? y,
    [l == null ? void 0 : l.query, y]
  ), R = G(
    () => (l == null ? void 0 : l.body) ?? {
      contactId: o,
      templateMetadataKey: "GeneralMTan"
    },
    [l == null ? void 0 : l.body, o]
  ), { isFetching: P, refetch: M } = C({
    body: R,
    enabled: l ? !!O : !!O && !!o,
    onSuccess: (T) => {
      var Y;
      (Y = b.current) == null || Y.runTimer(), _(Ot), I(Ot, "");
      const E = typeof T == "string" ? T : T == null ? void 0 : T.generatedSessionId;
      r(E), i && i(T);
    },
    onError: (T) => {
      c ? c(T) : j(Ot, {
        type: "custom",
        message: p("error.technical-error1")
      });
    }
  }), D = pe(() => {
    M();
  }, [M]), B = e || P || k, J = G(
    () => A("flex flex-col items-center gap-4", {
      "bg-secondary-200 p-4 rounded-lg": !!a
    }),
    [a]
  ), ee = G(
    () => A("flex flex-col gap-1 max-w-[470px] mx-auto", s),
    [s]
  );
  return /* @__PURE__ */ t.jsxs("div", { className: ee, children: [
    /* @__PURE__ */ t.jsx(Ee, { children: /* @__PURE__ */ t.jsxs(Xe, { className: "flex flex-col items-center gap-6", children: [
      /* @__PURE__ */ t.jsxs("div", { className: "space-y-2", children: [
        /* @__PURE__ */ t.jsx(w, { fontWeight: "bold", fontSize: "lg", textAlign: "center", children: p(n.subheader) }),
        /* @__PURE__ */ t.jsx(
          cl,
          {
            timerValue: O,
            ref: b,
            setExpiredError: () => j(Ot, {
              type: "custom",
              message: p("error.mtan.mtan-expired")
            })
          }
        )
      ] }),
      /* @__PURE__ */ t.jsxs("div", { className: J, children: [
        a && /* @__PURE__ */ t.jsx(w, { fontWeight: "bold", fontSize: "lg", textAlign: "center", children: a }),
        /* @__PURE__ */ t.jsx(me, { fontSize: "sm", children: p(n.text1) }),
        /* @__PURE__ */ t.jsx(
          ke,
          {
            control: v,
            name: Ot,
            render: ({ field: { onChange: T }, fieldState: { error: E } }) => /* @__PURE__ */ t.jsx(
              pi,
              {
                onChange: T,
                error: E,
                inputLength: d,
                isLoading: B,
                type: x
              }
            )
          }
        ),
        /* @__PURE__ */ t.jsx(
          "button",
          {
            name: "update-mtan",
            "aria-label": p("button.new-mtan"),
            type: "button",
            tabIndex: 0,
            onClick: D,
            className: "flex items-center gap-2 my-2 ml-auto cursor-pointer",
            children: B ? /* @__PURE__ */ t.jsx(fe, { width: 60, height: 6 }) : /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
              /* @__PURE__ */ t.jsx(Z, { name: F.update, color: "var(--accent-default)" }),
              /* @__PURE__ */ t.jsx(w, { fontWeight: "bold", className: "text-[--accent-default]", children: p("button.new-mtan") })
            ] })
          }
        )
      ] })
    ] }) }),
    u
  ] });
}, bc = (e, n) => ft().shape({
  [Ot]: Je().required(e("error.mtan.cannot-be-empty")).min(n || 6, e("error.mtan.cannot-be-empty")).max(n || 6, e("error.mtan.cannot-be-empty"))
});
export {
  Ul as AmountsSavingStep,
  ql as AmountsStepPayOut,
  Vl as AmountsStepTopUp,
  Xl as BulletList,
  _t as Button,
  Ee as Card,
  en as Checkbox,
  jr as ClientIdService,
  Kl as ClientsOverviewInvestment,
  Yo as Collapse,
  Vo as Column,
  Ur as ConfirmModal,
  fc as ConfirmationProductCard,
  rc as ContactInvestOverview,
  Wn as DonutDynamic,
  $l as DownloadLink,
  _1 as DynamicSaving,
  Bl as EmptyWizard,
  $e as ErrorMessage,
  u1 as ErrorModal,
  gn as ExAnte,
  I1 as ExecutionDayInfo,
  tc as ExposureWidget,
  zo as Fundings,
  bl as GeneralError,
  c1 as GroupDepotBage,
  Nl as GroupQuestionnaireBudgetarySurplusHeader,
  Sl as GroupQuestionnaireCurrentPropertyHeader,
  Cl as GroupQuestionnaireEsgPreferenceArrayIndex,
  _l as GroupQuestionnaireFinancialSituationGroupArrayIndex,
  yl as GroupQuestionnaireRiskWillingnessGroupArrayIndex,
  Le as Heading,
  De as Hint,
  X as ICON_SIZE_NAMES,
  Z as Icon,
  Ml as IconButton,
  D1 as IconCardButton,
  zr as IconLink,
  F as IconNames,
  Ol as IconText,
  xc as InvestmentPositions,
  dc as InvestmentSummaryTitle,
  V1 as ListItem,
  l1 as Loader,
  vc as Mtan,
  pi as MtanInput,
  wi as MultiCheckbox,
  Be as MultiStepButtons,
  Dl as MultiStepWizard,
  me as MultilineText,
  pt as NumberInput,
  nc as Orderbook,
  Gl as OverviewPayOut,
  Yl as OverviewSavingStep,
  Zl as OverviewStepTopUp,
  lc as OverviewSwap,
  Rt as PLACEMENTS_TYPES,
  Kt as POPOVER_SIZE_TYPES,
  We as PORTFOLIO_TYPE_RADIO,
  Wl as PersonalDetailsFields,
  Pl as PhoneCodeInput,
  Gn as PhoneCodeInputNames,
  mc as PlanSelection,
  At as Popover,
  Ql as PortfolioManagement,
  Jl as PortfolioOverviewWidget,
  ec as PortfolioTerminationOverview,
  Nt as Preloader,
  p1 as ProgressBar,
  Rn as QUARTER_PLANS,
  wl as QUARTER_PLANS_MULTIPLIERS,
  jl as RECURRENCE_TYPE_IDS,
  kr as RECURRENCE_TYPE_IDS_DISPLAY,
  Gr as RadioButton,
  t1 as RadioButtonGroup,
  Xr as RadioGroupIcon,
  Zo as Row,
  Oe as SAVING_ACTIONS,
  st as SELECTION_SWAP_RADIO,
  k1 as SavingAmount,
  gc as SavingGepCheckRequired,
  uc as SavingTimeLimit,
  Ct as Select,
  oc as SelectionSwap,
  Xe as StepLayout,
  ac as SwapTopics,
  Ve as TIME_LINE_FORM_NAMES,
  w as Text,
  Rl as TextArea,
  a1 as TextInput,
  Yn as ToggleCheckbox,
  pc as TopUpGepCheckRequired,
  Ne as TopicSwapInputNames,
  Qr as TopicSwapStepNames,
  on as amountPayOutInputName,
  ut as amountTopUpInputName,
  gt as amountsSavingInputNames,
  $r as amountsSavingInputNamesSecond,
  Il as amountsSavingSchema,
  Mo as annualIncreaseValidation,
  mt as budgetarySurplusRanges,
  ko as budgetarySurplusValidation,
  Dn as calculateExecutionDay,
  El as calculateIfBudgetarySurplusSameRangeOrHigher,
  Fl as calculateIfCurrentPropertySameRangeOrHigher,
  Rr as calculateIsIncreaseLessExecutionDay,
  tl as calculateIsWrongSwapProcessedDate,
  bt as createAmountsFieldNames,
  xt as createDate,
  Qt as createTriggerFields,
  ht as currentPropertyRanges,
  kl as defaultSavingsAmounts,
  K1 as defineSwapErrorMessages,
  vo as executionDayOptions,
  Eo as executionDayValidation,
  Ki as findGermanCodeId,
  Ir as formatDateForBE,
  Ke as germanMonth,
  ue as germanNumber,
  Ll as getBudgetarySurplusRange,
  zl as getCurrentPropertyRange,
  cc as getSwapError,
  No as isBudgetarySurplusMoreTotalSavingAmount,
  Lo as monthlySavingsRateValidation,
  Ot as mtanFieldName,
  bc as mtanValidationSchema,
  ic as overviewTopicSwapSchema,
  de as parseReplace,
  Hl as payOutAmountSchema,
  Tl as primaryPhoneValidationWithGemanCodeCase,
  bo as quarterSavingsPlanOptions,
  $o as quarterSavingsPlanValidation,
  wr as savingPlanSelectionFields,
  hc as savingPlanSelectionSchema,
  sc as selectionSwapSchema,
  S as sharedContainer,
  Io as startIncreaseMonthValidation,
  Co as startIncreaseYearOptions,
  So as startIncreaseYearValidation,
  Oo as timeLimitMonthValidation,
  Po as timeLimitYearValidation,
  Al as topUpAmountSchema
};
